import React, { useState, useEffect } from 'react';
import { CheckCircle, Send, Calendar, X, Plus, Activity, BookOpen, Target, ChevronDown, Sparkles, Brain, Download, Edit3, Trash2, Users, Printer } from 'lucide-react';
import { getAuth } from 'firebase/auth';
import { db } from '../firebase';
import {
  RUTIN_SECENEKLERI,
  mufredatVerisi,
  kaynaklarHavuzu
} from '../data/coaching/coachingCatalog';
import { collection, query, where, onSnapshot, doc, deleteDoc } from 'firebase/firestore';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, LineChart, Line, Legend, ScatterChart, Scatter, ZAxis, ReferenceLine, AreaChart, Area } from 'recharts';
import SmartPlanBuilder from './SmartPlanBuilder';

const HAFTA_SECENEKLERI = [8, 12, 16, 20, 24, 28, 32, 36];
const ALAN_SECENEKLERI = ['Sayısal', 'Eşit Ağırlık', 'Sözel', 'LGS (Ortak Alan)'];
const SINAV_SECENEKLERI = ['Sadece TYT', 'Sadece AYT', 'TYT + AYT (Önce TYT)', 'TYT + AYT (Eşzamanlı)', 'LGS'];const SINIF_SECENEKLERI = ['7. Sınıf', '8. Sınıf', '9. Sınıf', '10. Sınıf', '11. Sınıf', '12. Sınıf', 'Mezun'];
const GOREV_SECENEKLERI = [2, 3, 4];


// ============================================================
// FEATURE FLAG — AKILLI PLAN ROBOTU
// ============================================================
//
// Motor geliştirme aşamasında.
// false → kullanıcı erişemez, "Çok Yakında" görünür.
// true  → kart ve SmartPlanBuilder tekrar aktif olur.
//
const SMART_PLAN_ALLOWED_HOSTS = [
  'localhost',
  '127.0.0.1',
  'rehber360.net',
  'www.rehber360.net',
  'rehber360-e0808.web.app'
];


const SMART_PLAN_ROBOT_ENABLED =
  SMART_PLAN_ALLOWED_HOSTS.includes(
    window.location.hostname
  );


const GUNLER = [  "Pazartesi",
  "Salı",
  "Çarşamba",
  "Perşembe",
  "Cuma",
  "Cumartesi",
  "Pazar"
];

// 🚀 YENİ: Gölge Rakip (Benchmarking) Hedef Profilleri (Gerçek YÖKATLAS Verileri - Son Giren Kişi)
const HEDEF_PROFILLER = {
  "Tıp Fakültesi (Sakarya Üni)": { 
      "TYT - Türkçe": 85, "TYT - Matematik": 61, "TYT - Geometri": 61, "TYT - Fen": 94, "TYT - Fizik": 94, "TYT - Kimya": 94, "TYT - Biyoloji": 94, "TYT - Sosyal": 69, "TYT - Tarih": 69, "TYT - Coğrafya": 69, "TYT - Felsefe": 69, "TYT - Din Kültürü": 69,
      "AYT - Matematik": 83, "AYT - Geometri": 83, "AYT - Fen": 91, "AYT - Fizik": 100, "AYT - Kimya": 71, "AYT - Biyoloji": 100 
  },
  "Diş Hekimliği (Pamukkale Üni)": { 
      "TYT - Türkçe": 78, "TYT - Matematik": 73, "TYT - Geometri": 73, "TYT - Fen": 94, "TYT - Fizik": 94, "TYT - Kimya": 94, "TYT - Biyoloji": 94, "TYT - Sosyal": 69, "TYT - Tarih": 69, "TYT - Coğrafya": 69, "TYT - Felsefe": 69, "TYT - Din Kültürü": 69,
      "AYT - Matematik": 66, "AYT - Geometri": 66, "AYT - Fen": 84, "AYT - Fizik": 82, "AYT - Kimya": 81, "AYT - Biyoloji": 90 
  },
  "Bilgisayar Müh. (Pamukkale Üni)": { 
      "TYT - Türkçe": 71, "TYT - Matematik": 43, "TYT - Geometri": 43, "TYT - Fen": 48, "TYT - Fizik": 48, "TYT - Kimya": 48, "TYT - Biyoloji": 48, "TYT - Sosyal": 71, "TYT - Tarih": 71, "TYT - Coğrafya": 71, "TYT - Felsefe": 71, "TYT - Din Kültürü": 71,
      "AYT - Matematik": 59, "AYT - Geometri": 59, "AYT - Fen": 67, "AYT - Fizik": 54, "AYT - Kimya": 81, "AYT - Biyoloji": 67 
  },
  "Psikoloji (Pamukkale Üni)": { 
      "TYT - Türkçe": 76, "TYT - Matematik": 48, "TYT - Geometri": 48, "TYT - Fen": 28, "TYT - Fizik": 28, "TYT - Kimya": 28, "TYT - Biyoloji": 28, "TYT - Sosyal": 56, "TYT - Tarih": 56, "TYT - Coğrafya": 56, "TYT - Felsefe": 56, "TYT - Din Kültürü": 56,
      "AYT - Matematik": 25, "AYT - Geometri": 25, "AYT - Edebiyat": 74, "AYT - Tarih-1": 75, "AYT - Coğrafya-1": 42 
  },
  "Okul Öncesi Öğrt. (Balıkesir Üni)": {
      "TYT - Türkçe": 73, "TYT - Matematik": 19, "TYT - Geometri": 19, "TYT - Fen": 3, "TYT - Fizik": 3, "TYT - Kimya": 3, "TYT - Biyoloji": 3, "TYT - Sosyal": 69, "TYT - Tarih": 69, "TYT - Coğrafya": 69, "TYT - Felsefe": 69, "TYT - Din Kültürü": 69,
      "AYT - Edebiyat": 74, "AYT - Tarih-1": 100, "AYT - Coğrafya-1": 63, "AYT - Tarih-2": 27, "AYT - Coğrafya-2": 45, "AYT - Felsefe": 48, "AYT - Din Kültürü": 100
  },
  "İngilizce Öğrt. (Afyon Kocatepe)": {
      "TYT - Türkçe": 72, "TYT - Matematik": 21, "TYT - Geometri": 21, "TYT - Fen": 19, "TYT - Fizik": 19, "TYT - Kimya": 19, "TYT - Biyoloji": 19, "TYT - Sosyal": 56, "TYT - Tarih": 56, "TYT - Coğrafya": 56, "TYT - Felsefe": 56, "TYT - Din Kültürü": 56,
      "Yabancı Dil": 84
  },
  "LGS - Fen Lisesi (%0 - %2.5)": {
      "LGS - Türkçe": 95, "LGS - Matematik": 85, "LGS - Fen Bilimleri": 95, "LGS - İnkılap Tarihi": 100, "LGS - İngilizce": 100, "LGS - Din Kültürü": 100
  },
  "LGS - Nitelikli Anadolu Lisesi (%2.5 - %7.5)": {
      "LGS - Türkçe": 85, "LGS - Matematik": 65, "LGS - Fen Bilimleri": 85, "LGS - İnkılap Tarihi": 90, "LGS - İngilizce": 90, "LGS - Din Kültürü": 90
  },
  "LGS - Proje / Sosyal Bil. / Meslek Lisesi (%7.5 - %18)": {
      "LGS - Türkçe": 75, "LGS - Matematik": 45, "LGS - Fen Bilimleri": 70, "LGS - İnkılap Tarihi": 80, "LGS - İngilizce": 80, "LGS - Din Kültürü": 85
  }
};



const CoachingPanel = ({
  user,
  submissions = [],
  onAssign,
  academicYear = '2026-2027'
}) => { 
  const [targetNo, setTargetNo] = useState(''); 
  
  // 🖨️ REHBER360 BAĞIMSIZ YAZDIRMA (PDF) MOTORU
  const handlePrint = (printAreaId) => {
    const content = document.getElementById(printAreaId)?.innerHTML;
    if (!content) return;
    
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '1024px';
    iframe.style.height = '100%';
    iframe.style.zIndex = '-1';
    iframe.style.opacity = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);
    
    const doc = iframe.contentWindow.document;
    
    let stylesHTML = '';
    document.querySelectorAll('style, link[rel="stylesheet"]').forEach(el => {
        stylesHTML += el.outerHTML;
    });

    doc.open();
    doc.write(`
        <html>
        <head>
            <title>PDR Öğrenci Karnesi</title>
            ${stylesHTML}
            <style>
                @media print { 
                    @page { size: A4 portrait; margin: 10mm; } 
                    body { font-family: 'Segoe UI', system-ui, sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; background: white; color: black; } 
                    .no-print { display: none !important; }
                    .break-inside-avoid { page-break-inside: avoid !important; break-inside: avoid !important; display: block; }
                    
                    /* 🚀 YENİ: Tablo ve Grafiklerin PDF'te Kusursuz Çıkmasını Sağlayan Motor */
                    .overflow-x-auto { overflow: visible !important; }
                    table { width: 100% !important; border-collapse: collapse !important; }
                    th, td { padding: 6px 2px !important; font-size: 8px !important; white-space: normal !important; text-align: center !important; }
                    th { font-size: 7px !important; }
                    
                    /* 🚀 YENİ: Tarayıcının Grafikleri Alt Alta Atmasını Yasaklayan Kesin Kalkan */
                    .print-force-row { display: flex !important; flex-direction: row !important; flex-wrap: nowrap !important; justify-content: space-between !important; width: 100% !important; }
                    .print-force-half { width: 49% !important; flex: 0 0 49% !important; }
                    
                    /* 🚀 YENİ: Matrisi Siyah Mürekkepten Kurtaran Kesin Kalkan */
                    .pdf-matrix-box { background-color: #ffffff !important; border: 1px solid #e2e8f0 !important; box-shadow: none !important; }
                    .pdf-matrix-title { color: #334155 !important; }
                    .pdf-matrix-desc { color: #64748b !important; }
                }
            </style>
        </head>
        <body class="bg-white text-black">
            <div class="p-4">${content}</div>
        </body>
        </html>
    `);
    doc.close();
    
    setTimeout(() => { 
        if (iframe.contentWindow) {
            iframe.contentWindow.focus(); 
            iframe.contentWindow.onafterprint = () => {
                if (document.body.contains(iframe)) document.body.removeChild(iframe);
            };
            iframe.contentWindow.print(); 
            setTimeout(() => {
                if (document.body.contains(iframe)) document.body.removeChild(iframe); 
            }, 60000);
        }
    }, 500);
    };


// ============================================================
// AKILLI PLAN ARŞİVİ — A4 LANDSCAPE YAZDIRMA MOTORU
// ============================================================
//
// ÖNEMLİ:
//
// Bu motor yalnızca Program Arşivi'ndeki smart_plan
// kayıtları için kullanılır.
//
// Genel handlePrint(), Manuel Plan ve AI Makro Plan
// yazdırma davranışlarına dokunmaz.
// ============================================================

const handleSmartArchivePrint =
  () => {

    const printArea =
      document.getElementById(
        'saved-plan-print-area'
      );


    if (!printArea) {
      return;
    }


    const content =
      printArea.innerHTML;


    const iframe =
      document.createElement(
        'iframe'
      );


    iframe.style.position =
      'fixed';

    iframe.style.right =
      '0';

    iframe.style.bottom =
      '0';

    iframe.style.width =
      '0';

    iframe.style.height =
      '0';

    iframe.style.border =
      '0';


    document.body.appendChild(
      iframe
    );


    const printDocument =
      iframe.contentWindow
        ?.document;


    if (!printDocument) {

      document.body.removeChild(
        iframe
      );

      return;
    }


    let stylesHTML = '';


    document
      .querySelectorAll(
        'style, link[rel="stylesheet"]'
      )
      .forEach(
        element => {

          stylesHTML +=
            element.outerHTML;
        }
      );


    printDocument.open();


    printDocument.write(`
      <!DOCTYPE html>

      <html lang="tr">

        <head>

          <meta charset="UTF-8" />

          <title>
            Rehber360 Akıllı Çalışma Planı
          </title>

          ${stylesHTML}

          <style>

            * {
              box-sizing: border-box;
            }


            @page {
              size: A4 landscape;
              margin: 8mm;
            }


            body {
              margin: 0;

              background:
                #ffffff !important;

              color:
                #0f172a !important;

              font-family:
                Arial,
                Helvetica,
                sans-serif;

              -webkit-print-color-adjust:
                exact;

              print-color-adjust:
                exact;
            }


            /*
             * Arşivin ekrandaki genel özetini ve
             * eski ortak PDF başlığını basmıyoruz.
             *
             * Her hafta kendi öğrenci bilgi satırını
             * taşıyacak.
             */

            .archive-generic-print-header,
            .archive-smart-summary {
              display:
                none !important;
            }


            /*
             * HER HAFTA = AYRI A4 SAYFA
             */

            .archive-smart-week {
              width:
                100% !important;

              min-height:
                185mm;

              position:
                relative;

              padding:
                0 0 10mm 0 !important;

              margin:
                0 !important;

              border:
                0 !important;

              border-radius:
                0 !important;

              box-shadow:
                none !important;

              overflow:
                visible !important;

              background:
                #ffffff !important;

              page-break-after:
                always;

              break-after:
                page;
            }


            .archive-smart-week:last-child {
              page-break-after:
                auto;

              break-after:
                auto;
            }


            /*
             * HAFTA BAŞLIĞI
             */

            .archive-smart-week-header {
              display:
                flex !important;

              align-items:
                center !important;

              justify-content:
                space-between !important;

              background:
                #0f172a !important;

              color:
                #ffffff !important;

              border:
                0 !important;

              border-radius:
                10px !important;

              padding:
                12px 16px !important;

              margin:
                0 !important;
            }


            .archive-smart-week-header p {
              color:
                #c7d2fe !important;

              font-size:
                8px !important;
            }


            .archive-smart-week-header h4 {
              color:
                #ffffff !important;

              font-size:
                20px !important;

              margin-top:
                3px !important;
            }


            .archive-smart-week-header > span {
              color:
                #cbd5e1 !important;

              background:
                transparent !important;

              border:
                0 !important;

              font-size:
                10px !important;

              padding:
                0 !important;
            }


            /*
             * ÖĞRENCİ / SINAV / HEDEF / STRATEJİ
             */

            .archive-smart-print-info {
              display:
                grid !important;

              grid-template-columns:
                repeat(
                  4,
                  minmax(0, 1fr)
                );

              gap:
                8px;

              margin:
                10px 0;
            }


            .archive-smart-print-info > div {
              border:
                1px solid #e2e8f0;

              border-radius:
                8px;

              padding:
                7px 9px;

              background:
                #f8fafc;
            }


            .archive-smart-print-info span {
              display:
                block;

              color:
                #64748b;

              font-size:
                8px;

              margin-bottom:
                3px;
            }


            .archive-smart-print-info strong {
              display:
                block;

              color:
                #0f172a;

              font-size:
                10px;
            }


            /*
             * GÜN GRID
             */

            .archive-smart-days {
              display:
                grid !important;

              grid-template-columns:
                repeat(
                  3,
                  minmax(0, 1fr)
                ) !important;

              gap:
                8px !important;

              padding:
                0 !important;

              background:
                transparent !important;

              align-items:
                start;
            }


            /* 1 gün */

            .archive-print-days-1
            .archive-smart-days {
              grid-template-columns:
                minmax(0, 1fr)
                !important;
            }


            /* 2 gün */

            .archive-print-days-2
            .archive-smart-days {
              grid-template-columns:
                repeat(
                  2,
                  minmax(0, 1fr)
                ) !important;
            }


            /* 3 gün */

            .archive-print-days-3
            .archive-smart-days {
              grid-template-columns:
                repeat(
                  3,
                  minmax(0, 1fr)
                ) !important;
            }


            /* 4 gün → 2 + 2 */

            .archive-print-days-4
            .archive-smart-days {
              grid-template-columns:
                repeat(
                  2,
                  minmax(0, 1fr)
                ) !important;
            }


            /*
             * 5 gün → 3 + 2
             */

            .archive-print-days-5
            .archive-smart-days {
              grid-template-columns:
                repeat(
                  6,
                  minmax(0, 1fr)
                ) !important;
            }


            .archive-print-days-5
            .archive-smart-day:nth-child(-n + 3) {
              grid-column:
                span 2;
            }


            .archive-print-days-5
            .archive-smart-day:nth-child(n + 4) {
              grid-column:
                span 3;
            }


            /*
             * 6 gün → 3 + 3
             */

            .archive-print-days-6
            .archive-smart-days {
              grid-template-columns:
                repeat(
                  3,
                  minmax(0, 1fr)
                ) !important;
            }


            /*
             * 7 gün → 4 + 3
             */

            .archive-print-days-7
            .archive-smart-days {
              grid-template-columns:
                repeat(
                  12,
                  minmax(0, 1fr)
                ) !important;
            }


            .archive-print-days-7
            .archive-smart-day:nth-child(-n + 4) {
              grid-column:
                span 3;
            }


            .archive-print-days-7
            .archive-smart-day:nth-child(n + 5) {
              grid-column:
                span 4;
            }


            /*
             * GÜN KARTI
             */

            .archive-smart-day {
              border:
                1px solid #cbd5e1 !important;

              border-radius:
                10px !important;

              padding:
                9px !important;

              background:
                #ffffff !important;

              box-shadow:
                none !important;

              overflow:
                visible !important;

              break-inside:
                avoid;
            }


            .archive-smart-day-header {
              display:
                flex !important;

              align-items:
                flex-start !important;

              justify-content:
                space-between !important;

              border-bottom:
                1px solid #e2e8f0 !important;

              padding:
                0 0 7px 0 !important;

              margin:
                0 0 7px 0 !important;

              background:
                #ffffff !important;
            }


            .archive-smart-day-header h5 {
              color:
                #0f172a !important;

              font-size:
                11px !important;
            }


            .archive-smart-day-header p {
              color:
                #94a3b8 !important;

              font-size:
                8px !important;
            }


            .archive-smart-day-header > span {
              background:
                #f1f5f9 !important;

              color:
                #475569 !important;

              border:
                0 !important;

              border-radius:
                999px !important;

              padding:
                4px 7px !important;

              font-size:
                8px !important;
            }


            .archive-smart-tasks {
  padding:
    0 !important;

  display:
    grid !important;

  gap:
    6px !important;
}


/*
 * JSX tarafındaki Tailwind space-y-2.5
 * görevler arasına ayrıca margin ekliyordu.
 *
 * Print'te boşluğu yalnız grid gap yönetir.
 */

.archive-smart-tasks > * {
  margin-top:
    0 !important;

  margin-bottom:
    0 !important;
}


.archive-smart-assessment-groups {
  display:
    grid !important;

  gap:
    2px !important;

  margin-top:
    5px !important;
}


.archive-smart-assessment-groups > * {
  margin-top:
    0 !important;

  margin-bottom:
    0 !important;
}


            /*
             * GÖREV KARTLARI
             */

            .archive-smart-task {
              border:
                1px solid #dbeafe !important;

              border-left:
                4px solid #6366f1 !important;

              background:
                #f8fafc !important;

              border-radius:
                8px !important;

              padding:
                7px 8px !important;

              break-inside:
                avoid;

              box-shadow:
                none !important;
            }


            .archive-smart-task[data-task-type="practice"] {
              border-left-color:
                #2563eb !important;
            }

            .archive-smart-task[data-task-type="review"] {
              border-left-color:
                #7c3aed !important;
            }

            .archive-smart-task[data-task-type="mixed_practice"] {
              border-left-color:
                #0891b2 !important;
            }

            .archive-smart-task[data-task-type="topic_scan"] {
              border-left-color:
                #0f766e !important;
            }

            .archive-smart-task[data-task-type="weekly_scan"] {
              border-left-color:
                #0284c7 !important;
            }

            .archive-smart-task[data-task-type="branch_mock"] {
              border-left-color:
                #d97706 !important;
            }

            .archive-smart-task[data-task-type="full_mock"] {
              border-left-color:
                #ea580c !important;
            }

            .archive-smart-task[data-task-type="mock_analysis"] {
              border-left-color:
                #e11d48 !important;
            }

            .archive-smart-task[data-task-type="buffer"] {
              border-left-color:
                #64748b !important;
            }

            .archive-smart-task[data-task-type="routine"] {
              border-left-color:
                #059669 !important;
            }


            .archive-smart-assessment {
              background:
                #ffffff !important;

              border:
                1px solid #dbeafe !important;

              border-radius:
                6px !important;

              margin-top:
                5px !important;

              padding:
                5px 6px !important;
            }


            /*
             * COMPACT
             */

            .archive-print-density-compact
            .archive-smart-week-header {
              padding:
                9px 13px !important;
            }


            .archive-print-density-compact
            .archive-smart-week-header h4 {
              font-size:
                18px !important;
            }


            .archive-print-density-compact
            .archive-smart-print-info {
              gap:
                6px;

              margin:
                7px 0;
            }


            .archive-print-density-compact
            .archive-smart-day {
              padding:
                7px !important;
            }


            .archive-print-density-compact
            .archive-smart-days {
              gap:
                6px !important;
            }


            .archive-print-density-compact
            .archive-smart-tasks {
              gap:
                4px !important;
            }


            .archive-print-density-compact
            .archive-smart-task {
              padding:
                5px 6px !important;
            }


            .archive-print-density-compact
.archive-smart-day-header {
  padding-bottom:
    5px !important;

  margin-bottom:
    5px !important;
}


.archive-print-density-compact
.archive-smart-day-header h5 {
  font-size:
    10px !important;
}


.archive-print-density-compact
.archive-smart-day-header p {
  font-size:
    7px !important;

  margin-top:
    1px !important;
}


.archive-print-density-compact
.archive-smart-day-header > span {
  padding:
    3px 6px !important;

  font-size:
    7px !important;
}


.archive-print-density-compact
.archive-smart-task-top {
  gap:
    4px !important;

  font-size:
    7px !important;
}


.archive-print-density-compact
.archive-smart-task-type {
  gap:
    4px !important;
}


.archive-print-density-compact
.archive-smart-checkbox {
  width:
    14px !important;

  height:
    14px !important;

  font-size:
    8px !important;

  border-radius:
    4px !important;
}


.archive-print-density-compact
.archive-smart-task-label,
.archive-print-density-compact
.archive-smart-task-duration {
  font-size:
    7px !important;
}


.archive-print-density-compact
.archive-smart-task-subject {
  margin-top:
    3px !important;

  font-size:
    9px !important;
}


.archive-print-density-compact
.archive-smart-task-topic {
  margin-top:
    2px !important;

  font-size:
    8px !important;

  line-height:
    1.2 !important;
}


.archive-print-density-compact
.archive-smart-task-meta {
  margin-top:
    3px !important;

  font-size:
    6.7px !important;

  line-height:
    1.2 !important;
}


.archive-print-density-compact
.archive-smart-assessment {
  margin-top:
    4px !important;

  padding:
    4px 5px !important;
}


.archive-print-density-compact
.archive-smart-assessment-title {
  font-size:
    6.5px !important;
}


.archive-print-density-compact
.archive-smart-assessment-groups {
  gap:
    1px !important;

  margin-top:
    2px !important;
}


.archive-print-density-compact
.archive-smart-assessment-subject {
  font-size:
    7px !important;

  line-height:
    1.15 !important;
}


.archive-print-density-compact
.archive-smart-assessment-topics {
  margin-top:
    1px !important;

  font-size:
    6.5px !important;

  line-height:
    1.15 !important;
}


            /*
             * DENSE
             */

            .archive-print-density-dense
            .archive-smart-week-header {
              padding:
                8px 12px !important;
            }


            .archive-print-density-dense
            .archive-smart-week-header h4 {
              font-size:
                17px !important;
            }


            .archive-print-density-dense
            .archive-smart-print-info {
              gap:
                5px;

              margin:
                6px 0;
            }


            .archive-print-density-dense
            .archive-smart-print-info > div {
              padding:
                4px 6px;
            }


            .archive-print-density-dense
            .archive-smart-days {
              gap:
                5px !important;
            }


            .archive-print-density-dense
            .archive-smart-day {
              padding:
                6px !important;
            }


            .archive-print-density-dense
            .archive-smart-tasks {
              gap:
                3px !important;
            }


            .archive-print-density-dense
            .archive-smart-task {
              padding:
                4px 5px !important;

              border-left-width:
                3px !important;
            }
 

            .archive-print-density-dense
.archive-smart-day-header {
  padding-bottom:
    4px !important;

  margin-bottom:
    4px !important;
}


.archive-print-density-dense
.archive-smart-day-header h5 {
  font-size:
    9px !important;
}


.archive-print-density-dense
.archive-smart-day-header p {
  margin-top:
    1px !important;

  font-size:
    6.5px !important;
}


.archive-print-density-dense
.archive-smart-day-header > span {
  padding:
    2px 5px !important;

  font-size:
    6.5px !important;
}


.archive-print-density-dense
.archive-smart-task-top {
  gap:
    3px !important;
}


.archive-print-density-dense
.archive-smart-task-type {
  gap:
    3px !important;
}


.archive-print-density-dense
.archive-smart-checkbox {
  width:
    13px !important;

  height:
    13px !important;

  font-size:
    7px !important;

  border-radius:
    3px !important;
}


.archive-print-density-dense
.archive-smart-task-label,
.archive-print-density-dense
.archive-smart-task-duration {
  font-size:
    6.7px !important;
}


.archive-print-density-dense
.archive-smart-task-subject {
  margin-top:
    2px !important;

  font-size:
    8.5px !important;
}


.archive-print-density-dense
.archive-smart-task-topic {
  margin-top:
    1px !important;

  font-size:
    7.3px !important;

  line-height:
    1.15 !important;
}


.archive-print-density-dense
.archive-smart-task-meta {
  margin-top:
    2px !important;

  font-size:
    6.2px !important;

  line-height:
    1.15 !important;
}


.archive-print-density-dense
.archive-smart-assessment-title {
  font-size:
    6px !important;
}


.archive-print-density-dense
.archive-smart-assessment-groups {
  gap:
    1px !important;

  margin-top:
    1px !important;
}


.archive-print-density-dense
.archive-smart-assessment-subject {
  font-size:
    6.5px !important;

  line-height:
    1.1 !important;
}


.archive-print-density-dense
.archive-smart-assessment-topics {
  margin-top:
    0 !important;

  font-size:
    6px !important;

  line-height:
    1.1 !important;
}

            .archive-print-density-dense
            .archive-smart-assessment {
              margin-top:
                3px !important;

              padding:
                3px 4px !important;
            }

          </style>

        </head>


        <body>

          ${content}

        </body>

      </html>
    `);


    printDocument.close();


    setTimeout(
      () => {

        iframe.contentWindow
          ?.focus();


        iframe.contentWindow
          ?.print();


        setTimeout(
          () => {

            if (
              document.body.contains(
                iframe
              )
            ) {

              document.body.removeChild(
                iframe
              );
            }

          },
          1000
        );

      },
      350
    );
  };


// ============================================================
// MANUEL HAFTALIK PROGRAM — A4 YAZDIRMA MOTORU
// ============================================================

const handleManualWeekPrint = () => {

  const printableDays =
    GUNLER.map(day => ({
      day,
      tasks:
        Array.isArray(weekData?.[day])
          ? weekData[day]
          : []
    }));


  const totalPrintableTasks =
    printableDays.reduce(
      (total, day) =>
        total + day.tasks.length,
      0
    );


  if (totalPrintableTasks === 0) {
    alert(
      "Yazdırılabilecek görev bulunamadı."
    );
    return;
  }


  const selectedTargetStudent =
    benzersizOgrenciler.find(
      student =>
        String(student.no) ===
        String(targetNo)
    );


  const studentLabel =
    selectedTargetStudent?.label ||
    (
      targetNo
        ? `Öğrenci No: ${targetNo}`
        : 'Öğrenci: ................................................'
    );


  const escapePrintHtml =
    value =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');


  const iframe =
    document.createElement(
      'iframe'
    );


  iframe.style.position =
    'fixed';

  iframe.style.right =
    '0';

  iframe.style.bottom =
    '0';

  iframe.style.width =
    '0';

  iframe.style.height =
    '0';

  iframe.style.border =
    '0';


  document.body.appendChild(
    iframe
  );


  const printDocument =
    iframe.contentWindow?.document;


  if (!printDocument) {

    document.body.removeChild(
      iframe
    );

    return;
  }


  printDocument.open();


  printDocument.write(`
    <!DOCTYPE html>

    <html lang="tr">

      <head>

        <meta charset="UTF-8" />

        <title>
          Rehber360 Haftalık Çalışma Planı
        </title>

        <style>

          * {
            box-sizing: border-box;
          }


          @page {
            size: A4 landscape;
            margin: 8mm;
          }


          body {
            margin: 0;
            color: #0f172a;
            background: #ffffff;

            font-family:
              Arial,
              Helvetica,
              sans-serif;

            -webkit-print-color-adjust:
              exact;

            print-color-adjust:
              exact;
          }


          .page {
            width: 100%;
          }


          .header {
            background: #0f172a;
            color: white;

            border-radius: 10px;

            padding:
              12px 16px;

            display: flex;

            align-items: center;
            justify-content: space-between;

            gap: 15px;
          }


          .brand {
            color: #c7d2fe;

            font-size: 8px;
            font-weight: 800;

            letter-spacing: 1.4px;
          }


          h1 {
            font-size: 19px;

            margin:
              4px 0 0 0;
          }


          .week-badge {
            font-size: 9px;
            font-weight: 800;

            color: #cbd5e1;
          }


          .student-info {
            margin:
              10px 0;

            display: grid;

            grid-template-columns:
              2fr 1fr;

            gap: 8px;
          }


          .info-box {
            border:
              1px solid #e2e8f0;

            border-radius:
              8px;

            background:
              #f8fafc;

            padding:
              8px 10px;
          }


          .info-label {
            color: #64748b;

            font-size: 8px;

            margin-bottom:
              3px;
          }


          .info-value {
            font-size: 10px;
            font-weight: 800;
          }


          .week-grid {
            display: grid;

            grid-template-columns:
              repeat(7, minmax(0, 1fr));

            gap: 5px;

            align-items: stretch;
          }


          .day-card {
            border:
              1px solid #cbd5e1;

            border-radius:
              8px;

            overflow: hidden;

            min-height: 142mm;

            background: white;
          }


          .day-header {
            background: #f1f5f9;

            border-bottom:
              1px solid #cbd5e1;

            padding:
              7px;

            text-align: center;
          }


          .day-header strong {
            display: block;

            font-size: 9px;
          }


          .day-header span {
            display: block;

            margin-top:
              2px;

            color: #94a3b8;

            font-size: 7px;
          }


          .tasks {
            padding: 5px;

            display: grid;

            gap: 5px;
          }


          .task {
            border:
              1px solid #e2e8f0;

            border-left:
              3px solid #6366f1;

            border-radius:
              6px;

            background:
              #f8fafc;

            padding:
              6px;

            font-size:
              7.5px;

            line-height:
              1.35;

            break-inside:
              avoid;
          }


          .task-row {
            display: flex;

            gap: 4px;

            align-items: flex-start;
          }


          .checkbox {
            font-size:
              11px;

            line-height:
              1;

            flex-shrink:
              0;
          }


          .empty {
            padding:
              12px 6px;

            color:
              #94a3b8;

            font-size:
              7.5px;

            font-style:
              italic;

            text-align:
              center;
          }


          .footer {
            margin-top:
              8px;

            border-top:
              1px solid #e2e8f0;

            padding-top:
              6px;

            color:
              #94a3b8;

            font-size:
              7px;

            display: flex;

            justify-content:
              space-between;
          }

        </style>

      </head>


      <body>

        <div class="page">


          <div class="header">

            <div>

              <div class="brand">
                REHBER360 • KOÇLUK VE PLAN
              </div>

              <h1>
                Haftalık Çalışma Planı
              </h1>

            </div>


            <div class="week-badge">
              1 Haftalık Program
            </div>

          </div>


          <div class="student-info">

            <div class="info-box">

              <div class="info-label">
                Öğrenci
              </div>

              <div class="info-value">
                ${escapePrintHtml(
                  studentLabel
                )}
              </div>

            </div>


            <div class="info-box">

              <div class="info-label">
                Haftalık Soru Hedefi
              </div>

              <div class="info-value">

                ${
                  targetGoal
                    ? `${escapePrintHtml(targetGoal)} soru`
                    : 'Belirtilmedi'
                }

              </div>

            </div>

          </div>


          <div class="week-grid">

            ${
              printableDays
                .map(
                  ({ day, tasks }) => `

                    <div class="day-card">

                      <div class="day-header">

                        <strong>
                          ${escapePrintHtml(day)}
                        </strong>

                        <span>
                          ${tasks.length} görev
                        </span>

                      </div>


                      ${
                        tasks.length > 0

                          ? `
                            <div class="tasks">

                              ${
                                tasks
                                  .map(
                                    task => `

                                      <div class="task">

                                        <div class="task-row">

                                          <span class="checkbox">
                                            □
                                          </span>

                                          <span>
                                            ${escapePrintHtml(
                                              task?.text ||
                                              ''
                                            )}
                                          </span>

                                        </div>

                                      </div>

                                    `
                                  )
                                  .join('')
                              }

                            </div>
                          `

                          : `
                            <div class="empty">
                              Görev yok.
                            </div>
                          `
                      }

                    </div>

                  `
                )
                .join('')
            }

          </div>


          <div class="footer">

            <span>
              Rehber360 • Haftalık Çalışma Planı
            </span>

            <span>
              Tamamladığın görevleri kutucuklardan işaretleyebilirsin.
            </span>

          </div>


        </div>

      </body>

    </html>
  `);


  printDocument.close();


  setTimeout(
    () => {

      iframe.contentWindow
        ?.focus();


      iframe.contentWindow
        ?.print();


      setTimeout(
        () => {

          if (
            document.body.contains(
              iframe
            )
          ) {
            document.body.removeChild(
              iframe
            );
          }

        },
        1000
      );

    },
    350
  );
};


 const [
  selectedSavedPlanId,
  setSelectedSavedPlanId
] = useState('');


const [
  aiTargetNo,
  setAiTargetNo
] = useState('');


// ============================================================
// PROGRAM ARŞİVİ V2 — ORTAK PLAN VERİ KATMANI
// ============================================================

const ARCHIVE_PLAN_TYPES =
  new Set([
    'weekly_plan',
    'ai_macro_plan',
    'smart_plan'
  ]);


const SMART_PLAN_STRATEGY_LABELS = {
  baslangic: 'Başlangıç',
  dengeli: 'Dengeli',
  telafi: 'Telafi',
  genel_tekrar: 'Genel Tekrar',
  son_duzluk: 'Son Düzlük',
  deneme_odakli: 'Deneme Odaklı'
};


const getArchivePlanId =
  plan =>
    String(
      plan?.firebaseId ||
      plan?.id ||
      ''
    );


const getArchivePlanTimestamp =
  plan => {

    const createdAt =
      Number(
        plan?.createdAt
      );

    if (
      Number.isFinite(createdAt) &&
      createdAt > 0
    ) {
      return createdAt;
    }


    const timestamp =
      Date.parse(
        plan?.timestamp ||
        ''
      );

    return Number.isFinite(timestamp)
      ? timestamp
      : 0;
  };


const getArchivePlanDateLabel =
  plan => {

    const timestamp =
      getArchivePlanTimestamp(
        plan
      );


    if (!timestamp) {
      return 'Tarih bilinmiyor';
    }


    return new Date(
      timestamp
    ).toLocaleDateString(
      'tr-TR'
    );
  };


const getArchivePlanLabel =
  plan => {

    const dateLabel =
      getArchivePlanDateLabel(
        plan
      );


    if (
      plan?.testId ===
      'ai_macro_plan'
    ) {

      const weeks =
        plan
          ?.answers
          ?.parametreler
          ?.hafta;


      return [
        dateLabel,
        'AI Makro Plan',
        weeks
          ? `${weeks} Hafta`
          : null
      ]
        .filter(Boolean)
        .join(' • ');
    }


    if (
      plan?.testId ===
      'weekly_plan'
    ) {

      return [
        dateLabel,
        'Haftalık Manuel Plan'
      ].join(' • ');
    }


    if (
      plan?.testId ===
      'smart_plan'
    ) {

      const weeks =
        plan
          ?.answers
          ?.weeks;


      const strategyId =
        plan
          ?.answers
          ?.strategyId;


      const strategyLabel =
        SMART_PLAN_STRATEGY_LABELS[
          strategyId
        ] ||
        strategyId ||
        null;


      return [
        dateLabel,
        'Akıllı Plan',
        weeks
          ? `${weeks} Hafta`
          : null,
        strategyLabel
      ]
        .filter(Boolean)
        .join(' • ');
    }


    return [
      dateLabel,
      plan?.testName ||
        'Plan'
    ].join(' • ');
  };


const archivePlans =
  submissions
    .filter(
      submission =>
        ARCHIVE_PLAN_TYPES.has(
          submission?.testId
        ) &&
        String(
          submission?.studentNo
        ) ===
        String(
          aiTargetNo
        )
    )
    .sort(
      (a, b) =>
        getArchivePlanTimestamp(b) -
        getArchivePlanTimestamp(a)
    );


const selectedArchivePlan =
  archivePlans.find(
    plan =>
      getArchivePlanId(
        plan
      ) ===
      String(
        selectedSavedPlanId
      )
  ) ||
  null;


const latestArchivePlanOfSelectedType =
  selectedArchivePlan
    ? (
        archivePlans.find(
          plan =>
            plan?.testId ===
            selectedArchivePlan?.testId
        ) ||
        null
      )
    : null;


const isSelectedArchivePlanActive =
  Boolean(
    selectedArchivePlan &&
    latestArchivePlanOfSelectedType &&
    getArchivePlanId(
      selectedArchivePlan
    ) ===
      getArchivePlanId(
        latestArchivePlanOfSelectedType
      )
  );


const [targetGoal, setTargetGoal] = useState('');
  const [weekData, setWeekData] = useState({ Pazartesi: [], Salı: [], Çarşamba: [], Perşembe: [], Cuma: [], Cumartesi: [], Pazar: [] }); 
  const [inputs, setInputs] = useState({}); 
  const [saved, setSaved] = useState(false);
  const [taskSelections, setTaskSelections] = useState({});

  const handleAddSmartTask = (day) => {
    const ders = taskSelections[day]?.ders;
    const konu = taskSelections[day]?.konu;
    const soru = taskSelections[day]?.soru; 
    const kaynak = taskSelections[day]?.kaynak; // 🚀 YENİ: Kaynak Seçimi
    if (!ders || !konu) return; 

    let taskText = `${ders}: ${konu}`;
    if (kaynak) taskText += ` (${kaynak})`; // Kaynak varsa parantez içine al
    if (soru) taskText += ` [${soru} Soru]`; // Soru varsa köşeli paranteze al
    
    if (ders === '⭐ GÜNLÜK RUTİNLER') {
       taskText = `Rutin: ${konu}`;
       if (kaynak) taskText += ` (${kaynak})`;
       if (soru) taskText += ` [${soru} Soru]`;
    }

    setWeekData(prev => ({ ...prev, [day]: [...prev[day], { id: Date.now() + Math.random(), text: taskText, completed: false }] }));
    
    setTaskSelections(prev => ({ ...prev, [day]: { ders: '', konu: '', soru: '' } }));
  };

const [isAiModalOpen, setIsAiModalOpen] = useState(false);
  const [aiParams, setAiParams] = useState({
    hafta: 12,
    sinif: '12. Sınıf',
    sinav: 'Sadece TYT',
    alan: 'Sayısal',
    seviye: 'Orta', // 🚀 YENİ: Öğrenci Seviyesi
    gorevSayisi: 3,
    rutin: RUTIN_SECENEKLERI[0],
    manuelRutin: '',
    molaGunu: '',
    zirveGunu: '',
    hedefSoru: ''
  });

  const [isGenerating, setIsGenerating] = useState(false); 
  const [generatedPlanText, setGeneratedPlanText] = useState(''); 
  const [isEditingPlan, setIsEditingPlan] = useState(false);

  const handleSaveAiPlan = async () => {
    if (!aiTargetNo) return alert("Lütfen planı kaydetmek için bir öğrenci numarası girin.");
    
    // 🚀 YENİ: STANDART PAKET KOÇLUK LİMİTİ KONTROLÜ
    if (!user?.isPremium) {
      const KOCLUK_MODULLERI = [
  'gunluk_soru_takibi',
  'deneme_net_takibi',
  'weekly_plan',
  'ai_macro_plan',
  'smart_plan'
];
      const activeStudents = [...new Set(submissions.filter(s => KOCLUK_MODULLERI.includes(s.testId)).map(s => String(s.studentNo)))];
      
      const isExisting = activeStudents.includes(String(aiTargetNo));
      if (!isExisting && activeStudents.length >= 5) {
          alert("⚠️ STANDART PAKET LİMİTİ\n\nÜcretsiz sürümde koçluk modülüne en fazla 5 öğrenci ekleyebilirsiniz.\nSınırsız öğrenci takibi ve tüm özellikler için lütfen Premium'a geçiş yapın.");
          return;
      }
    }

    const planData = {
      id: Date.now(),
      createdAt: Date.now(),
      studentClass: aiParams.sinif,
      studentNo: aiTargetNo, // Saf Öğrenci Numarası
      clinicianCode: user?.refCode || '', // Gerçek Uzman Kodu
      testId: 'ai_macro_plan',
      testName: 'AI Makro Plan',
      answers: { 
        planText: generatedPlanText, 
        parametreler: aiParams,
        hedefSoru: Number(aiParams.hedefSoru) || 1000 // 🚀 YENİ: Veritabanına hedef soru kaydediliyor
      },
      status: 'assigned'
    };
   const saveSuccess =
  await onAssign(
    planData
  );


if (saveSuccess !== true) {

  alert(
    '⚠️ AI planı oluşturuldu ancak öğrenciye kaydedilemedi.\n\n' +
    'İnternet bağlantısını kontrol edip tekrar deneyiniz.'
  );

  return;
}


alert(
  `✅ ${aiParams.hafta} haftalık AI planı, ` +
  `${aiTargetNo} numaralı öğrencinin dosyasına başarıyla kaydedildi!`
);
  };

const [activeTab, setActiveTab] = useState('haftalik_plan');
const [programMode, setProgramMode] = useState('');
const [mainSection, setMainSection] = useState('program');
  const [soruEforTab, setSoruEforTab] = useState('genel');
  const [selectedStudent, setSelectedStudent] = useState(''); // Artık Sadece Numara Tutacak
  const [timeFilter, setTimeFilter] = useState('all'); 
  const [seciliHafta, setSeciliHafta] = useState(''); // 🚀 YENİ: Haftalık Karne Tarih Seçimi
  const [seciliHedefProfil, setSeciliHedefProfil] = useState(''); // 🚀 YENİ: Gölge Rakip Seçimi
const [demoModuAktif, setDemoModuAktif] = useState(false); // 🚀 YENİ: Güvenli Test Verisi Modu
  const [pdfModal, setPdfModal] = useState({ isOpen: false, type: '', student: null, expertNote: '' }); // 🚀 YENİ: Karne PDF Modalı
  const [expertPrintNote, setExpertPrintNote] = useState(''); // 🚀 YENİ: Karneye Basılacak Uzman Notu

  const handleAddTask = (day) => { 
    if (!inputs[day] || inputs[day].trim() === '') return; 
    setWeekData(prev => ({ ...prev, [day]: [...prev[day], { id: Date.now() + Math.random(), text: inputs[day], completed: false }] })); 
    setInputs(prev => ({ ...prev, [day]: '' })); 
  }; 
  
  const handleDeleteTask = (day, taskId) => { 
    setWeekData(prev => ({ ...prev, [day]: prev[day].filter(t => t.id !== taskId) })); 
  }; 
  
  const handleAssign = async () => { 
    if (!targetNo || !targetGoal) return alert("Lütfen öğrenci no ve hedef soru sayısını giriniz."); 
    
    // 🚀 YENİ: STANDART PAKET KOÇLUK LİMİTİ KONTROLÜ
    if (!user?.isPremium) {
      const KOCLUK_MODULLERI = [
  'gunluk_soru_takibi',
  'deneme_net_takibi',
  'weekly_plan',
  'ai_macro_plan',
  'smart_plan'
];
      const activeStudents = [...new Set(submissions.filter(s => KOCLUK_MODULLERI.includes(s.testId)).map(s => String(s.studentNo)))];
      
      const isExisting = activeStudents.includes(String(targetNo));
      if (!isExisting && activeStudents.length >= 5) {
          alert("⚠️ STANDART PAKET LİMİTİ\n\nÜcretsiz sürümde koçluk modülüne en fazla 5 öğrenci ekleyebilirsiniz.\nSınırsız öğrenci takibi ve tüm özellikler için lütfen Premium'a geçiş yapın.");
          return;
      }
    }

    const planData = {
      id: Date.now(), 
      createdAt: Date.now(),
      studentClass: 'Koçluk', 
      studentNo: targetNo, 
      clinicianCode: user?.refCode || '', // Gerçek Uzman Kodu
      testId: 'weekly_plan',
      testName: 'Haftalık Plan', 
      answers: { 
        ...weekData, 
        hedefSoru: Number(targetGoal) 
      }, 
      status: 'assigned' 
    }; 
    const saveSuccess =
  await onAssign(
    planData
  );


if (saveSuccess !== true) {

  setSaved(false);

  alert(
    '⚠️ Haftalık plan oluşturuldu ancak öğrenciye kaydedilemedi.\n\n' +
    'İnternet bağlantısını kontrol edip tekrar deneyiniz.'
  );

  return;
}


setSaved(true);

setTimeout(
  () => setSaved(false),
  3000
);
  };

  const handleGenerateMacroPlan = async () => {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      alert("Oturum süreniz dolmuş veya kullanıcı kimliği alınamadı. Lütfen sisteme tekrar giriş yapın.");
      return;
    }

    const gercekUserId = currentUser.uid;
    setIsGenerating(true);

    const hedeflenenMufredat = Object.keys(mufredatVerisi).reduce((acc, dersAdi) => {
  const isTyt = dersAdi.startsWith("TYT");
  const isAyt = dersAdi.startsWith("AYT");
  const isLgs = dersAdi.startsWith("LGS");

  let aytAlaninaUygun = false;

  if (isAyt) {
    if (aiParams.alan === "Sayısal") {
      aytAlaninaUygun =
        dersAdi.includes("Matematik") ||
        dersAdi.includes("Geometri") ||
        dersAdi.includes("Fizik") ||
        dersAdi.includes("Kimya") ||
        dersAdi.includes("Biyoloji");
    }

    if (aiParams.alan === "Eşit Ağırlık") {
      aytAlaninaUygun =
        dersAdi.includes("Matematik") ||
        dersAdi.includes("Geometri") ||
        dersAdi.includes("Edebiyat") ||
        dersAdi.includes("Tarih") ||
        dersAdi.includes("Coğrafya");
    }

    if (aiParams.alan === "Sözel") {
      aytAlaninaUygun =
        dersAdi.includes("Edebiyat") ||
        dersAdi.includes("Tarih") ||
        dersAdi.includes("Coğrafya") ||
        dersAdi.includes("Psikoloji") ||
        dersAdi.includes("Sosyoloji") ||
        dersAdi.includes("Mantık") ||
        dersAdi.includes("Din Kültürü");
    }
  }

  if (aiParams.sinav === "Sadece TYT" && isTyt) {
    acc[dersAdi] = mufredatVerisi[dersAdi];
  }

  if (aiParams.sinav === "Sadece AYT" && isAyt && aytAlaninaUygun) {
    acc[dersAdi] = mufredatVerisi[dersAdi];
  }

  if (aiParams.sinav.includes("TYT + AYT")) {
    if (isTyt || (isAyt && aytAlaninaUygun)) {
      acc[dersAdi] = mufredatVerisi[dersAdi];
    }
  }

  if (aiParams.sinav === "LGS" && isLgs) {
    acc[dersAdi] = mufredatVerisi[dersAdi];
  }

  return acc;
}, {});

    const aiPayload = {
      parametreler: {
        hafta: aiParams.hafta,
        sinif: aiParams.sinif,
        sinavTuru: aiParams.sinav,
        alan: aiParams.alan,
seviye: aiParams.seviye,
hedefSoru: Number(aiParams.hedefSoru) || 1000,
gunlukMaksBlok: aiParams.gorevSayisi,
        rutin: aiParams.rutin.includes("Manuel") ? aiParams.manuelRutin : aiParams.rutin,
        molaGunu: aiParams.molaGunu || "Yok",
        zirveGunu: aiParams.zirveGunu || "Yok"
      },
      mufredatHavuzu: hedeflenenMufredat
    };

    try {
      const response = await fetch('https://us-central1-rehber360-e0808.cloudfunctions.net/generateMacroPlan', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          parametreler: aiPayload.parametreler, 
          mufredatHavuzu: hedeflenenMufredat,
          userId: gercekUserId 
        })
      });

            const data =
        await response
          .json()
          .catch(() => ({}));

      if (!response.ok) {

        if (
          data?.error ===
          "INSUFFICIENT_CREDITS"
        ) {

          alert(
            "Ücretsiz Makro Plan hakkınız doldu.\n\n" +
            "Ücretsiz üyelikte 5 Yapay Zeka Makro Planı oluşturabilirsiniz. " +
            "Daha fazla kullanım için Premium üyeliğe geçebilirsiniz."
          );

          return;
        }

        throw new Error(
          data?.error ||
          response.statusText ||
          `HTTP ${response.status}`
        );
      }
      
      if (data.result) {
        setGeneratedPlanText(data.result); 
        alert("✅ Makro çalışma planı yapay zeka tarafından başarıyla optimize edildi!");
        setIsAiModalOpen(false);
      } else {
        throw new Error("Yapay zeka boş bir yanıt döndürdü.");
      }

    } catch (error) {
      console.error("🔴 [Rehber360 AI] Detaylı Hata Gözlemi:", error);
      alert(`Plan üretilirken bir hata oluştu. Teknik Detay: ${error.message}`);
    } finally {
      setIsGenerating(false);
    }
  };

  const days = Object.keys(weekData); 

  const simdi = Date.now();
  const yediGun = 7 * 24 * 60 * 60 * 1000;
  const otuzGun = 30 * 24 * 60 * 60 * 1000;

  const filtrelenmisSubmissions = submissions.filter(s => {
     if (timeFilter === 'all') return true;
     const kayıtZamanı = s.createdAt || (typeof s.id === 'number' ? s.id : null);
     if (!kayıtZamanı) return false; 
     if (timeFilter === '7days') return (simdi - kayıtZamanı) <= yediGun;
     if (timeFilter === '30days') return (simdi - kayıtZamanı) <= otuzGun;
     return true;
  });

  const soruVerileri = filtrelenmisSubmissions.filter(s => s.testId === 'gunluk_soru_takibi');
  const denemeVerileri = filtrelenmisSubmissions.filter(s => s.testId === 'deneme_net_takibi');

  const hamSoruVerileri = submissions.filter(s => s.testId === 'gunluk_soru_takibi');
  const hamDenemeVerileri = submissions.filter(s => s.testId === 'deneme_net_takibi');

  // 🧠 YENİ EFSANE MOTOR: Öğrencileri doğrudan ClassManager (E-Okul) veritabanından çekiyoruz!
  const [benzersizOgrenciler, setBenzersizOgrenciler] = useState([]);

    useEffect(() => {
    if (!user || !user.uid) {
      setBenzersizOgrenciler([]);
      return;
    }

    const q = query(
      collection(db, "classes"),
      where("clinicianUid", "==", user.uid)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const loadedStudents = [];

      snapshot.docs.forEach(document => {
        const classData = document.data();

        const classYear =
          classData.academicYear ||
          '2025-2026';

        if (classYear !== academicYear) {
          return;
        }

        if (
          classData.students &&
          Array.isArray(classData.students)
        ) {
          classData.students.forEach(stu => {
            loadedStudents.push({
  no: String(stu.no),
  name: stu.name || '',
  className: classData.name,
  label: `${classData.name} - ${stu.no} (${stu.name})`
});
          });
        }
      });

      loadedStudents.sort((a, b) => {
        const classCompare =
          a.className.localeCompare(
            b.className,
            'tr',
            { numeric: true }
          );

        if (classCompare !== 0) {
          return classCompare;
        }

        return parseInt(a.no) - parseInt(b.no);
      });

      setBenzersizOgrenciler(
        loadedStudents
      );
    });

    return () => unsubscribe();

  }, [user, academicYear]);

  let seciliOgrenciVerisi = [];
  let radarData = []; 
  let konuDetaylari = []; 
  let seciliOgrenciDenemeleri = []; 
  let zamanHirsizlari = []; 
  // 🚀 YENİ: Efor-Verim Matrisi Değişkenleri
  let eforVerimData = [];
  let ortalamaEfor = 0;
  let ortalamaVerim = 0;
  let toplamSoru = 0;
  
// 🚀 YENİ: Momentum ve Projeksiyon Değişkenleri (TYT & AYT & LGS)
  let tytMomentum = 0, tytProjeksiyon = 0, tytSonucMetni = "Yeterli TYT deneme verisi yok (En az 2 deneme girilmelidir).", tytTrend = "notr", sonTytNet = 0;
  let aytMomentum = 0, aytProjeksiyon = 0, aytSonucMetni = "Yeterli AYT deneme verisi yok (En az 2 deneme girilmelidir).", aytTrend = "notr", sonAytNet = 0;
  let lgsMomentum = 0, lgsProjeksiyon = 0, lgsSonucMetni = "Yeterli LGS deneme verisi yok.", lgsTrend = "notr", sonLgsNet = 0;

  // 🗑️ PROGRAM ARŞİVİ — GEÇMİŞ PLAN SİLME MOTORU
const handleDeleteSubmission =
  async (subId) => {

    if (!subId) {
      return;
    }


    const confirmed =
      window.confirm(
        'Bu geçmiş plan kalıcı olarak silinecek.\n\n' +
        'Bu işlem geri alınamaz. Devam etmek istediğinize emin misiniz?'
      );


    if (!confirmed) {
      return;
    }


    try {

      await deleteDoc(
        doc(
          db,
          'submissions',
          String(subId)
        )
      );


      // Silinen kayıt ekranda seçili kalmasın.
      setSelectedSavedPlanId(
        ''
      );


      alert(
        '✅ Geçmiş plan başarıyla silindi.'
      );

    } catch (error) {

      console.error(
        'Plan silme hatası:',
        error
      );

      alert(
        '⚠️ Plan silinirken bir hata oluştu.'
      );
    }
  };
  let toplamDogru = 0;
  let toplamYanlis = 0;
  
// selectedStudent artık saf numara (no) olduğu için filtrelemeler ona göre yapıldı
  // 🚀 YENİ: Hem Manuel hem AI Planının 'hedefSoru' verisini Röntgen için yakalıyoruz.
 const ogrenciPlani = submissions.filter(s => (s.testId === 'weekly_plan' || s.testId === 'ai_macro_plan') && String(s.studentNo) === String(selectedStudent)).sort((a, b) => b.createdAt - a.createdAt)[0];
  const hedefSoru = ogrenciPlani?.answers?.hedefSoru || 1000;
  let basariYuzdesi = 0;
  
  // 🚀 KARNE DEĞİŞKENLERİ (En Dış Kapsam - Tüm sayfa görebilir)
  let haftalikKume = {};
  let mevcutHaftalar = [];
  let gosterilecekHafta = "";
  let aktifHaftaVerisi = null;

  if (selectedStudent) {
    const hamVeriler = soruVerileri.filter(s => String(s.studentNo) === String(selectedStudent));
    
    const dersGruplari = {};
    const konular = {};

    hamVeriler.forEach(sub => {
      const a = sub.answers;
      
if (!dersGruplari[a.ders]) {
        dersGruplari[a.ders] = { name: a.ders, toplam: 0, dogru: 0, yanlis: 0, bos: 0, sure: 0 };
      }
      dersGruplari[a.ders].toplam += Number(a.toplam || 0);
      dersGruplari[a.ders].dogru += Number(a.dogru || 0);
      dersGruplari[a.ders].yanlis += Number(a.yanlis || 0);
      dersGruplari[a.ders].bos += Number(a.bos || 0);
      dersGruplari[a.ders].sure += Number(a.sure || 0); // 🚀 YENİ: Zaman Hırsızı için süreleri topluyoruz

      const konuAdi = a.konu && a.konu.trim() !== "" ? a.konu : "Genel Soru Çözümü";
      const anahtar = `${a.ders}_${konuAdi}`;
      if (!konular[anahtar]) {
          konular[anahtar] = { ders: a.ders, konu: konuAdi, toplam: 0, dogru: 0, yanlis: 0 };
      }
      konular[anahtar].toplam += Number(a.toplam || 0);
      konular[anahtar].dogru += Number(a.dogru || 0);
      konular[anahtar].yanlis += Number(a.yanlis || 0);

      toplamSoru += Number(a.toplam || 0);
      toplamDogru += Number(a.dogru || 0);
      toplamYanlis += Number(a.yanlis || 0);
    });

seciliOgrenciVerisi = Object.values(dersGruplari).sort((a, b) => b.toplam - a.toplam);
    basariYuzdesi = Math.min(100, Math.round((toplamSoru / hedefSoru) * 100));

  // 🚀 YENİ: Zaman Hırsızı Tespiti Motoru
    const IDEAL_SURELER = {
      // LGS Sistem Tanımlamaları
      'LGS - Matematik': 2.5, 'LGS - Türkçe': 1.75, 'LGS - Fen Bilimleri': 1.75,
      'LGS - İnkılap Tarihi': 1.0, 'LGS - İngilizce': 1.0, 'LGS - Din Kültürü': 1.0,

      // Yeni Sistem (Önekli) Tanımlamalar
      'TYT - Türkçe': 1.1, 'TYT - Matematik': 1.5, 'TYT - Geometri': 1.5,
      'TYT - Fizik': 1.2, 'TYT - Kimya': 1.1, 'TYT - Biyoloji': 1.1,
      'TYT - Tarih': 1.0, 'TYT - Coğrafya': 1.0, 'TYT - Felsefe': 1.0, 'TYT - Din Kültürü': 1.0,
      'AYT - Matematik': 2.0, 'AYT - Matematik (İleri)': 2.0, 'AYT - Geometri': 2.0, 'AYT - Geometri (İleri)': 2.0,
      'AYT - Edebiyat': 1.0, 'AYT - Fizik': 1.8, 'AYT - Fizik (İleri)': 1.8,
      'AYT - Kimya': 1.5, 'AYT - Kimya (İleri)': 1.5, 'AYT - Biyoloji': 1.4, 'AYT - Biyoloji (İleri)': 1.4,
      'AYT - Tarih': 1.0, 'AYT - Tarih (İleri)': 1.0, 'AYT - Coğrafya': 1.0, 'AYT - Coğrafya (İleri)': 1.0,
      
      // Eski Sistem (Geriye Dönük Uyumluluk) Tanımlamaları
      'Türkçe': 1.1, 'Matematik': 1.5, 'Geometri': 1.5, 
      'Fizik': 1.3, 'Kimya': 1.2, 'Biyoloji': 1.2,
      'Tarih': 1.0, 'Coğrafya': 1.0, 'Edebiyat': 1.2, 'Felsefe': 1.0
    };
    
    // Yeterli veri olan (en az 10 soru çözülmüş) derslerde analiz yap
 zamanHirsizlari = seciliOgrenciVerisi
      .filter(d => d.toplam >= 10 && d.sure > 0)
      .map(d => {
        const ortalamaSure = d.sure / d.toplam;
        const limit = IDEAL_SURELER[d.name] || 1.5; // Tanımsızsa varsayılan 1.5 dk
        return {
           ders: d.name,
           ortalama: ortalamaSure,
           limit: limit,
           gecikmeOrani: (ortalamaSure - limit) / limit
        };
      })
      .filter(d => d.gecikmeOrani > 0.15) // İdeal süreyi %15'ten fazla aşıyorsa tehlikeli say
      .sort((a, b) => b.gecikmeOrani - a.gecikmeOrani); // En çok vakit çalanı en üste al

  // 🚀 YENİ: Gölge Rakip Kıyaslamalı Radar Motoru
    radarData = Object.values(dersGruplari).map(d => {
        const ogrenciBasarisi = d.toplam > 0 ? Math.round((d.dogru / d.toplam) * 100) : 0;
        
        let hedefBasari = 0;
        if (seciliHedefProfil && HEDEF_PROFILLER[seciliHedefProfil]) {
            const profil = HEDEF_PROFILLER[seciliHedefProfil];
            const temizDersAdi = d.name.replace('TYT - ', '').replace('AYT - ', '').replace('LGS - ', ''); // Eski/yeni veri farkını ortadan kaldır
            
            // Önce tam eşleşme ara, yoksa TYT/AYT/LGS önekleriyle ara, o da yoksa Fen/Sosyal genellemesine bak
            hedefBasari = profil[d.name] || 
                          profil[`TYT - ${temizDersAdi}`] || 
                          profil[`AYT - ${temizDersAdi}`] ||
                          profil[`LGS - ${temizDersAdi}`] ||
                          (temizDersAdi.includes("Fizik") || temizDersAdi.includes("Kimya") || temizDersAdi.includes("Biyoloji") ? profil["TYT - Fen"] || profil["AYT - Fen"] || 0 : 0) ||
                          (temizDersAdi.includes("Tarih") || temizDersAdi.includes("Coğrafya") || temizDersAdi.includes("Felsefe") || temizDersAdi.includes("Din") ? profil["TYT - Sosyal"] || 0 : 0) || 0;
        }

        return {
            subject: d.name.replace('TYT - ', '').replace('AYT - ', ''), 
            ogrenci: ogrenciBasarisi,
            hedef: hedefBasari,
            fullMark: 100
        };
    });

    // 🚀 YENİ: Efor - Verim Matrisi Hesaplama Motoru
    eforVerimData = seciliOgrenciVerisi.filter(d => d.toplam > 0).map(d => ({
        ders: d.name,
        efor: d.sure > 0 ? d.sure : d.toplam, // Süre verisi varsa efor olarak süreyi, yoksa soru sayısını al
        verim: Math.round((d.dogru / d.toplam) * 100),
        soru: d.toplam
    }));
    
    ortalamaEfor = eforVerimData.length > 0 ? eforVerimData.reduce((acc, curr) => acc + curr.efor, 0) / eforVerimData.length : 0;
    ortalamaVerim = eforVerimData.length > 0 ? eforVerimData.reduce((acc, curr) => acc + curr.verim, 0) / eforVerimData.length : 0;

    // 🚀 YENİ: Akıllı Triyaj (Triage) Hesaplama Motoru
    konuDetaylari = Object.values(konular).map(k => {
        const hataOrani = k.toplam > 0 ? (k.yanlis / k.toplam) : 0;
        let triyaj = 'yesil'; 
        let triyajText = 'Güvenli Alan';
        
        // Sadece en az 5 soru çözülmüşse triyaj (renklendirme) yapıyoruz.
        // Aksi takdirde 1 soru çözüp 1 yanlış yapana (%100) acil durum dememek için.
        if (k.toplam >= 5) {
            if (hataOrani >= 0.4) { 
                triyaj = 'kirmizi'; triyajText = 'Acil Müdahale'; 
            } else if (hataOrani >= 0.25) { 
                triyaj = 'sari'; triyajText = 'Riskli Alan'; 
            }
        } else {
            triyaj = 'gri'; triyajText = 'Yetersiz Veri'; 
        }
        
        return { ...k, hataOrani, triyaj, triyajText };
    }).sort((a, b) => {
        // Önce triyaj aciliyetine göre (Kırmızı > Sarı > Gri > Yeşil) sırala
        const priority = { 'kirmizi': 1, 'sari': 2, 'gri': 3, 'yesil': 4 };
        if (priority[a.triyaj] !== priority[b.triyaj]) {
            return priority[a.triyaj] - priority[b.triyaj];
        }
      // Triyaj seviyesi aynıysa, hata oranına göre yüksekten düşüğe sırala
        return b.hataOrani - a.hataOrani;
    });

    // 🚀 GERÇEK ÖĞRENCİ HAFTALIK GRUPLAMA MOTORU
    const tumSoruGecmisi = hamSoruVerileri.filter(s => String(s.studentNo) === String(selectedStudent));
    
    tumSoruGecmisi.forEach(sub => {
        const a = sub.answers;
        const ts = sub.createdAt || (typeof sub.id === 'number' ? sub.id : Date.now());
        const dateObj = new Date(ts);
        const day = dateObj.getDay() || 7; 
        const monday = new Date(dateObj);
        monday.setDate(monday.getDate() - (day - 1));
        const haftaBaslangici = monday.toLocaleDateString('tr-TR');

        if (!haftalikKume[haftaBaslangici]) {
            haftalikKume[haftaBaslangici] = {
                timestamp: monday.getTime(), hafta: haftaBaslangici, toplam: 0, dogru: 0, yanlis: 0, dersler: {}
            };
        }

        const ders = a.ders || 'Bilinmiyor';
        if (!haftalikKume[haftaBaslangici].dersler[ders]) {
            haftalikKume[haftaBaslangici].dersler[ders] = { toplam: 0, dogru: 0, yanlis: 0 };
        }

        const sToplam = Number(a.toplam || 0);
        const sDogru = Number(a.dogru || 0);
        const sYanlis = Number(a.yanlis || 0);

        haftalikKume[haftaBaslangici].dersler[ders].toplam += sToplam;
        haftalikKume[haftaBaslangici].dersler[ders].dogru += sDogru;
        haftalikKume[haftaBaslangici].dersler[ders].yanlis += sYanlis;

        haftalikKume[haftaBaslangici].toplam += sToplam;
        haftalikKume[haftaBaslangici].dogru += sDogru;
        haftalikKume[haftaBaslangici].yanlis += sYanlis;
    });

    mevcutHaftalar = Object.values(haftalikKume).sort((a, b) => b.timestamp - a.timestamp).map(h => h.hafta);

    seciliOgrenciDenemeleri = denemeVerileri
        .filter(s => String(s.studentNo) === String(selectedStudent))
        .map(d => {
            const a = d.answers;
            
            const turkceNet = (Number(a.turkceD||0)) - (Number(a.turkceY||0)/4);
            const matNet = (Number(a.matematikD||0)) - (Number(a.matematikY||0)/4);
            const sosyalNet = (Number(a.sosyalD||0)) - (Number(a.sosyalY||0)/4);
            const fenNet = (Number(a.fenD||0)) - (Number(a.fenY||0)/4);
            
            const edbNet = (Number(a.edebiyatD||0)) - (Number(a.edebiyatY||0)/4);
            const tar1Net = (Number(a.tarih1D||0)) - (Number(a.tarih1Y||0)/4);
            const cog1Net = (Number(a.cografya1D||0)) - (Number(a.cografya1Y||0)/4);
            const tar2Net = (Number(a.tarih2D||0)) - (Number(a.tarih2Y||0)/4);
            const felsefeNet = (Number(a.felsefeD||0)) - (Number(a.felsefeY||0)/4);
            const dilNet = (Number(a.dilD||0)) - (Number(a.dilY||0)/4);

// AYT Sayısal / Sosyal-2 branş netleri
const fizikNet = (Number(a.fizikD||0)) - (Number(a.fizikY||0)/4);
const kimyaNet = (Number(a.kimyaD||0)) - (Number(a.kimyaY||0)/4);
const biyolojiNet = (Number(a.biyolojiD||0)) - (Number(a.biyolojiY||0)/4);
const cog2Net = (Number(a.cografya2D||0)) - (Number(a.cografya2Y||0)/4);
const dinNet = (Number(a.dinD||0)) - (Number(a.dinY||0)/4);


            
            // 🚀 YENİ: LGS Net Hesaplama (3 Yanlış 1 Doğru)
            const lgsTurkceNet = (Number(a.lgsTurkceD||0)) - (Number(a.lgsTurkceY||0)/3);
            const lgsMatNet = (Number(a.lgsMatD||0)) - (Number(a.lgsMatY||0)/3);
            const lgsFenNet = (Number(a.lgsFenD||0)) - (Number(a.lgsFenY||0)/3);
            const lgsInkilapNet = (Number(a.lgsInkilapD||0)) - (Number(a.lgsInkilapY||0)/3);
            const lgsIngNet = (Number(a.lgsIngD||0)) - (Number(a.lgsIngY||0)/3);
            const lgsDinNet = (Number(a.lgsDinD||0)) - (Number(a.lgsDinY||0)/3);
            
           // TYT Toplam Net
const tytAnlikToplamNet =
    turkceNet +
    matNet +
    sosyalNet +
    fenNet;

// AYT Toplam Net
// Kullanılmayan alanlar boş geldiği için Number(... || 0) sayesinde otomatik 0 kabul edilir.
const aytAnlikToplamNet =
    matNet +
    fizikNet +
    kimyaNet +
    biyolojiNet +
    edbNet +
    tar1Net +
    cog1Net +
    tar2Net +
    cog2Net +
    felsefeNet +
    dinNet;

// YDT Toplam Net
const ydtAnlikToplamNet = dilNet;

// LGS Toplam Net
const lgsAnlikToplamNet =
    lgsTurkceNet +
    lgsMatNet +
    lgsFenNet +
    lgsInkilapNet +
    lgsIngNet +
    lgsDinNet;

// Denemenin türüne göre doğru motoru seç
const finalToplamNet =
    a.denemeTuru === 'LGS' ? lgsAnlikToplamNet :
    a.denemeTuru === 'AYT' ? aytAnlikToplamNet :
    a.denemeTuru === 'YDT' ? ydtAnlikToplamNet :
    tytAnlikToplamNet;

            return {
                name: a.denemeAdi || d.testName,
                'TYT Net': a.denemeTuru === 'TYT' ? Number(Math.max(0, finalToplamNet).toFixed(2)) : null,
                'AYT Net': a.denemeTuru === 'AYT' ? Number(Math.max(0, finalToplamNet).toFixed(2)) : null,
                'YDT Net': a.denemeTuru === 'YDT' ? Number(Math.max(0, finalToplamNet).toFixed(2)) : null,
                'LGS Net': a.denemeTuru === 'LGS' ? Number(Math.max(0, finalToplamNet).toFixed(2)) : null,
                
                // 🚀 YENİ: Karne Tablosu Detaylı Alt Kırılımlar
              tarih: a.tarih || new Date(d.createdAt || Date.now()).toLocaleDateString('tr-TR'),
timestamp: a.tarih
    ? new Date(`${a.tarih}T00:00:00`).getTime()
    : (d.createdAt || (typeof d.id === 'number' ? d.id : 0)),
turu: a.denemeTuru || 'Bilinmiyor',
yayin: a.denemeAdi || 'Bilinmeyen Yayın',
toplamNet: Number(Math.max(0, finalToplamNet).toFixed(2)),
                
                // TYT Kırılımları
                tytTurkce: a.denemeTuru === 'TYT' ? Number(Math.max(0, turkceNet).toFixed(2)) : '-',
                tytMat: a.denemeTuru === 'TYT' ? Number(Math.max(0, matNet).toFixed(2)) : '-',
                tytSos: a.denemeTuru === 'TYT' ? Number(Math.max(0, sosyalNet).toFixed(2)) : '-',
                tytFen: a.denemeTuru === 'TYT' ? Number(Math.max(0, fenNet).toFixed(2)) : '-',

                // AYT Sayısal Kırılımları
                aytMat: a.denemeTuru === 'AYT' ? Number(Math.max(0, matNet).toFixed(2)) : '-',
               aytFizik: a.denemeTuru === 'AYT' ? Number(Math.max(0, fizikNet).toFixed(2)) : '-',
                aytKimya: a.denemeTuru === 'AYT' ? Number(Math.max(0, kimyaNet).toFixed(2)) : '-',
                aytBiyo: a.denemeTuru === 'AYT' ? Number(Math.max(0, biyolojiNet).toFixed(2)) : '-',

                // AYT Eşit Ağırlık / Sözel (Sos-1 & Sos-2) Kırılımları
                aytEdb: a.denemeTuru === 'AYT' ? Number(Math.max(0, edbNet).toFixed(2)) : '-',
                aytTar1: a.denemeTuru === 'AYT' ? Number(Math.max(0, tar1Net).toFixed(2)) : '-',
                aytCog1: a.denemeTuru === 'AYT' ? Number(Math.max(0, cog1Net).toFixed(2)) : '-',
                aytTar2: a.denemeTuru === 'AYT' ? Number(Math.max(0, tar2Net).toFixed(2)) : '-',
                aytCog2: a.denemeTuru === 'AYT' ? Number(Math.max(0, cog2Net).toFixed(2)) : '-',
                aytFel: a.denemeTuru === 'AYT' ? Number(Math.max(0, felsefeNet).toFixed(2)) : '-',
                aytDin: a.denemeTuru === 'AYT' ? Number(Math.max(0, dinNet).toFixed(2)) : '-',

                // YDT Kırılımı
                ydtDil: a.denemeTuru === 'YDT' ? Number(Math.max(0, dilNet).toFixed(2)) : '-'
            };
        })
        .sort((a, b) => a.timestamp - b.timestamp);

    // 🚀 YENİ: Momentum ve Projeksiyon Hesaplama (TYT verileri üzerinden)
    const tytDenemeleri = seciliOgrenciDenemeleri.filter(d => d['TYT Net'] !== null);
    if (tytDenemeleri.length >= 2) {
        // İvme hesaplamak için son 3 denemeye (veya varsa 2'ye) bakıyoruz
        const sonDenemeler = tytDenemeleri.slice(-3); 
        const ilkNet = sonDenemeler[0]['TYT Net'];
        sonTytNet = sonDenemeler[sonDenemeler.length - 1]['TYT Net'];
        
        const fark = sonTytNet - ilkNet;
        tytMomentum = fark / (sonDenemeler.length - 1); // Deneme başına ortalama net artışı/azalışı
        
        if (tytMomentum > 1.5) {
            tytTrend = "artis";
            tytSonucMetni = `🚀 Harika bir ivme! Öğrenci son denemelerde ortalama ${tytMomentum.toFixed(1)} net artış (momentum) yakaladı. Özgüveni yüksek, yeni ve zorlu konulara geçilebilir.`;
        } else if (tytMomentum < -1.5) {
            tytTrend = "dusus";
            tytSonucMetni = `⚠️ Kritik Uyarı! Öğrenci son denemelerde hızla kan kaybediyor (Ortalama ${Math.abs(tytMomentum).toFixed(1)} net düşüş). Kaygı seviyesi ölçülmeli veya konu eksikleri baştan taranmalı.`;
        } else {
            tytTrend = "sabit";
            tytSonucMetni = `⚖️ Plato Evresi (Durağanlık). Öğrenci şu an ${sonTytNet.toFixed(1)} net bandına sıkışmış durumda. Bu eşiği atlamak için standart çalışma rutinini kırıp branş denemelerine ağırlık verilmesi önerilir.`;
        }
        
        // Gelecek 5 deneme sonrası için basit bir projeksiyon
        tytProjeksiyon = Math.max(0, Math.min(120, sonTytNet + (tytMomentum * 5))); 
    } else if (tytDenemeleri.length === 1) {
        sonTytNet = tytDenemeleri[0]['TYT Net'];
    }

    // 🚀 YENİ: AYT Momentum ve Projeksiyon Hesaplama
    const aytDenemeleri = seciliOgrenciDenemeleri.filter(d => d['AYT Net'] !== null);
    if (aytDenemeleri.length >= 2) {
        const sonAytDenemeler = aytDenemeleri.slice(-3); 
        const ilkAytNet = sonAytDenemeler[0]['AYT Net'];
        sonAytNet = sonAytDenemeler[sonAytDenemeler.length - 1]['AYT Net'];
        
        const aytFark = sonAytNet - ilkAytNet;
        aytMomentum = aytFark / (sonAytDenemeler.length - 1); 
        
        if (aytMomentum > 1.5) {
            aytTrend = "artis";
            aytSonucMetni = `🚀 Harika AYT ivmesi! Öğrenci AYT denemelerinde ortalama ${aytMomentum.toFixed(1)} net artış yakaladı. Alan hakimiyeti güçleniyor.`;
        } else if (aytMomentum < -1.5) {
            aytTrend = "dusus";
            aytSonucMetni = `⚠️ AYT Kan Kaybı! Son denemelerde ortalama ${Math.abs(aytMomentum).toFixed(1)} net düşüş var. AYT konu eksikleri acilen taranmalı.`;
        } else {
            aytTrend = "sabit";
            aytSonucMetni = `⚖️ AYT Denge Evresi. Öğrenci ${sonAytNet.toFixed(1)} net bandında seyrediyor. Derece için alan derinleşmesi ve branş denemesi şart.`;
        }
        aytProjeksiyon = Math.max(0, Math.min(80, sonAytNet + (aytMomentum * 5))); 
  } else if (aytDenemeleri.length === 1) {
        sonAytNet = aytDenemeleri[0]['AYT Net'];
    }

    // 🚀 YENİ: LGS Momentum ve Projeksiyon Hesaplama
    const lgsDenemeleri = seciliOgrenciDenemeleri.filter(d => d['LGS Net'] !== null);
    if (lgsDenemeleri.length >= 2) {
        const sonLgsDenemeler = lgsDenemeleri.slice(-3); 
        const ilkLgsNet = sonLgsDenemeler[0]['LGS Net'];
        sonLgsNet = sonLgsDenemeler[sonLgsDenemeler.length - 1]['LGS Net'];
        
        const lgsFark = sonLgsNet - ilkLgsNet;
        lgsMomentum = lgsFark / (sonLgsDenemeler.length - 1); 
        
        if (lgsMomentum > 1.5) {
            lgsTrend = "artis";
            lgsSonucMetni = `🚀 Harika LGS ivmesi! Öğrenci LGS denemelerinde ortalama ${lgsMomentum.toFixed(1)} net artış yakaladı. Yeni nesil soru çözme pratikleri meyvesini veriyor.`;
        } else if (lgsMomentum < -1.5) {
            lgsTrend = "dusus";
            lgsSonucMetni = `⚠️ LGS Kan Kaybı! Son denemelerde ortalama ${Math.abs(lgsMomentum).toFixed(1)} net düşüş var. Süre yönetimi veya LGS konu eksikleri acilen taranmalı.`;
        } else {
            lgsTrend = "sabit";
            lgsSonucMetni = `⚖️ LGS Denge Evresi. Öğrenci ${sonLgsNet.toFixed(1)} net bandında seyrediyor. Bu barajı aşmak için yeni nesil soru pratiklerine ağırlık verilmeli.`;
        }
        lgsProjeksiyon = Math.max(0, Math.min(90, sonLgsNet + (lgsMomentum * 5))); 
    } else if (lgsDenemeleri.length === 1) {
        sonLgsNet = lgsDenemeleri[0]['LGS Net'];
    }
  }

// 🚀 YENİ: Güvenli Demo Verisi (Mock Data) Şalteri
  if (demoModuAktif) {
      const isLgsDemo = seciliHedefProfil && seciliHedefProfil.includes('LGS');

      if (isLgsDemo) {
          // --- LGS DEMO VERİLERİ ---
          radarData = [
              { subject: 'Türkçe', ogrenci: 80, hedef: HEDEF_PROFILLER[seciliHedefProfil]["LGS - Türkçe"] || 0, fullMark: 100 },
              { subject: 'Matematik', ogrenci: 50, hedef: HEDEF_PROFILLER[seciliHedefProfil]["LGS - Matematik"] || 0, fullMark: 100 },
              { subject: 'Fen Bilimleri', ogrenci: 75, hedef: HEDEF_PROFILLER[seciliHedefProfil]["LGS - Fen Bilimleri"] || 0, fullMark: 100 },
              { subject: 'İnkılap Tar.', ogrenci: 90, hedef: HEDEF_PROFILLER[seciliHedefProfil]["LGS - İnkılap Tarihi"] || 0, fullMark: 100 }
          ];
          seciliOgrenciVerisi = [
              { name: 'LGS - Türkçe', toplam: 300 }, { name: 'LGS - Matematik', toplam: 250 },
              { name: 'LGS - Fen Bilimleri', toplam: 200 }, { name: 'LGS - İnkılap Tarihi', toplam: 150 }
          ];
          eforVerimData = [
              { ders: 'LGS - Türkçe', efor: 1.5, verim: 80, soru: 300 }, { ders: 'LGS - Matematik', efor: 2.8, verim: 50, soru: 250 },
              { ders: 'LGS - Fen Bilimleri', efor: 1.6, verim: 75, soru: 200 }, { ders: 'LGS - İnkılap Tarihi', efor: 0.9, verim: 90, soru: 150 }
          ];
          ortalamaEfor = 1.7; ortalamaVerim = 73.7;
          konuDetaylari = [
              { ders: 'LGS - Matematik', konu: 'Doğrusal Denklemler', toplam: 100, dogru: 45, yanlis: 55, hataOrani: 0.55, triyaj: 'kirmizi', triyajText: 'Acil Müdahale' },
              { ders: 'LGS - Fen Bilimleri', konu: 'DNA ve Genetik Kod', toplam: 80, dogru: 50, yanlis: 30, hataOrani: 0.37, triyaj: 'sari', triyajText: 'Riskli Alan' },
              { ders: 'LGS - Türkçe', konu: 'Paragrafta Anlam', toplam: 150, dogru: 130, yanlis: 20, hataOrani: 0.13, triyaj: 'yesil', triyajText: 'Güvenli Alan' }
          ];
          toplamSoru = 900; toplamDogru = 650; toplamYanlis = 250; basariYuzdesi = 90;
          seciliOgrenciDenemeleri = [
              { name: 'Güz Denemesi', 'LGS Net': 55.5, tarih: '15.09.2026', turu: 'LGS', yayin: 'Hız Yayınları', toplamNet: 55.5 },
              { name: 'Kış Denemesi', 'LGS Net': 62.0, tarih: '20.10.2026', turu: 'LGS', yayin: 'Mozaik Türkiye Geneli', toplamNet: 62.0 },
              { name: 'Bahar Denemesi', 'LGS Net': 71.3, tarih: '12.11.2026', turu: 'LGS', yayin: 'Okyanus LGS', toplamNet: 71.3 }
          ];
          lgsMomentum = 7.9; lgsProjeksiyon = 85.0;
          lgsSonucMetni = "🚀 Harika LGS ivmesi! Öğrenci yeni nesil soru mantığına alışmış durumda, hedefe kilitlenilmiş.";
          lgsTrend = "artis"; sonLgsNet = 71.3;
          zamanHirsizlari = [{ ders: 'LGS - Matematik', ortalama: 2.8, limit: 2.5, gecikmeOrani: 0.12 }];
          
          // 🚀 YENİ: LGS Demo Haftalık Kume Verisi
          haftalikKume = {
              "19.10.2026": {
                  hafta: "19.10.2026", toplam: 250, dogru: 175, yanlis: 75,
                  dersler: {
                      "LGS - Matematik": { toplam: 100, dogru: 45, yanlis: 55 },
                      "LGS - Türkçe": { toplam: 150, dogru: 130, yanlis: 20 }
                  }
              },
              "12.10.2026": {
                  hafta: "12.10.2026", toplam: 230, dogru: 140, yanlis: 90,
                  dersler: {
                      "LGS - Matematik": { toplam: 150, dogru: 90, yanlis: 60 },
                      "LGS - Fen Bilimleri": { toplam: 80, dogru: 50, yanlis: 30 }
                  }
              }
          };
          mevcutHaftalar = ["19.10.2026", "12.10.2026"];

      } else {
          // --- YKS DEMO VERİLERİ ---
          radarData = [
              { subject: 'Türkçe', ogrenci: 65, hedef: seciliHedefProfil && HEDEF_PROFILLER[seciliHedefProfil] ? HEDEF_PROFILLER[seciliHedefProfil]["TYT - Türkçe"] || 0 : 0, fullMark: 100 },
              { subject: 'Matematik', ogrenci: 45, hedef: seciliHedefProfil && HEDEF_PROFILLER[seciliHedefProfil] ? HEDEF_PROFILLER[seciliHedefProfil]["TYT - Matematik"] || 0 : 0, fullMark: 100 },
              { subject: 'Geometri', ogrenci: 30, hedef: seciliHedefProfil && HEDEF_PROFILLER[seciliHedefProfil] ? HEDEF_PROFILLER[seciliHedefProfil]["TYT - Geometri"] || 0 : 0, fullMark: 100 },
              { subject: 'Fizik', ogrenci: 55, hedef: seciliHedefProfil && HEDEF_PROFILLER[seciliHedefProfil] ? HEDEF_PROFILLER[seciliHedefProfil]["TYT - Fizik"] || HEDEF_PROFILLER[seciliHedefProfil]["TYT - Fen"] || 0 : 0, fullMark: 100 },
              { subject: 'Tarih', ogrenci: 80, hedef: seciliHedefProfil && HEDEF_PROFILLER[seciliHedefProfil] ? HEDEF_PROFILLER[seciliHedefProfil]["TYT - Tarih"] || HEDEF_PROFILLER[seciliHedefProfil]["TYT - Sosyal"] || 0 : 0, fullMark: 100 }
          ];
          seciliOgrenciVerisi = [
              { name: 'Türkçe', toplam: 250 }, { name: 'Matematik', toplam: 400 }, { name: 'Geometri', toplam: 150 }, { name: 'Fizik', toplam: 200 }, { name: 'Tarih', toplam: 100 }
          ];
          eforVerimData = [
              { ders: 'TYT - Türkçe', efor: 1.0, verim: 65, soru: 250 }, { ders: 'TYT - Matematik', efor: 2.2, verim: 45, soru: 400 },
              { ders: 'TYT - Geometri', efor: 1.8, verim: 30, soru: 150 }, { ders: 'TYT - Fizik', efor: 1.4, verim: 55, soru: 200 },
              { ders: 'TYT - Tarih', efor: 0.8, verim: 80, soru: 100 }
          ];
          ortalamaEfor = 1.44; ortalamaVerim = 55;
          konuDetaylari = [
              { ders: 'TYT - Matematik', konu: 'Problemler', toplam: 80, dogru: 35, yanlis: 45, hataOrani: 0.56, triyaj: 'kirmizi', triyajText: 'Acil Müdahale' },
              { ders: 'TYT - Geometri', konu: 'Üçgende Açılar', toplam: 40, dogru: 25, yanlis: 15, hataOrani: 0.37, triyaj: 'sari', triyajText: 'Riskli Alan' },
              { ders: 'TYT - Türkçe', konu: 'Paragrafta Anlam', toplam: 150, dogru: 120, yanlis: 30, hataOrani: 0.20, triyaj: 'yesil', triyajText: 'Güvenli Alan' },
              { ders: 'TYT - Fizik', konu: 'Genel Soru Çözümü', toplam: 200, dogru: 145, yanlis: 55, hataOrani: 0.275, triyaj: 'sari', triyajText: 'Riskli Alan' },
              { ders: 'TYT - Tarih', konu: 'Genel Soru Çözümü', toplam: 100, dogru: 80, yanlis: 20, hataOrani: 0.20, triyaj: 'yesil', triyajText: 'Güvenli Alan' }
          ];
          toplamSoru = 900; toplamDogru = 495; toplamYanlis = 405; basariYuzdesi = 90;
          seciliOgrenciDenemeleri = [
              { name: 'Eylül Denemesi', 'TYT Net': 45.5, 'AYT Net': null, 'YDT Net': null, tarih: '15.09.2026', turu: 'TYT', yayin: '3D Yayınları TYT', toplamNet: 45.5, tytTurkce: 18.5, tytMat: 12, tytSos: 10, tytFen: 5, aytMat: '-', aytFizik: '-', aytKimya: '-', aytBiyo: '-', aytEdb: '-', aytTar1: '-', aytCog1: '-', aytTar2: '-', aytCog2: '-', aytFel: '-', aytDin: '-', ydtDil: '-' },
              { name: 'Ekim Denemesi', 'TYT Net': 48.25, 'AYT Net': null, 'YDT Net': null, tarih: '20.10.2026', turu: 'TYT', yayin: 'Özdebir Türkiye Geneli', toplamNet: 48.25, tytTurkce: 22, tytMat: 12.25, tytSos: 10, tytFen: 4, aytMat: '-', aytFizik: '-', aytKimya: '-', aytBiyo: '-', aytEdb: '-', aytTar1: '-', aytCog1: '-', aytTar2: '-', aytCog2: '-', aytFel: '-', aytDin: '-', ydtDil: '-' },
              { name: 'Kasım Denemesi', 'TYT Net': 55.75, 'AYT Net': 25.5, 'YDT Net': null, tarih: '12.11.2026', turu: 'AYT', yayin: 'Bilgi Sarmal AYT', toplamNet: 25.5, tytTurkce: '-', tytMat: '-', tytSos: '-', tytFen: '-', aytMat: 12.5, aytFizik: 4, aytKimya: 3, aytBiyo: 6, aytEdb: '-', aytTar1: '-', aytCog1: '-', aytTar2: '-', aytCog2: '-', aytFel: '-', aytDin: '-', ydtDil: '-' },
              { name: 'Aralık Denemesi', 'TYT Net': 62.5, 'AYT Net': 32.0, 'YDT Net': null, tarih: '25.12.2026', turu: 'TYT', yayin: 'Endemik Yayınları', toplamNet: 62.5, tytTurkce: 24, tytMat: 18.5, tytSos: 12, tytFen: 8, aytMat: 16, aytFizik: 5, aytKimya: 4, aytBiyo: 7, aytEdb: '-', aytTar1: '-', aytCog1: '-', aytTar2: '-', aytCog2: '-', aytFel: '-', aytDin: '-', ydtDil: '-' }
          ];
          tytMomentum = 7.12; tytProjeksiyon = 98.1;
          tytSonucMetni = "🚀 Harika bir ivme! Öğrenci son denemelerde ortalama 7.1 net artış (momentum) yakaladı. Özgüveni yüksek, yeni ve zorlu konulara geçilebilir.";
          tytTrend = "artis"; sonTytNet = 62.5;
          aytMomentum = 6.5; aytProjeksiyon = 64.5;
          aytSonucMetni = "🚀 Harika AYT ivmesi! Öğrenci AYT denemelerinde ortalama 6.5 net artış yakaladı. Alan hakimiyeti gözle görülür şekilde güçleniyor.";
          aytTrend = "artis"; sonAytNet = 32.0;
          zamanHirsizlari = [ { ders: 'TYT - Matematik', ortalama: 2.2, limit: 1.5, gecikmeOrani: 0.46 } ];

          // 🚀 YENİ: YKS Demo Haftalık Kume Verisi
          haftalikKume = {
              "19.10.2026": {
                  hafta: "19.10.2026", toplam: 230, dogru: 155, yanlis: 75,
                  dersler: { "TYT - Matematik": { toplam: 80, dogru: 35, yanlis: 45 }, "TYT - Türkçe": { toplam: 150, dogru: 120, yanlis: 30 } }
              },
              "12.10.2026": {
                  hafta: "12.10.2026", toplam: 140, dogru: 105, yanlis: 35,
                  dersler: { "TYT - Geometri": { toplam: 40, dogru: 25, yanlis: 15 }, "TYT - Tarih": { toplam: 100, dogru: 80, yanlis: 20 } }
              }
          };
          mevcutHaftalar = ["19.10.2026", "12.10.2026"];
      }
  }

  // 🚀 SEÇİLİ HAFTAYI BELİRLE VE VERİYİ ÇEK (HEM DEMO HEM GERÇEK İÇİN ÇALIŞIR)
  gosterilecekHafta = seciliHafta && mevcutHaftalar.includes(seciliHafta) ? seciliHafta : (mevcutHaftalar.length > 0 ? mevcutHaftalar[0] : "");
  aktifHaftaVerisi = gosterilecekHafta ? haftalikKume[gosterilecekHafta] : null;

  // 🚀 YENİ: Öğrenci Koçluk Merkezi Ana Veri Motoru (Güvenli Bölgeye Taşındı)
  const SIMDI = Date.now();  const BES_GUN = 5 * 24 * 60 * 60 * 1000;
  // 🚀 DÜZELTME: Sadece ve sadece Koçluk/Akademik işlem yapmış öğrencileri filtreliyoruz.
  const KOCLUK_MODULLERI = [
  'gunluk_soru_takibi',
  'deneme_net_takibi',
  'weekly_plan',
  'ai_macro_plan',
  'smart_plan'
];

  const koclukMerkeziVerileri = benzersizOgrenciler.map(ogr => {
      const ogrSubs = submissions.filter(s => String(s.studentNo) === ogr.no && KOCLUK_MODULLERI.includes(s.testId)); 
      
      const sonAktivite = ogrSubs.reduce((max, s) => Math.max(max, s.createdAt || (typeof s.id === 'number' ? s.id : 0)), 0);

      const isGhost = sonAktivite > 0 && (SIMDI - sonAktivite) > BES_GUN;
      
     const smartPlan =
  ogrSubs.find(
    s =>
      s.testId ===
      'smart_plan'
  );

const aiPlan =
  ogrSubs.find(
    s =>
      s.testId ===
      'ai_macro_plan'
  );

const weeklyPlan =
  ogrSubs.find(
    s =>
      s.testId ===
      'weekly_plan'
  );


let planDurumu =
  "Plan Atanmadı";


if (smartPlan) {

  planDurumu =
    "Akıllı Plan";

} else if (aiPlan) {

  planDurumu =
    "AI Makro Plan";

} else if (weeklyPlan) {

  planDurumu =
    "Haftalık Manuel Plan";
}

      let durum = "Aktif";
      let durumRenk = "text-emerald-700 bg-emerald-100 border-emerald-200";
      if (isGhost) {
          durum = "Sistemden Koptu";
          durumRenk = "text-slate-600 bg-slate-200 border-slate-300";
      } else if (
  !smartPlan &&
  !aiPlan &&
  !weeklyPlan &&
  ogrSubs.length > 0
) {
          durum = "Plan Bekliyor";
          durumRenk = "text-amber-700 bg-amber-100 border-amber-200";
      } else if (ogrSubs.length === 0) {
          durum = "Sistemde Yok"; // 🚀 YENİ: Hiç verisi olmayanları ayırıyoruz
      }

      return { ...ogr, sonAktivite, planDurumu, durum, durumRenk };
  })
  .filter(ogr => ogr.durum !== "Sistemde Yok") // 🚀 YENİ: Hiç verisi olmayanları tablodan çıkarıyoruz
  .sort((a,b) => b.sonAktivite - a.sonAktivite);


  const formatPlanAsGrid = (text) => {
    if (!text) return null;

    const weeks = text
  .split(/(?=# )/)
  .filter(part =>
    part.trimStart().startsWith('# ')
  );

    return weeks.map((weekText, wIdx) => {
      const lines = weekText.split('\n').filter(l => l.trim() !== '');
      const weekTitle = lines[0].replace('# ', '').trim();
      const days = [];
      let currentDay = null;

      lines.slice(1).forEach(line => {
        if (line.startsWith('**') || line.startsWith('* ')) {
          if (currentDay) days.push(currentDay);
          currentDay = { name: line.replace(/\*\*/g, '').replace('* ', '').replace(':', '').trim(), tasks: [] };
        } else if (line.startsWith('- ') && currentDay) {
          currentDay.tasks.push(line.replace('- ', '').trim());
        }
      });
      if (currentDay) days.push(currentDay);

     return (
        <div key={wIdx} className="mb-10 print:mb-6 break-inside-avoid block">
          <div className="bg-indigo-600 text-white font-black px-5 py-3 rounded-t-2xl shadow-md print:bg-indigo-100 print:text-indigo-900 print:shadow-none print:border-b-2 print:border-indigo-800 print:rounded-none">
            {weekTitle}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-5 bg-slate-800/40 rounded-b-2xl border border-t-0 border-slate-700 print:bg-transparent print:border-none print:p-0 print:pt-4 print:grid-cols-3 print:gap-2">
            {days.map((day, dIdx) => (
              <div key={dIdx} className="bg-slate-800 p-4 rounded-xl border border-slate-700 shadow-sm print:bg-white print:border print:border-slate-300 print:shadow-none break-inside-avoid">
                <h3 className="text-sm font-black text-emerald-400 mb-3 border-b border-slate-700 pb-2 print:text-slate-800 print:border-slate-300 uppercase tracking-wide">
                  {day.name}
                </h3>
                <ul className="space-y-2">
                  {day.tasks.map((task, tIdx) => (
                    <li key={tIdx} className="text-[11px] text-slate-300 leading-relaxed flex items-start print:text-slate-700">
                      <div className="min-w-1.5 h-1.5 mt-1.5 mr-2 rounded-full bg-indigo-500 print:bg-slate-400"></div>
                      <span>{task}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      );
    });
  };

  // 🧠 YENİ: Öğrencinin kaydettiği interaktif ilerlemeyi (progressData) gösteren motor
  const renderProgressData = (progressData) => {
    if (!progressData || !Array.isArray(progressData)) return null;

    return progressData.map((week, wIdx) => {
      // Haftalık başarı yüzdesini hesapla
      let totalWeekTasks = 0;
      let completedWeekTasks = 0;
      week.days.forEach(day => {
        day.tasks.forEach(task => {
          totalWeekTasks++;
          if (task.completed) completedWeekTasks++;
        });
      });
      const weekProgress = totalWeekTasks > 0 ? Math.round((completedWeekTasks / totalWeekTasks) * 100) : 0;

      return (
        <div key={wIdx} className="mb-10 print:mb-6 break-inside-avoid block">
          <div className="bg-indigo-600 text-white font-black px-5 py-3 rounded-t-2xl shadow-md flex justify-between items-center print:bg-indigo-100 print:text-indigo-900 print:shadow-none print:border-b-2 print:border-indigo-800 print:rounded-none">
            <span>{week.title}</span>
            <span className="text-xs bg-white/20 px-3 py-1 rounded-full border border-white/30 print:border-indigo-900 print:text-indigo-900">
              İlerleme: %{weekProgress}
            </span>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-5 bg-slate-800/40 rounded-b-2xl border border-t-0 border-slate-700 print:bg-transparent print:border-none print:p-0 print:pt-4 print:grid-cols-3 print:gap-2">
            {week.days.map((day, dIdx) => (
              <div key={dIdx} className="bg-slate-800 p-4 rounded-xl border border-slate-700 shadow-sm print:bg-white print:border print:border-slate-300 print:shadow-none break-inside-avoid">
                <h3 className="text-sm font-black text-emerald-400 mb-3 border-b border-slate-700 pb-2 print:text-slate-800 print:border-slate-300 uppercase tracking-wide">
                  {day.name}
                </h3>
                <ul className="space-y-2">
                  {day.tasks.map((task, tIdx) => (
                    <li key={tIdx} className={`text-[11px] leading-relaxed flex items-start ${task.completed ? 'text-slate-500 line-through print:text-slate-400' : 'text-slate-300 print:text-slate-700'}`}>
                      <div className={`min-w-1.5 h-1.5 mt-1.5 mr-2 rounded-full ${task.completed ? 'bg-emerald-500' : 'bg-indigo-500 print:bg-slate-400'}`}></div>
                      <span>{task.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      );
    });
  };

  return (
  <div className="space-y-8">

    {/* =====================================================
        KOÇLUK MODÜLÜ — ANA BÖLÜMLER
    ====================================================== */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 no-print">

      <button
        type="button"
        onClick={() => {
          setMainSection('program');
          setActiveTab('haftalik_plan');
        }}
        className={`text-left rounded-3xl border-2 p-5 transition-all ${
          mainSection === 'program'
            ? 'border-indigo-500 bg-indigo-50 shadow-sm'
            : 'border-slate-200 bg-white hover:border-indigo-200 hover:shadow-sm'
        }`}
      >
        <div className="flex items-center gap-4">

          <div
            className={`h-12 w-12 rounded-2xl flex items-center justify-center shrink-0 ${
              mainSection === 'program'
                ? 'bg-indigo-600 text-white'
                : 'bg-indigo-50 text-indigo-600'
            }`}
          >
            <Calendar className="h-6 w-6" />
          </div>

          <div>
            <p
              className={`text-[10px] font-black uppercase tracking-[0.16em] ${
                mainSection === 'program'
                  ? 'text-indigo-500'
                  : 'text-slate-400'
              }`}
            >
              Programlama
            </p>

            <h2 className="text-lg font-black text-slate-900 mt-0.5">
              Program Oluşturma
            </h2>

            <p className="text-xs text-slate-500 mt-1">
              Yapay zeka veya manuel yöntemle öğrenciye
              çalışma programı hazırlayın.
            </p>
          </div>

        </div>
      </button>


      <button
        type="button"
        onClick={() => {
          setMainSection('tracking');
          setActiveTab('haftalik_plan');
        }}
        className={`text-left rounded-3xl border-2 p-5 transition-all ${
          mainSection === 'tracking'
            ? 'border-emerald-500 bg-emerald-50 shadow-sm'
            : 'border-slate-200 bg-white hover:border-emerald-200 hover:shadow-sm'
        }`}
      >
        <div className="flex items-center gap-4">

          <div
            className={`h-12 w-12 rounded-2xl flex items-center justify-center shrink-0 ${
              mainSection === 'tracking'
                ? 'bg-emerald-600 text-white'
                : 'bg-emerald-50 text-emerald-600'
            }`}
          >
            <Users className="h-6 w-6" />
          </div>

          <div>
            <p
              className={`text-[10px] font-black uppercase tracking-[0.16em] ${
                mainSection === 'tracking'
                  ? 'text-emerald-600'
                  : 'text-slate-400'
              }`}
            >
              İzleme & Analiz
            </p>

            <h2 className="text-lg font-black text-slate-900 mt-0.5">
              Öğrenci Takibi
            </h2>

            <p className="text-xs text-slate-500 mt-1">
              Soru, efor, deneme, gelişim ve öğrenci
              raporlarını tek yerden takip edin.
            </p>
          </div>

        </div>
      </button>

    </div>


    {mainSection === 'program' && (
      <div className="no-print">

  <div className="mb-6">

    <p className="text-[10px] font-black uppercase tracking-[0.18em] text-indigo-500">
      Program Oluşturma
    </p>

    <h2 className="text-2xl font-black text-slate-900 mt-1">
      Nasıl bir program oluşturmak istiyorsunuz?
    </h2>

    <p className="text-sm text-slate-500 mt-2">
      Yapay zekanın uzun dönem program oluşturmasını sağlayın
      veya haftalık programı kendiniz hazırlayın.
    </p>

  </div>


 <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">

    {/* ==================================================
        AKILLI PLAN ROBOTU — YENİ DETERMINISTIK MOTOR
    ================================================== */}
       <button
      type="button"
      disabled={!SMART_PLAN_ROBOT_ENABLED}
      aria-disabled={!SMART_PLAN_ROBOT_ENABLED}
      onClick={() => {
        if (!SMART_PLAN_ROBOT_ENABLED) return;

        setProgramMode('smart');
        setActiveTab('haftalik_plan');
        setIsAiModalOpen(false);
      }}
      className={`text-left rounded-3xl border-2 p-6 transition-all ${
        !SMART_PLAN_ROBOT_ENABLED
          ? 'border-violet-200 bg-gradient-to-br from-violet-50 to-indigo-50 cursor-not-allowed opacity-80'
          : programMode === 'smart'
            ? 'border-violet-500 bg-gradient-to-br from-indigo-600 to-violet-700 text-white shadow-lg shadow-indigo-100'
            : 'border-slate-200 bg-white hover:border-violet-300 hover:shadow-md'
      }`}
    >

      <div className="flex items-start justify-between gap-4">

        <div
          className={`h-12 w-12 rounded-2xl flex items-center justify-center shrink-0 ${
            !SMART_PLAN_ROBOT_ENABLED
              ? 'bg-violet-100 text-violet-500'
              : programMode === 'smart'
                ? 'bg-white/15 text-white'
                : 'bg-violet-50 text-violet-600'
          }`}
        >
          <Brain className="h-6 w-6" />
        </div>

        <span
          className={`px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-wider ${
            !SMART_PLAN_ROBOT_ENABLED
              ? 'bg-amber-100 text-amber-700 border border-amber-200'
              : programMode === 'smart'
                ? 'bg-white/15 text-white'
                : 'bg-violet-50 text-violet-600'
          }`}
        >
          {SMART_PLAN_ROBOT_ENABLED
            ? 'Yeni • Akıllı Motor'
            : 'Çok Yakında'}
        </span>

      </div>


      <h3 className="text-xl font-black mt-5 text-slate-900">
        Akıllı Plan Robotu
      </h3>

      <p className="text-sm mt-2 leading-relaxed text-slate-500">
        Öğrencinin zamanı, dersleri, konu durumu ve çalışma
        stratejisine göre uygulanabilir haftalık planı
        otomatik oluşturun.
      </p>

      <div
        className={`mt-5 text-xs font-black ${
          SMART_PLAN_ROBOT_ENABLED
            ? 'text-violet-600'
            : 'text-slate-400'
        }`}
      >
        {SMART_PLAN_ROBOT_ENABLED
          ? 'Akıllı Plan Oluştur →'
          : 'Geliştirme devam ediyor'}
      </div>

    </button>


    <button
      type="button"
      onClick={() => {
        setProgramMode('ai');
        setIsAiModalOpen(true);
      }}
      className={`text-left rounded-3xl border-2 p-6 transition-all ${
        programMode === 'ai'
          ? 'border-indigo-500 bg-indigo-600 text-white shadow-lg shadow-indigo-100'
          : 'border-slate-200 bg-white hover:border-indigo-300 hover:shadow-md'
      }`}
    >

      <div className="flex items-start justify-between gap-4">

        <div
          className={`h-12 w-12 rounded-2xl flex items-center justify-center shrink-0 ${
            programMode === 'ai'
              ? 'bg-white/15 text-white'
              : 'bg-indigo-50 text-indigo-600'
          }`}
        >
          <Sparkles className="h-6 w-6" />
        </div>

        <span
          className={`px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-wider ${
            programMode === 'ai'
              ? 'bg-white/15 text-white'
              : 'bg-indigo-50 text-indigo-600'
          }`}
        >
          Uzun dönem • Otomatik
        </span>

      </div>


      <h3 className="text-xl font-black mt-5">
        Yapay Zeka ile Program Oluştur
      </h3>

      <p
        className={`text-sm mt-2 leading-relaxed ${
          programMode === 'ai'
            ? 'text-indigo-100'
            : 'text-slate-500'
        }`}
      >
        Öğrencinin sınıfı, sınav türü, alanı, seviyesi ve
        hedeflerine göre 8–36 haftalık çalışma programını
        otomatik hazırlayın.
      </p>

      <div
        className={`mt-5 text-xs font-black ${
          programMode === 'ai'
            ? 'text-white'
            : 'text-indigo-600'
        }`}
      >
        Yapay Zeka ile Oluştur →
      </div>

    </button>


    <button
      type="button"
      onClick={() => {
        setProgramMode('manual');
        setActiveTab('haftalik_plan');
      }}
      className={`text-left rounded-3xl border-2 p-6 transition-all ${
        programMode === 'manual'
          ? 'border-blue-500 bg-slate-900 text-white shadow-lg shadow-slate-200'
          : 'border-slate-200 bg-white hover:border-blue-300 hover:shadow-md'
      }`}
    >

      <div className="flex items-start justify-between gap-4">

        <div
          className={`h-12 w-12 rounded-2xl flex items-center justify-center shrink-0 ${
            programMode === 'manual'
              ? 'bg-white/10 text-white'
              : 'bg-blue-50 text-blue-600'
          }`}
        >
          <Calendar className="h-6 w-6" />
        </div>

        <span
          className={`px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-wider ${
            programMode === 'manual'
              ? 'bg-white/10 text-white'
              : 'bg-blue-50 text-blue-600'
          }`}
        >
          1 hafta • Tam kontrol
        </span>

      </div>


      <h3 className="text-xl font-black mt-5">
        Manuel Haftalık Program
      </h3>

      <p
        className={`text-sm mt-2 leading-relaxed ${
          programMode === 'manual'
            ? 'text-slate-300'
            : 'text-slate-500'
        }`}
      >
        Ders, konu, kaynak, soru hedefi ve özel görevleri
        gün gün kendiniz belirleyerek haftalık programı
        hazırlayın.
      </p>

      <div
        className={`mt-5 text-xs font-black ${
          programMode === 'manual'
            ? 'text-white'
            : 'text-blue-600'
        }`}
      >
        Kendim Oluşturayım →
      </div>

    </button>

    </div>

</div>
)}


{mainSection === 'program' &&
  SMART_PLAN_ROBOT_ENABLED &&
  programMode === 'smart' && (
    <SmartPlanBuilder
  students={benzersizOgrenciler}
  user={user}
  submissions={submissions}
  onAssign={onAssign}
  academicYear={academicYear}
/>
)}


{mainSection === 'tracking' && (
  <div className="no-print">

    <div className="mb-5">

      <p className="text-[10px] font-black uppercase tracking-[0.18em] text-emerald-600">
        Öğrenci Takibi
      </p>

      <h2 className="text-2xl font-black text-slate-900 mt-1">
        Koçluk öğrencilerini izleyin
      </h2>

      <p className="text-sm text-slate-500 mt-2">
        Öğrencilerin çalışma sürecini, soru performansını
        ve deneme gelişimini inceleyin.
      </p>

    </div>


    <div className="flex flex-wrap gap-2 mb-8">

      <button
        type="button"
        onClick={() => setActiveTab('haftalik_plan')}
        className={`px-4 py-2.5 rounded-xl text-xs font-black transition ${
          activeTab === 'haftalik_plan'
            ? 'bg-slate-900 text-white shadow-sm'
            : 'bg-white border border-slate-200 text-slate-600 hover:border-slate-300'
        }`}
      >
        <Users className="h-4 w-4 inline-block mr-2" />
        Öğrenci Listesi
      </button>


     <button
  type="button"
  onClick={() => setActiveTab('plan_arsivi')}
  className={`px-4 py-2.5 rounded-xl text-xs font-black transition ${
    activeTab === 'plan_arsivi'
      ? 'bg-violet-600 text-white shadow-sm'
      : 'bg-white border border-slate-200 text-slate-600 hover:border-violet-200'
  }`}
>
  <BookOpen className="h-4 w-4 inline-block mr-2" />
  Program Arşivi
</button>


      <button
        type="button"
        onClick={() => {
  setActiveTab('ogrenci_rontgeni');
  setSoruEforTab('genel');
}}
        className={`px-4 py-2.5 rounded-xl text-xs font-black transition ${
          activeTab === 'ogrenci_rontgeni'
            ? 'bg-indigo-600 text-white shadow-sm'
            : 'bg-white border border-slate-200 text-slate-600 hover:border-indigo-200'
        }`}
      >
        <Activity className="h-4 w-4 inline-block mr-2" />
        Soru & Efor
      </button>


      <button
        type="button"
        onClick={() => setActiveTab('deneme_analizi')}
        className={`px-4 py-2.5 rounded-xl text-xs font-black transition ${
          activeTab === 'deneme_analizi'
            ? 'bg-emerald-600 text-white shadow-sm'
            : 'bg-white border border-slate-200 text-slate-600 hover:border-emerald-200'
        }`}
      >
        <Target className="h-4 w-4 inline-block mr-2" />
        Deneme & Trend
      </button>

    </div>

  </div>

)}


      {(activeTab === 'haftalik_plan' || activeTab === 'plan_arsivi') ? (
        <div className="space-y-8">
        {mainSection === 'program' && programMode === 'manual' && (
  <>
          <div className="flex justify-between items-center bg-white p-6 rounded-2xl shadow-sm border border-slate-100 no-print">
            <div>
              <h2 className="text-2xl font-black text-slate-800">Plan Oluşturucu</h2>
              <p className="text-slate-500 text-sm">Öğrenciye özel, madde madde görev listesi oluşturun.</p>
            </div>
           <div className="flex gap-3">
             {/* 🎯 E-Okul Uyumlu Yeni Öğrenci Seçici (Manual Plan İçin) */}
              <select 
                value={targetNo} 
                onChange={(e) => setTargetNo(e.target.value)} 
                className="px-4 py-2 bg-slate-50 border-2 border-slate-200 rounded-xl font-bold w-48 focus:border-blue-500 focus:outline-none cursor-pointer text-slate-700"
              >
                <option value="" disabled>Öğrenci Seçin...</option>
                {benzersizOgrenciler.map(ogr => <option key={ogr.no} value={ogr.no}>{ogr.label}</option>)}
              </select>
              <input 
                type="number" 
                value={targetGoal} 
                onChange={(e) => setTargetGoal(e.target.value)} 
                placeholder="Hedef Soru" 
                className="px-4 py-2 bg-slate-50 border-2 border-slate-200 rounded-xl font-bold w-32 focus:border-indigo-500 focus:outline-none text-center text-indigo-600" 
              />
            <button 
  onClick={handleAssign} 
  className="px-6 py-2 bg-slate-900 text-white rounded-xl font-bold hover:bg-black transition flex items-center"
>
  {
    saved
      ? <CheckCircle className="h-4 w-4 mr-2"/>
      : <Send className="h-4 w-4 mr-2"/>
  }

  {
    saved
      ? "Gönderildi"
      : "Planı Gönder"
  }
</button>


<button
  type="button"
  onClick={handleManualWeekPrint}
  className="px-5 py-2 bg-white text-slate-700 rounded-xl font-bold hover:bg-slate-50 transition flex items-center border-2 border-slate-200"
>
  <Printer className="h-4 w-4 mr-2" />

  Yazdır / PDF
</button>
              
                          </div>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 no-print">
            {days.map(day => (
              <div key={day} className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col min-h-[540px]">
                <h3 className="font-bold text-xs text-slate-400 uppercase mb-3 flex items-center border-b pb-2">
                  <Calendar className="h-3 w-3 mr-1"/> {day}
                </h3>
                <div className="flex-1 overflow-y-auto space-y-2 mb-3 custom-scrollbar">
                  {weekData[day].map(task => (
                    <div key={task.id} className="flex justify-between items-start bg-slate-50 p-2 rounded-lg group">
                      <span className="text-sm text-slate-700 leading-tight">{task.text}</span>
                      <button onClick={() => handleDeleteTask(day, task.id)} className="text-slate-300 hover:text-red-500 opacity-0 group-hover:opacity-100 transition">
                        <X className="h-3 w-3"/>
                      </button>
                    </div>
                  ))}
                  {weekData[day].length === 0 && <p className="text-xs text-slate-300 text-center mt-4">Görev eklenmedi.</p>}
                </div>
              <div className="flex flex-col gap-2 mt-auto border-t border-slate-100 pt-3">
                 <select
                    value={taskSelections[day]?.ders || ''}
                    onChange={(e) => setTaskSelections({...taskSelections, [day]: { ...taskSelections[day], ders: e.target.value, konu: '', kaynak: '' }})}
                    className="w-full px-2 py-2 bg-slate-50 border border-slate-200 rounded-lg text-xs font-bold text-slate-700 focus:outline-none focus:border-blue-500 cursor-pointer"
                  >
                    <option value="" disabled>1. Ders Seçin...</option>
                    {Object.keys(mufredatVerisi).map(d => <option key={d} value={d}>{d}</option>)}
                  </select>

                  <select
                    value={taskSelections[day]?.konu || ''}
                    onChange={(e) => setTaskSelections({...taskSelections, [day]: { ...taskSelections[day], konu: e.target.value }})}
                    className={`w-full px-2 py-2 border rounded-lg text-xs font-medium focus:outline-none focus:border-blue-500 cursor-pointer transition ${taskSelections[day]?.ders ? 'bg-slate-50 border-slate-200 text-slate-700' : 'bg-slate-100 border-transparent text-slate-400 cursor-not-allowed'}`}
                    disabled={!taskSelections[day]?.ders}
                  >
                    <option value="" disabled>2. Konu Seçin...</option>
                    {taskSelections[day]?.ders && mufredatVerisi[taskSelections[day].ders]?.map(k => <option key={k} value={k}>{k}</option>)}
                  </select>

                  {/* 🚀 KAYNAK SEÇİCİ */}
                  <select
                    value={taskSelections[day]?.kaynak || ''}
                    onChange={(e) => setTaskSelections({...taskSelections, [day]: { ...taskSelections[day], kaynak: e.target.value }})}
                    className={`w-full px-2 py-2 border rounded-lg text-xs font-medium focus:outline-none focus:border-emerald-500 cursor-pointer transition ${taskSelections[day]?.ders && kaynaklarHavuzu[taskSelections[day].ders] ? 'bg-emerald-50 border-emerald-200 text-emerald-800' : 'bg-slate-100 border-transparent text-slate-400 cursor-not-allowed'}`}
                    disabled={!taskSelections[day]?.ders || !kaynaklarHavuzu[taskSelections[day].ders]}
                  >
                    <option value="" disabled>3. Kaynak Seçin (Opsiyonel)</option>
                    {taskSelections[day]?.ders && kaynaklarHavuzu[taskSelections[day].ders] && Object.entries(kaynaklarHavuzu[taskSelections[day].ders]).map(([seviye, kitaplar]) => (
                        <optgroup key={seviye} label={`${seviye} Seviye Kaynaklar`}>
                            {kitaplar.map(kitap => <option key={kitap} value={kitap}>{kitap}</option>)}
                        </optgroup>
                    ))}
                  </select>

                  <div className="flex gap-2">
                    <input 
                      type="number" 
                      placeholder="Hedef Soru (Ops.)" 
                      value={taskSelections[day]?.soru || ''}
                      onChange={(e) => setTaskSelections({...taskSelections, [day]: { ...taskSelections[day], soru: e.target.value }})}
                      className="flex-1 px-2 py-2 bg-slate-50 border border-slate-200 rounded-lg text-xs font-bold text-slate-700 focus:outline-none focus:border-emerald-500" 
                      disabled={!taskSelections[day]?.konu}
                    />
                    <button
                      onClick={() => handleAddSmartTask(day)}
                      disabled={!taskSelections[day]?.konu}
                      className="bg-blue-600 hover:bg-blue-700 disabled:bg-slate-300 text-white p-2 rounded-lg transition flex items-center justify-center w-10 shrink-0"
                    >
                      <Plus className="h-4 w-4"/>
                    </button>
                  </div>

                  {/* 🚀 YENİ: SERBEST GÖREV EKLEME ALANI */}
                  <div className="mt-1 pt-2 border-t border-slate-100 flex gap-2">
                    <input 
                      type="text" 
                      placeholder="Özel görev ekle..." 
                      value={inputs[day] || ''}
                      onChange={(e) => setInputs({...inputs, [day]: e.target.value})}
                      onKeyPress={(e) => e.key === 'Enter' && handleAddTask(day)}
                      className="flex-1 px-2 py-2 bg-slate-50 border border-slate-200 rounded-lg text-xs font-medium text-slate-700 focus:outline-none focus:border-purple-500" 
                    />
                    <button
                      onClick={() => handleAddTask(day)}
                      disabled={!inputs[day] || inputs[day].trim() === ''}
                      className="bg-purple-600 hover:bg-purple-700 disabled:bg-slate-300 text-white p-2 rounded-lg transition flex items-center justify-center w-10 shrink-0"
                    >
                      <Plus className="h-4 w-4"/>
                    </button>
                  </div>

                </div>
              </div>
            ))}
                    </div>

      </>
    )}


    {mainSection === 'tracking' && (
      <>

{activeTab === 'haftalik_plan' && (
  <div className="no-print">
            <div className="flex justify-between items-center mb-6">
               <h3 className="font-black text-xl text-slate-800 flex items-center"><Users className="h-6 w-6 mr-3 text-blue-500"/> Öğrenci Koçluk Merkezi</h3>
               <div className="flex items-center gap-3">
                 {!user?.isPremium && (
                   <span className={`border px-4 py-1.5 rounded-full text-[10px] uppercase tracking-widest font-black shadow-sm flex items-center ${koclukMerkeziVerileri.length >= 5 ? 'bg-red-50 text-red-600 border-red-200 animate-pulse' : 'bg-amber-50 text-amber-600 border-amber-200'}`}>
                     Kapasite: {koclukMerkeziVerileri.length} / 5
                   </span>
                 )}
                 <span className="bg-blue-50 text-blue-700 border border-blue-200 px-4 py-1.5 rounded-full text-xs font-black shadow-sm">{koclukMerkeziVerileri.length} Öğrenci</span>
               </div>
            </div>
            <div className="bg-white rounded-3xl border border-slate-200 overflow-hidden shadow-sm">
              <div className="overflow-auto custom-scrollbar max-h-[520px]">
                <table className="w-full text-left text-sm whitespace-nowrap">
                  <thead className="bg-slate-50 text-slate-400 font-bold uppercase text-[10px] tracking-widest border-b border-slate-100">
                    <tr>
                      <th className="p-5">Öğrenci Bilgisi</th>
                      <th className="p-5 text-center border-l border-slate-100">Plan Durumu</th>
                      <th className="p-5 text-center border-l border-slate-100">Güncel Sistem Durumu</th>
                      <th className="p-5 text-right border-l border-slate-100">Karneler & Raporlar</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100">
                    {koclukMerkeziVerileri.map(ogr => (
                        <tr key={ogr.no} className="hover:bg-slate-50 transition">
                          <td className="p-5">
                            <p className="font-black text-slate-800 text-sm">{ogr.className} - {ogr.no}</p>
                            <p className="text-xs font-medium text-slate-500 mt-0.5">{ogr.label.split('(')[1].replace(')', '')}</p>
                          </td>
                          <td className="p-5 text-center border-l border-slate-50">
                            <span className={`px-3 py-1.5 rounded-lg text-[10px] font-black uppercase tracking-wide border ${ogr.planDurumu === 'AI Makro Plan' ? 'bg-indigo-50 text-indigo-700 border-indigo-200 shadow-sm' : ogr.planDurumu === 'Haftalık Manuel Plan' ? 'bg-blue-50 text-blue-700 border-blue-200 shadow-sm' : 'bg-slate-50 text-slate-500 border-slate-200'}`}>
                                {ogr.planDurumu}
                            </span>
                          </td>
                          <td className="p-5 text-center border-l border-slate-50">
                            <span className={`px-3 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest border shadow-sm ${ogr.durumRenk}`}>
                                {ogr.durum}
                            </span>
                          </td>
                          <td className="p-5 text-right border-l border-slate-50">
                             <div className="flex justify-end gap-2">
                                <button onClick={() => { setSelectedStudent(ogr.no); setPdfModal({ isOpen: true, type: 'efor', student: ogr, expertNote: '' }); }} className="px-4 py-2 bg-white text-emerald-600 hover:bg-emerald-600 hover:text-white rounded-xl font-bold text-xs transition border border-emerald-200 shadow-sm flex items-center group">
                                   <Activity className="h-4 w-4 mr-2 group-hover:animate-pulse"/> Soru / Efor
                                </button>
                                <button onClick={() => { setSelectedStudent(ogr.no); setPdfModal({ isOpen: true, type: 'deneme', student: ogr, expertNote: '' }); }} className="px-4 py-2 bg-white text-blue-600 hover:bg-blue-600 hover:text-white rounded-xl font-bold text-xs transition border border-blue-200 shadow-sm flex items-center group">
                                   <Target className="h-4 w-4 mr-2 group-hover:animate-pulse"/> Deneme / Trend
                                </button>
                             </div>
                          </td>
                        </tr>
                    ))}
                    {koclukMerkeziVerileri.length === 0 && (
                      <tr><td colSpan="4" className="p-8 text-center text-slate-400">Sistemde kayıtlı öğrenci bulunmuyor.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
                   </div>
)}

{activeTab === 'plan_arsivi' && (
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 no-print">
            <h3 className="text-xl font-black text-slate-800 flex items-center mb-6 border-b border-slate-100 pb-4">
              <BookOpen className="h-6 w-6 mr-2 text-indigo-500"/>
Koçluk Program Arşivi
            </h3>
            
            <div className="flex flex-col md:flex-row gap-4 items-center mb-6">
              <select 
                value={aiTargetNo} 
                onChange={(e) => { setAiTargetNo(e.target.value); setSelectedSavedPlanId(''); }} 
                className="px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold w-full md:w-64 focus:outline-none focus:border-indigo-500 text-slate-700 cursor-pointer"
              >
                <option value="">1. Öğrenci Seçin...</option>
                {koclukMerkeziVerileri.map(ogr => (
                  <option key={ogr.no} value={ogr.no}>{ogr.label}</option>
                ))}
              </select>

              <select 
                value={selectedSavedPlanId} 
                onChange={(e) => setSelectedSavedPlanId(e.target.value)} 
                className="px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold w-full md:w-64 focus:outline-none focus:border-indigo-500 text-slate-700 cursor-pointer"
                disabled={!aiTargetNo}
              >
               <option value="">
  2. Kayıtlı Plan Seçin...
</option>

{archivePlans.map(
  plan => {

    const archivePlanId =
      getArchivePlanId(
        plan
      );


    return (
      <option
        key={archivePlanId}
        value={archivePlanId}
      >
        {getArchivePlanLabel(
          plan
        )}
      </option>
    );
  }
)}
              </select>
            </div>

            {selectedSavedPlanId && (
              <div
  className={`p-6 rounded-2xl border animate-in fade-in duration-300 ${
    selectedArchivePlan?.testId === 'smart_plan'
      ? 'bg-slate-50 border-slate-200 shadow-sm'
      : 'bg-slate-950 border-slate-800 shadow-xl'
  }`}
>
  <div
    className={`flex justify-between items-center mb-6 border-b pb-4 ${
      selectedArchivePlan?.testId === 'smart_plan'
        ? 'border-slate-200'
        : 'border-slate-800'
    }`}
  >
    <h4
      className={`text-sm font-black uppercase tracking-widest ${
        selectedArchivePlan?.testId === 'smart_plan'
          ? 'text-emerald-700'
          : 'text-emerald-400'
      }`}
    >
      Arşiv Raporu Aktif
   </h4>


<div className="flex flex-wrap items-center justify-end gap-2">

  {
    isSelectedArchivePlanActive
      ? (
          <span className="px-4 py-2.5 rounded-xl bg-emerald-100 border border-emerald-200 text-emerald-700 text-xs font-black flex items-center">
            <CheckCircle className="h-4 w-4 mr-2" />
            Aktif Plan
          </span>
        )

      : (
          <button
            type="button"

            onClick={() =>
              handleDeleteSubmission(
                getArchivePlanId(
                  selectedArchivePlan
                )
              )
            }

            className="px-4 py-2.5 bg-red-50 hover:bg-red-100 border border-red-200 text-red-700 rounded-xl font-black text-xs transition flex items-center"
          >
            <Trash2 className="h-4 w-4 mr-2" />
            Bu Eski Planı Sil
          </button>
        )
  }


  <button
    type="button"

    onClick={
      () => {

        if (
          selectedArchivePlan?.testId ===
          'smart_plan'
        ) {

          handleSmartArchivePrint();

          return;
        }


        handlePrint(
          'saved-plan-print-area'
        );
      }
    }

    className="px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-bold text-xs transition flex items-center shadow-lg shadow-emerald-900/20"
  >
    <Download className="h-4 w-4 mr-2"/>
    Bu Planı Yazdır / PDF Al
  </button>

</div>

</div>
                
                <div
  id="saved-plan-print-area"
  className={
    selectedArchivePlan?.testId === 'smart_plan'
      ? 'text-slate-800 print:bg-white print:text-black'
      : 'text-slate-100 print:bg-white print:text-black'
  }
>
                    <div className="archive-generic-print-header hidden print:flex justify-between items-center border-b-4 border-slate-900 pb-4 mb-8">
    <div>
        <h1 className="text-2xl font-black tracking-tight text-slate-900">REHBER360</h1>
        <p className="text-[10px] uppercase font-bold tracking-widest text-slate-400">Yapay Zeka Destekli PDR Servisi</p>
    </div>
    <div className="text-right">
        <h2 className="text-sm font-black text-slate-800">Öğrenci Makro Gelişim Planı</h2>
    </div>
</div>
                  
                  {(() => {
                    const selectedPlan =
  selectedArchivePlan;


if (!selectedPlan) {
  return null;
}
                    
                    // ============================================================
// AI MAKRO PLAN
// ============================================================

if (
  selectedPlan.testId ===
  'ai_macro_plan'
) {

  if (
    selectedPlan.progressData &&
    selectedPlan.progressData.length > 0
  ) {

    return renderProgressData(
      selectedPlan.progressData
    );
  }


  return formatPlanAsGrid(
    selectedPlan
      .answers
      ?.planText
  );
}


// ============================================================
// HAFTALIK MANUEL PLAN
// ============================================================

if (
  selectedPlan.testId ===
  'weekly_plan'
) {

  const manualDays =
    GUNLER.map(
      day => ({
        day,

        tasks:
          Array.isArray(
            selectedPlan
              ?.answers
              ?.[day]
          )
            ? selectedPlan
                .answers[day]
            : []
      })
    );


  const totalTasks =
    manualDays.reduce(
      (total, item) =>
        total +
        item.tasks.length,
      0
    );


  const targetQuestionCount =
    selectedPlan
      ?.answers
      ?.hedefSoru;


  return (
    <div className="space-y-5">

      <div className="rounded-2xl border border-blue-800 bg-slate-900 p-5">

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">

          <div>

            <p className="text-[10px] font-black uppercase tracking-widest text-blue-300">
              Haftalık Manuel Plan
            </p>

            <h3 className="text-xl font-black text-white mt-1">
              Gönderilen Haftalık Program
            </h3>

            <p className="text-xs text-slate-400 mt-2">
              {getArchivePlanDateLabel(
                selectedPlan
              )}
            </p>

          </div>


          <div className="flex flex-wrap gap-2">

            <span className="px-3 py-1.5 rounded-full bg-blue-950 border border-blue-800 text-blue-200 text-[10px] font-black">
              {totalTasks} görev
            </span>

            {
              targetQuestionCount
                ? (
                    <span className="px-3 py-1.5 rounded-full bg-emerald-950 border border-emerald-800 text-emerald-200 text-[10px] font-black">
                      Hedef: {targetQuestionCount} soru
                    </span>
                  )
                : null
            }

          </div>

        </div>

      </div>


      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">

        {manualDays.map(
          ({ day, tasks }) => (

            <div
              key={day}
              className="rounded-2xl border border-slate-700 bg-slate-900 overflow-hidden"
            >

              <div className="px-4 py-3 bg-slate-800 border-b border-slate-700 flex items-center justify-between">

                <h4 className="text-sm font-black text-white">
                  {day}
                </h4>

                <span className="text-[10px] font-black text-slate-400">
                  {tasks.length} görev
                </span>

              </div>


              <div className="p-4 space-y-3">

                {
                  tasks.length > 0
                    ? tasks.map(
                        (
                          task,
                          taskIndex
                        ) => (

                          <div
                            key={
                              task?.id ||
                              `${day}-${taskIndex}`
                            }
                            className="rounded-xl border border-slate-700 bg-slate-950 p-3"
                          >

                            <div className="flex items-start gap-3">

                              <span className="mt-0.5 h-5 w-5 rounded-md border border-slate-600 flex items-center justify-center shrink-0 text-[10px] text-slate-500">
                                □
                              </span>

                              <p className="text-xs font-bold leading-relaxed text-slate-200">
                                {
                                  task?.text ||
                                  'Görev bilgisi bulunamadı.'
                                }
                              </p>

                            </div>

                          </div>

                        )
                      )

                    : (
                        <div className="py-6 text-center">

                          <p className="text-xs font-bold text-slate-500">
                            Bu gün için görev bulunmuyor.
                          </p>

                        </div>
                      )
                }

              </div>

            </div>

          )
        )}

      </div>

    </div>
  );
}


// ============================================================
// AKILLI PLAN
// ============================================================

if (
  selectedPlan.testId ===
  'smart_plan'
) {

  const smartAnswers =
    selectedPlan?.answers || {};


  const smartSchedule =
    Array.isArray(
      smartAnswers.schedule
    )
      ? smartAnswers.schedule
      : [];


    const smartTaskLabels = {
    new_topic: 'Yeni Konu',
    practice: 'Soru Çözümü',
    review: 'Planlı Tekrar',
    mixed_practice: 'Karma Soru',

    topic_scan: 'Konu Tarama',
    weekly_scan: 'Haftalık Tarama',

    branch_mock: 'Branş Denemesi',
    full_mock: 'Tam Deneme',
    mock_analysis: 'Deneme Analizi',
    buffer: 'Telafi / Esnek Alan',
    routine: 'Kısa Pekiştirme'
  };


  const smartArchiveTaskStyles = {

    new_topic: {
      card:
        'border-indigo-200 border-l-4 border-l-indigo-500 bg-indigo-50/40',

      checkbox:
        'border-indigo-300 text-indigo-500',

      label:
        'text-indigo-700'
    },


    practice: {
      card:
        'border-blue-200 border-l-4 border-l-blue-500 bg-blue-50/40',

      checkbox:
        'border-blue-300 text-blue-500',

      label:
        'text-blue-700'
    },


    review: {
      card:
        'border-violet-200 border-l-4 border-l-violet-500 bg-violet-50/40',

      checkbox:
        'border-violet-300 text-violet-500',

      label:
        'text-violet-700'
    },


    mixed_practice: {
      card:
        'border-cyan-200 border-l-4 border-l-cyan-500 bg-cyan-50/40',

      checkbox:
        'border-cyan-300 text-cyan-500',

      label:
        'text-cyan-700'
    },


    topic_scan: {
      card:
        'border-teal-200 border-l-4 border-l-teal-600 bg-teal-50/40',

      checkbox:
        'border-teal-300 text-teal-600',

      label:
        'text-teal-700'
    },


    weekly_scan: {
      card:
        'border-sky-200 border-l-4 border-l-sky-600 bg-sky-50/40',

      checkbox:
        'border-sky-300 text-sky-600',

      label:
        'text-sky-700'
    },


    branch_mock: {
      card:
        'border-amber-200 border-l-4 border-l-amber-500 bg-amber-50/40',

      checkbox:
        'border-amber-300 text-amber-600',

      label:
        'text-amber-700'
    },


    full_mock: {
      card:
        'border-orange-200 border-l-4 border-l-orange-500 bg-orange-50/40',

      checkbox:
        'border-orange-300 text-orange-600',

      label:
        'text-orange-700'
    },


    mock_analysis: {
      card:
        'border-rose-200 border-l-4 border-l-rose-500 bg-rose-50/40',

      checkbox:
        'border-rose-300 text-rose-600',

      label:
        'text-rose-700'
    },


    buffer: {
      card:
        'border-slate-200 border-l-4 border-l-slate-500 bg-slate-50',

      checkbox:
        'border-slate-300 text-slate-500',

      label:
        'text-slate-700'
    },


    routine: {
      card:
        'border-emerald-200 border-l-4 border-l-emerald-500 bg-emerald-50/40',

      checkbox:
        'border-emerald-300 text-emerald-600',

      label:
        'text-emerald-700'
    }
  };


  const smartArchiveDefaultTaskStyle = {
    card:
      'border-slate-200 border-l-4 border-l-slate-400 bg-slate-50',

    checkbox:
      'border-slate-300 text-slate-500',

    label:
      'text-slate-700'
  };


  const getSmartArchiveAssessmentGroups =
    task => {

      if (
        task?.type !== 'topic_scan' &&
        task?.type !== 'weekly_scan'
      ) {
        return [];
      }


      const assessmentTopics =
        Array.isArray(
          task?.assessmentTopics
        )
          ? task.assessmentTopics
          : [];


      const grouped =
        new Map();


      assessmentTopics.forEach(
        item => {

          const subject =
            typeof item?.subject === 'string'
              ? item.subject.trim()
              : '';

          const topic =
            typeof item?.topic === 'string'
              ? item.topic.trim()
              : '';


          if (
            !subject ||
            !topic
          ) {
            return;
          }


          if (
            !grouped.has(subject)
          ) {
            grouped.set(
              subject,
              []
            );
          }


          const topics =
            grouped.get(subject);


          if (
            !topics.includes(topic)
          ) {
            topics.push(topic);
          }
        }
      );


      return [
        ...grouped.entries()
      ].map(
        ([subject, topics]) => ({
          subject,
          topics
        })
      );
    };


  const strategyLabel =
    SMART_PLAN_STRATEGY_LABELS[
      smartAnswers.strategyId
    ] ||
    smartAnswers.strategyId ||
    'Belirtilmedi';


  const examLabel =
    smartAnswers.examMode ||
    'Belirtilmedi';


  const levelLabel =
    smartAnswers.studentLevel ||
    smartAnswers.difficulty ||
    null;


  const workingDayCount =
  Array.isArray(
    smartAnswers.workingDays
  )
    ? smartAnswers.workingDays.length
    : 0;


const archiveStudent =
  benzersizOgrenciler.find(
    student =>
      String(student?.no) ===
      String(selectedPlan?.studentNo)
  );


const archiveStudentLabel =
  archiveStudent?.label ||
  [
    selectedPlan?.targetClass,

    selectedPlan?.studentNo
      ? (
          selectedPlan?.studentName
            ? `${selectedPlan.studentNo} (${selectedPlan.studentName})`
            : String(selectedPlan.studentNo)
        )
      : null
  ]
    .filter(Boolean)
    .join(' - ') ||
  'Öğrenci';


const totalTaskCount =
    smartSchedule.reduce(
      (planTotal, week) =>
        planTotal +
        (
          Array.isArray(week?.days)
            ? week.days.reduce(
                (weekTotal, day) =>
                  weekTotal +
                  (
                    Array.isArray(day?.tasks)
                      ? day.tasks.length
                      : 0
                  ),
                0
              )
            : 0
        ),
      0
    );


  return (
    <div className="space-y-6">

      {/* ================================================
          PLAN ÖZETİ
      ================================================= */}

      <div className="archive-smart-summary rounded-2xl border border-violet-200 bg-white p-5 shadow-sm">

        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-5">

          <div>

                       <p className="text-[10px] font-black uppercase tracking-widest text-violet-600">
              Rehber360 • Akıllı Plan
            </p>

            <h3 className="text-xl font-black text-slate-900 mt-1">
              Gönderilen Akıllı Çalışma Planı
            </h3>

            <p className="text-xs text-slate-400 mt-2">
              {getArchivePlanDateLabel(
                selectedPlan
              )}
            </p>

          </div>


          <div className="flex flex-wrap gap-2">

            <span className="px-3 py-1.5 rounded-full bg-violet-50 border border-violet-200 text-violet-700 text-[10px] font-black">
              {smartSchedule.length} Hafta
            </span>

            <span className="px-3 py-1.5 rounded-full bg-indigo-50 border border-indigo-200 text-indigo-700 text-[10px] font-black">
              {totalTaskCount} Görev
            </span>

          </div>

        </div>


        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3 mt-5">

          <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
            <p className="text-[9px] font-black uppercase tracking-wider text-slate-500">
              Sınav
            </p>

            <p className="text-xs font-black text-slate-900 mt-1">
              {examLabel}
            </p>
          </div>


          <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
            <p className="text-[9px] font-black uppercase tracking-wider text-slate-500">
              Strateji
            </p>

            <p className="text-xs font-black text-slate-900 mt-1">
              {strategyLabel}
            </p>
          </div>


          <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
            <p className="text-[9px] font-black uppercase tracking-wider text-slate-500">
              Öğrenci Seviyesi
            </p>

            <p className="text-xs font-black text-slate-900 mt-1">
              {levelLabel || 'Eski kayıt'}
            </p>
          </div>


          <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
            <p className="text-[9px] font-black uppercase tracking-wider text-slate-500">
              Günlük Süre
            </p>

            <p className="text-xs font-black text-slate-900 mt-1">
              {
                smartAnswers.dailyMinutes
                  ? `${smartAnswers.dailyMinutes} dk`
                  : 'Belirtilmedi'
              }
            </p>
          </div>


          <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
            <p className="text-[9px] font-black uppercase tracking-wider text-slate-500">
              Çalışma Günü
            </p>

            <p className="text-xs font-black text-slate-900 mt-1">
              {
                workingDayCount > 0
                  ? `${workingDayCount} gün`
                  : 'Belirtilmedi'
              }
            </p>
          </div>


          <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
            <p className="text-[9px] font-black uppercase tracking-wider text-slate-500">
              Alan
            </p>

            <p className="text-xs font-black text-slate-900 mt-1">
              {smartAnswers.field || '—'}
            </p>
          </div>

        </div>


        {
          Array.isArray(
            smartAnswers.selectedSubjects
          ) &&
          smartAnswers.selectedSubjects.length > 0
            ? (
                <div className="mt-4">

                  <p className="text-[9px] font-black uppercase tracking-wider text-slate-500 mb-2">
                    Planlanan Dersler
                  </p>

                  <div className="flex flex-wrap gap-2">

                    {smartAnswers.selectedSubjects.map(
                      subject => (

                        <span
                          key={subject}
                          className="px-2.5 py-1 rounded-lg border border-slate-200 bg-slate-50 text-[10px] font-bold text-slate-600"
                        >
                          {subject}
                        </span>

                      )
                    )}

                  </div>

                </div>
              )
            : null
        }

      </div>


      {/* ================================================
          HAFTALAR
      ================================================= */}

      {
        smartSchedule.length === 0
          ? (
              <div className="rounded-2xl border border-amber-800 bg-amber-950/30 p-5">

                <p className="text-sm font-black text-amber-200">
                  Bu kayıtta haftalık plan verisi bulunamadı.
                </p>

              </div>
            )

          : smartSchedule.map(
              (
                week,
                weekIndex
              ) => {

                const weekDays =
  Array.isArray(
    week?.days
  )
    ? week.days
    : [];


const weekTaskCount =
  weekDays.reduce(
    (total, day) =>
      total +
      (
        Array.isArray(
          day?.tasks
        )
          ? day.tasks.length
          : 0
      ),
    0
  );


const maxTasksPerDay =
  weekDays.reduce(
    (maximum, day) => {

      const taskCount =
        Array.isArray(
          day?.tasks
        )
          ? day.tasks.length
          : 0;


      return Math.max(
        maximum,
        taskCount
      );
    },
    0
  );


const archivePrintDensityClass =
  (
    maxTasksPerDay >= 5 ||
    weekTaskCount >= 22
  )
    ? 'archive-print-density-dense'

    : (
        maxTasksPerDay >= 4 ||
        weekTaskCount >= 15 ||
        (
          weekDays.length >= 6 &&
          weekTaskCount >= 12
        )
      )
      ? 'archive-print-density-compact'

      : 'archive-print-density-normal';


const archivePrintDayClass =
  weekDays.length >= 1 &&
  weekDays.length <= 7
    ? `archive-print-days-${weekDays.length}`
    : 'archive-print-days-default';


return (
                  <div
  key={
    week?.weekNumber ||
    `smart-week-${weekIndex}`
  }
  className={`archive-smart-week ${archivePrintDensityClass} ${archivePrintDayClass} rounded-2xl border border-slate-200 overflow-hidden bg-white shadow-sm`}
>

                    <div className="archive-smart-week-header px-5 py-3.5 bg-violet-50 border-b border-violet-100 flex items-center justify-between gap-4">

                      <div>

                        <p className="text-[9px] font-black uppercase tracking-widest text-violet-600">
                          Akıllı Plan
                        </p>

                        <h4 className="text-sm font-black text-slate-900 mt-0.5">
                          {
                            week?.weekNumber ||
                            weekIndex + 1
                          }. Hafta
                        </h4>

                      </div>


                      <span className="px-3 py-1.5 rounded-full border border-violet-200 bg-white text-[10px] font-black text-violet-700">
                        {weekDays.length} çalışma günü
                      </span>

                   </div>


<div className="archive-smart-print-info hidden">

  <div>
    <span>Öğrenci</span>
    <strong>
      {archiveStudentLabel}
    </strong>
  </div>

  <div>
    <span>Sınav</span>
    <strong>
      {examLabel}
    </strong>
  </div>

  <div>
    <span>Günlük Hedef</span>
    <strong>
      {
        smartAnswers.dailyMinutes
          ? `${smartAnswers.dailyMinutes} dk`
          : '—'
      }
    </strong>
  </div>

  <div>
    <span>Strateji</span>
    <strong>
      {strategyLabel}
    </strong>
  </div>

</div>


<div className="archive-smart-days grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 p-4 bg-slate-50/70">

                      {weekDays.map(
                        (
                          day,
                          dayIndex
                        ) => {

                          const dayTasks =
                            Array.isArray(
                              day?.tasks
                            )
                              ? day.tasks
                              : [];


                          return (
                            <div
                              key={
                                `${week?.weekNumber || weekIndex}-${day?.day || dayIndex}`
                              }
                              className="archive-smart-day rounded-xl border border-slate-200 bg-white overflow-hidden shadow-sm"
                            >

                              <div className="archive-smart-day-header px-4 py-3 border-b border-slate-200 bg-white flex items-center justify-between gap-3">

                                <div>

                                  <h5 className="text-xs font-black text-slate-800">
                                    {day?.day || 'Gün'}
                                  </h5>

                                  <p className="text-[9px] font-bold text-slate-500 mt-0.5">
                                    {dayTasks.length} görev
                                  </p>

                                </div>


                                <span className="px-2.5 py-1 rounded-full bg-slate-100 border border-slate-200 text-[9px] font-black text-slate-600">
                                  {day?.totalMinutes || 0}
                                  {
                                    smartAnswers.dailyMinutes
                                      ? ` / ${smartAnswers.dailyMinutes}`
                                      : ''
                                  } dk
                                </span>

                              </div>


                              <div className="archive-smart-tasks p-3 space-y-2.5">

                                {
                                  dayTasks.length === 0
                                    ? (
                                        <p className="text-xs text-slate-500 italic py-3 text-center">
                                          Bu gün için görev bulunmuyor.
                                        </p>
                                      )

                                    : dayTasks.map(
                                        (
                                          task,
                                          taskIndex
                                        ) => {

                                                                                    const taskLabel =
                                            smartTaskLabels[
                                              task?.type
                                            ] ||
                                            task?.type ||
                                            'Görev';


                                          const assessmentGroups =
                                            getSmartArchiveAssessmentGroups(
                                              task
                                            );


                                                                                    const assessmentTopicCount =
                                            assessmentGroups.reduce(
                                              (total, group) =>
                                                total +
                                                group.topics.length,
                                              0
                                            );


                                          const taskStyle =
                                            smartArchiveTaskStyles[
                                              task?.type
                                            ] ||
                                            smartArchiveDefaultTaskStyle;


                                          return (
                                                                                      <div
  key={
    task?.id ||
    `${day?.day}-${taskIndex}`
  }
  data-task-type={
    task?.type ||
    ''
  }
  className={`archive-smart-task rounded-xl border p-3 transition ${taskStyle.card}`}
>

                                              <div className="archive-smart-task-top flex items-start justify-between gap-3">

  <div className="archive-smart-task-type flex items-center gap-2 min-w-0">

    <span
  className={`archive-smart-checkbox h-5 w-5 rounded-md border flex items-center justify-center shrink-0 text-[10px] font-black ${
    task?.completed
      ? 'bg-emerald-500 border-emerald-500 text-white'
      : `bg-white ${taskStyle.checkbox}`
  }`}
>
  {task?.completed ? '✓' : '□'}
</span>

    <span
      className={`archive-smart-task-label text-[9px] font-black uppercase tracking-wider ${taskStyle.label}`}
    >
      {taskLabel}
    </span>

  </div>

  <span className="archive-smart-task-duration text-[9px] font-black text-slate-400 whitespace-nowrap">
    {task?.duration || 0} dk
  </span>

</div>


                                              {
                                                task?.subject
                                                  ? (
                                                      <p className="archive-smart-task-subject text-xs font-black text-slate-800 mt-2.5">
  {task.subject}
</p>
                                                    )
                                                  : null
                                              }


                                                                                            {
                                                task?.topic
                                                  ? (
                                                      <p className="archive-smart-task-topic text-[11px] font-bold text-slate-600 mt-1">
  {task.topic}
</p>
                                                    )
                                                  : null
                                              }


                                              {
                                                assessmentTopicCount > 0
                                                  ? (
                                                      <div className="archive-smart-assessment mt-2.5 rounded-lg border border-sky-200 bg-sky-50 p-2.5">

                                                        <p className="archive-smart-assessment-title text-[9px] font-black uppercase tracking-wider text-sky-700">
  Tarama kapsamı · {assessmentTopicCount} konu
</p>

<div className="archive-smart-assessment-groups mt-1.5 space-y-1.5">

  {assessmentGroups.map(
    group => (
      <div
        key={group.subject}
        className="archive-smart-assessment-group"
      >

        <p className="archive-smart-assessment-subject text-[10px] font-black text-slate-700">
          {group.subject}
        </p>

        <p className="archive-smart-assessment-topics text-[10px] font-bold text-slate-500 mt-0.5 leading-relaxed">
          {group.topics.join(' • ')}
        </p>

                                                              </div>
                                                            )
                                                          )}

                                                        </div>

                                                      </div>
                                                    )
                                                  : null
                                              }


                                              {
                                                task?.questionCount ||
                                                task?.resource
                                                  ? (
                                                      <p className="archive-smart-task-meta text-[10px] text-slate-500 mt-2">

                                                        {
                                                          task?.questionCount
                                                            ? `${task.questionCount} soru`
                                                            : ''
                                                        }

                                                        {
                                                          task?.questionCount &&
                                                          task?.resource
                                                            ? ' • '
                                                            : ''
                                                        }

                                                        {task?.resource || ''}

                                                      </p>
                                                    )
                                                  : null
                                              }

                                            </div>
                                          );
                                        }
                                      )
                                }

                              </div>

                            </div>
                          );
                        }
                      )}

                    </div>

                  </div>
                );
              }
            )
      }

    </div>
  );
}


// Bilinmeyen plan tipi için güvenli geri dönüş.
return null;
                  })()}
                </div>
              </div>
                                             )}
          </div>
)}

      </>
    )}

        </div>

     ) : mainSection === 'tracking' && activeTab === 'ogrenci_rontgeni' ? (
  <div id="rontgen-print-area" className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 min-h-[500px] print:p-0 print:border-none print:shadow-none">
           
           {/* 🚀 YENİ: PDF KURUMSAL BAŞLIK (Sadece Yazdırırken Görünür) */}
           <div className="hidden print:flex justify-between items-center border-b-4 border-slate-900 pb-4 mb-8">
              <div>
                  <h1 className="text-2xl font-black tracking-tight text-slate-900">{user?.schoolName || "REHBER360"}</h1>
                  <p className="text-[10px] uppercase font-bold tracking-widest text-slate-400">Psikolojik Danışmanlık ve Rehberlik Servisi</p>
              </div>
              <div className="text-right">
                  <h2 className="text-sm font-black text-slate-800">Akademik Röntgen ve Efor Raporu</h2>
                  <p className="text-[10px] text-slate-500 font-bold">Öğrenci: {benzersizOgrenciler.find(o => String(o.no) === String(selectedStudent))?.label || (demoModuAktif ? "Demo Öğrenci" : "")}</p>
              </div>
           </div>

           <div className="flex flex-col md:flex-row justify-between items-center mb-8 border-b pb-4 border-slate-100 no-print">
              <div>
                <h2 className="text-2xl font-black text-slate-800 flex items-center"><Activity className="h-6 w-6 mr-2 text-indigo-500"/> Öğrenci Röntgeni</h2>
                <p className="text-slate-500 text-sm">Öğrencilerin girdikleri günlük soru sayıları ve başarı oranları.</p>
              </div>

              <div className="mt-4 md:mt-0 flex flex-col md:flex-row gap-3 w-full md:w-auto">
                {/* 🚀 YENİ: Demo Modu Tetikleyicisi */}
                <button 
                  onClick={() => setDemoModuAktif(!demoModuAktif)}
                  className={`px-4 py-3 rounded-xl font-bold text-xs transition border-2 flex items-center shadow-sm ${demoModuAktif ? 'bg-amber-100 border-amber-400 text-amber-700' : 'bg-slate-50 border-slate-200 text-slate-500 hover:bg-slate-100'}`}
                >
                  {demoModuAktif ? '🧪 Demo Aktif' : 'Test Verisi Yükle'}
                </button>
                {/* 🚀 YENİ: Gölge Rakip (Benchmarking) Seçicisi */}
                <div className="w-full md:w-64 relative">
                  <select 
                    value={seciliHedefProfil} 
                    onChange={(e) => setSeciliHedefProfil(e.target.value)}
                    className="w-full appearance-none bg-indigo-600 border-2 border-indigo-700 text-white font-bold py-3 px-4 pr-10 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-400 cursor-pointer shadow-sm"
                  >
                    <option value="">Hedef Profil (Gölge Rakip)</option>
                    {Object.keys(HEDEF_PROFILLER).map(profil => (
                      <option key={profil} value={profil}>{profil}</option>
                    ))}
                  </select>
                  <ChevronDown className="absolute right-4 top-1/2 transform -translate-y-1/2 text-indigo-300 pointer-events-none" />
                </div>
                <div className="w-full md:w-44 relative">
                  <select 
                    value={timeFilter}
                    onChange={(e) => setTimeFilter(e.target.value)}
                    className="w-full appearance-none bg-indigo-50 border-2 border-indigo-100 text-indigo-700 font-bold py-3 px-4 pr-10 rounded-xl focus:outline-none focus:border-indigo-500 cursor-pointer"
                  >
                    <option value="all">⏳ Tüm Zamanlar</option>
                    <option value="7days">📅 Son 7 Gün</option>
                    <option value="30days">🗓️ Son 30 Gün</option>
                  </select>
                  <ChevronDown className="absolute right-4 top-1/2 transform -translate-y-1/2 text-indigo-400 pointer-events-none" />
                </div>
                <div className="w-full md:w-72 relative">
                  <select 
                    value={selectedStudent} 
                    onChange={(e) => setSelectedStudent(e.target.value)}
                    className="w-full appearance-none bg-slate-50 border-2 border-slate-200 text-slate-700 font-bold py-3 px-4 pr-10 rounded-xl focus:outline-none focus:border-indigo-500 cursor-pointer"
                  >
                    <option value="">Röntgeni Çekilecek Öğrenciyi Seç</option>
                    {koclukMerkeziVerileri.map(ogr => (
                      <option key={ogr.no} value={ogr.no}>{ogr.label}</option>
                    ))}
                  </select>
                  <ChevronDown className="absolute right-4 top-1/2 transform -translate-y-1/2 text-slate-400 pointer-events-none" />
                </div>
              </div>
           </div>

                         
           <div className="flex flex-wrap gap-2 mb-6 no-print">

             <button
               type="button"
               onClick={() => setSoruEforTab('genel')}
               className={`px-4 py-2.5 rounded-xl text-xs font-black transition ${
                 soruEforTab === 'genel'
                   ? 'bg-indigo-600 text-white shadow-sm'
                   : 'bg-slate-50 border border-slate-200 text-slate-600 hover:border-indigo-200'
               }`}
             >
               Genel Bakış
             </button>

             <button
               type="button"
               onClick={() => setSoruEforTab('ders')}
               className={`px-4 py-2.5 rounded-xl text-xs font-black transition ${
                 soruEforTab === 'ders'
                   ? 'bg-indigo-600 text-white shadow-sm'
                   : 'bg-slate-50 border border-slate-200 text-slate-600 hover:border-indigo-200'
               }`}
             >
               Ders Dağılımı
             </button>

             <button
               type="button"
               onClick={() => setSoruEforTab('efor')}
               className={`px-4 py-2.5 rounded-xl text-xs font-black transition ${
                 soruEforTab === 'efor'
                   ? 'bg-indigo-600 text-white shadow-sm'
                   : 'bg-slate-50 border border-slate-200 text-slate-600 hover:border-indigo-200'
               }`}
             >
               Efor & Öncelik
             </button>

             <button
               type="button"
               onClick={() => setSoruEforTab('haftalik')}
               className={`px-4 py-2.5 rounded-xl text-xs font-black transition ${
                 soruEforTab === 'haftalik'
                   ? 'bg-indigo-600 text-white shadow-sm'
                   : 'bg-slate-50 border border-slate-200 text-slate-600 hover:border-indigo-200'
               }`}
             >
               Haftalık Geçmiş
             </button>

           </div>


           

           {(!selectedStudent && !demoModuAktif) ? (
             <div className="flex flex-col items-center justify-center h-64 text-slate-400">
               <Target className="h-16 w-16 mb-4 opacity-20"/>
               <p className="font-bold text-lg">Analiz İçin Öğrenci Seçin</p>
               <p className="text-sm">Yukarıdaki menüden veri girişi yapmış bir öğrenci seçmeli veya Demo Modu'nu açmalısınız.</p>
             </div>
           ) : (seciliOgrenciVerisi.length === 0 && !demoModuAktif) ? (
             <div className="flex flex-col items-center justify-center h-64 text-slate-400">
               <BookOpen className="h-16 w-16 mb-4 opacity-20"/>
               <p className="font-bold text-lg">Veri Bulunamadı</p>
               <p className="text-sm">Bu öğrenci henüz soru girişi yapmamış.</p>
             </div>
           ) : (
                          <div className="animate-in fade-in zoom-in-95 duration-300">

               <div
                 className={`${
                   soruEforTab === 'genel' ? 'block' : 'hidden'
                 } print:block`}
               >

                <div className="bg-slate-50 p-6 rounded-3xl border border-slate-200 mb-8 shadow-inner">
                   <div className="flex flex-col md:flex-row justify-between items-center mb-6">
                      <div>
                         <h3 className="font-black text-slate-800 text-lg">Soru Çözüm Hedefi</h3>
                         <p className="text-sm font-medium text-slate-500">Öğrencinin anlık durumu ve hedefe kalan mesafe</p>
                      </div>
                      <div className="text-right mt-2 md:mt-0">
                         <span className="text-4xl font-black text-indigo-600">{toplamSoru}</span>
                         <span className="text-lg font-bold text-slate-400"> / {hedefSoru} Soru</span>
                      </div>
                   </div>

                   <div className="w-full bg-slate-200 rounded-full h-4 mb-2 overflow-hidden shadow-inner">
                      <div 
                        className={`h-4 rounded-full transition-all duration-1000 ${basariYuzdesi >= 100 ? 'bg-emerald-500' : basariYuzdesi > 50 ? 'bg-indigo-500' : 'bg-amber-500'}`} 
                        style={{ width: `${basariYuzdesi}%` }}
                      ></div>
                   </div>
                   <div className="flex justify-between text-xs font-bold mb-6">
                      <span className={basariYuzdesi < 50 ? "text-amber-500" : "text-slate-400"}>Başlangıç</span>
                      <span className="text-indigo-600">%{basariYuzdesi} Tamamlandı</span>
                      <span className={basariYuzdesi >= 100 ? "text-emerald-500" : "text-slate-400"}>Hedef ({hedefSoru})</span>
                   </div>

                   <div className="grid grid-cols-2 gap-4 border-t border-slate-200 pt-6">
                      <div className="bg-white p-4 rounded-2xl border border-slate-100 flex items-center justify-between shadow-sm">
                         <div>
                            <p className="text-[10px] font-bold text-emerald-500 uppercase tracking-widest">Doğru Sayısı</p>
                            <p className="text-2xl font-black text-slate-800">{toplamDogru}</p>
                         </div>
                         <div className="h-10 w-10 bg-emerald-50 rounded-full flex items-center justify-center text-emerald-500 font-bold text-xs">
                            %{toplamSoru > 0 ? Math.round((toplamDogru/toplamSoru)*100) : 0}
                         </div>
                      </div>
                      <div className="bg-white p-4 rounded-2xl border border-slate-100 flex items-center justify-between shadow-sm">
                         <div>
                            <p className="text-[10px] font-bold text-red-500 uppercase tracking-widest">Yanlış Sayısı</p>
                            <p className="text-2xl font-black text-slate-800">{toplamYanlis}</p>
                         </div>
                         <div className="h-10 w-10 bg-red-50 rounded-full flex items-center justify-center text-red-500 font-bold text-xs">
                            %{toplamSoru > 0 ? Math.round((toplamYanlis/toplamSoru)*100) : 0}
                         </div>
                      </div>
                   </div>
                </div>
              
                <div className="mb-8 space-y-3">
                  
                  {/* 🚀 YENİ: ZAMAN HIRSIZI RADARI ARAYÜZÜ */}
                  {zamanHirsizlari && zamanHirsizlari.length > 0 && (
                    <div className="bg-indigo-50 border-l-4 border-indigo-500 p-4 rounded-r-xl shadow-sm flex items-start animate-in slide-in-from-left-2 duration-500">
                      <Activity className="h-5 w-5 text-indigo-500 mr-3 mt-0.5 flex-shrink-0 animate-pulse" />
                      <div className="w-full">
                        <h4 className="text-indigo-800 font-bold text-sm">⏱️ Zaman Hırsızı Tespit Edildi</h4>
                        <p className="text-indigo-700 text-xs mt-1 mb-3">Bazı derslerde soru başına harcanan süre, Türkiye geneli ideal standartların oldukça üzerinde. Sınavda zaman problemi yaşanabilir.</p>
                        <div className="flex flex-col gap-2">
                          {zamanHirsizlari.slice(0, 2).map((zh, idx) => (
                            <div key={idx} className="bg-white/60 p-2.5 rounded-lg border border-indigo-100 flex justify-between items-center text-xs shadow-sm">
                              <span className="font-bold text-slate-700 uppercase tracking-wide">{zh.ders}</span>
                              <div className="flex items-center gap-3">
                                <span className="text-slate-500">İdeal: <span className="font-medium text-slate-700">{zh.limit} dk</span></span>
                                <span className="text-red-500 font-black">Harcanan: {zh.ortalama.toFixed(1)} dk</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}

                  {basariYuzdesi < 50 && toplamSoru > 0 && (
                    <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-xl shadow-sm flex items-start animate-in slide-in-from-left-2 duration-500">
                      <Activity className="h-5 w-5 text-amber-500 mr-3 mt-0.5 flex-shrink-0" />
                      <div>
                        <h4 className="text-amber-800 font-bold text-sm">Hedefin Gerisindeyiz</h4>
                        <p className="text-amber-700 text-xs mt-1">Öğrenci şu an belirlediğiniz soru hedefinin yarısına bile ulaşamadı. Motivasyon veya planlama desteği gerekebilir.</p>
                      </div>
                    </div>
                  )}
                  
                  {konuDetaylari.filter(k => k.toplam >= 5 && (k.yanlis / k.toplam) >= 0.4).slice(0, 2).map((k, idx) => (
                    <div key={idx} className="bg-red-50 border-l-4 border-red-500 p-4 rounded-r-xl shadow-sm flex items-start animate-in slide-in-from-left-2 duration-500 delay-150">
                      <Target className="h-5 w-5 text-red-500 mr-3 mt-0.5 flex-shrink-0" />
                      <div>
                        <h4 className="text-red-800 font-bold text-sm">Kritik Kanama Noktası: {k.ders}</h4>
                        <p className="text-red-700 text-xs mt-1">
                          <span className="font-bold">"{k.konu}"</span> konusunda çözülen {k.toplam} sorunun {k.yanlis} tanesi yanlış (Hata Oranı: %{Math.round((k.yanlis/k.toplam)*100)}). Acil konu tekrarı önerilir!
                        </p>
                      </div>
                    </div>
                  ))}
                  
                  {toplamSoru > 0 && basariYuzdesi >= 80 && (
                    <div className="bg-emerald-50 border-l-4 border-emerald-500 p-4 rounded-r-xl shadow-sm flex items-start animate-in slide-in-from-left-2 duration-500">
                      <CheckCircle className="h-5 w-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" />
                      <div>
                        <h4 className="text-emerald-800 font-bold text-sm">Harika İlerleme</h4>
                        <p className="text-emerald-700 text-xs mt-1">Öğrenci hedefine çok yakın veya ulaşmış durumda. Bu istikrarı için kesinlikle tebrik edilmeli!</p>
                      </div>
                    </div>
                                    )}
                </div>

               </div>


               <div
                 className={`${
                   soruEforTab === 'ders' ? 'block' : 'hidden'
                 } print:block`}
               >

              <div className="flex flex-col lg:flex-row gap-6 mb-8 break-inside-avoid print-force-row">
                    <div className="w-full lg:w-1/2 h-[300px] bg-slate-50 rounded-2xl border border-slate-100 p-4 shadow-inner print:h-[200px] print:bg-white print:border-slate-300 print:shadow-none print:p-2 flex flex-col overflow-hidden print-force-half">
                        <h3 className="font-bold text-slate-600 mb-2 text-center text-xs uppercase tracking-wider shrink-0">Ders Bazlı Başarı Oranı (%)</h3>
                        <div className="w-full flex-1 min-h-0 relative">
                            <ResponsiveContainer width="99%" height="100%">
                                <RadarChart cx="50%" cy="50%" outerRadius="70%" data={radarData}>
                                    <PolarGrid stroke="#cbd5e1" />
                                    <PolarAngleAxis dataKey="subject" tick={{fill: '#475569', fontSize: 9, fontWeight: 'bold'}} />
                                    <PolarRadiusAxis angle={30} domain={[0, 100]} tick={{fill: '#94a3b8', fontSize: 9}} />
                                    <Radar name="Öğrenci Başarısı" dataKey="ogrenci" isAnimationActive={false} stroke="#6366f1" fill="#818cf8" fillOpacity={0.6} />
                                    {seciliHedefProfil && (
                                       <Radar name="Gölge Rakip (Hedef)" dataKey="hedef" isAnimationActive={false} stroke="#f59e0b" fill="#fbbf24" fillOpacity={0.3} strokeDasharray="5 5" />
                                    )}
                                    <Tooltip contentStyle={{ borderRadius: '10px', fontSize: '12px' }}/>
                                    <Legend wrapperStyle={{fontSize: '9px', fontWeight: 'bold', paddingTop: '5px'}}/>
                                </RadarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>

                    <div className="w-full lg:w-1/2 h-[300px] bg-slate-50 rounded-2xl border border-slate-100 p-4 shadow-inner print:h-[200px] print:bg-white print:border-slate-300 print:shadow-none print:p-2 flex flex-col overflow-hidden print-force-half">
                        <h3 className="font-bold text-slate-600 mb-2 text-center text-xs uppercase tracking-wider shrink-0">Çözülen Soru Dağılımı</h3>
                        <div className="w-full flex-1 min-h-0 relative">
                            <ResponsiveContainer width="99%" height="100%">
                                <BarChart data={seciliOgrenciVerisi} margin={{ top: 5, right: 10, left: -20, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0"/>
                                <XAxis dataKey="name" tick={{fontSize: 9, fontWeight: 'bold', fill: '#64748b'}} axisLine={false} tickLine={false}/>
                                <YAxis tick={{fontSize: 9, fill: '#94a3b8'}} axisLine={false} tickLine={false}/>
                                <Tooltip cursor={{fill: '#f1f5f9'}} contentStyle={{ borderRadius: '10px', fontSize: '12px' }}/>
                                <Bar dataKey="toplam" isAnimationActive={false} radius={[4, 4, 0, 0]} barSize={20}>
                                    {seciliOgrenciVerisi.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={index % 2 === 0 ? '#10b981' : '#34d399'} />
                                    ))}
                                </Bar>
                                </BarChart>
                           </ResponsiveContainer>
                        </div>
                                        </div>
                </div>

               </div>


               <div
                 className={`${
                   soruEforTab === 'efor' ? 'block' : 'hidden'
                 } print:block`}
               >

               {/* 🚀 YENİ: EFOR - VERİM MATRİSİ ARAYÜZÜ */}
                <div className="h-[450px] print:h-auto bg-slate-900 rounded-3xl border border-slate-800 p-6 shadow-2xl mb-8 relative overflow-hidden animate-in zoom-in-95 duration-500 flex flex-col break-inside-avoid print:p-4 pdf-matrix-box">
                    <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500/10 rounded-full blur-3xl pointer-events-none print:hidden"></div>
                    <div className="absolute bottom-0 left-0 w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none print:hidden"></div>
                    
                    <div className="text-center mb-6 print:mb-2 relative z-10 shrink-0">
                        <h3 className="font-black text-white text-sm uppercase tracking-widest flex items-center justify-center pdf-matrix-title"><Target className="h-4 w-4 mr-2 text-indigo-400"/> Efor - Verim Matrisi</h3>
                        <p className="text-xs text-slate-400 mt-2 print:mt-1 max-w-2xl mx-auto print:text-[8px] leading-tight pdf-matrix-desc">
                            <span className="text-emerald-400 print:text-emerald-600 font-bold">Sağ Üst:</span> Yıldız Dersler (Çok Efor, Yüksek Verim) | 
                            <span className="text-red-400 print:text-red-600 font-bold"> Sağ Alt:</span> Kanayan Yaralar (Çok Efor, Düşük Verim) <br className="hidden print:block"/>
                            <span className="text-blue-400 print:text-blue-600 font-bold"> Sol Üst:</span> Potansiyeller (Az Efor, Yüksek Verim) | 
                            <span className="text-amber-400 print:text-amber-600 font-bold"> Sol Alt:</span> Gelişime Açık (Az Efor, Düşük Verim)
                        </p>
                    </div>
                    
                    <div className="w-full flex-1 min-h-0 relative z-10 print:h-[200px] print:flex-none">
                        <ResponsiveContainer width="99%" height="100%">
                            <ScatterChart margin={{ top: 20, right: 30, bottom: 20, left: 0 }}>
                                <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
                                <XAxis type="number" dataKey="efor" name="Efor (Süre/Soru)" tick={{fontSize: 11, fill: '#94a3b8'}} axisLine={{stroke: '#475569'}} tickLine={false} />
                                <YAxis type="number" dataKey="verim" name="Verim (%)" domain={[0, 100]} tick={{fontSize: 11, fill: '#94a3b8'}} axisLine={{stroke: '#475569'}} tickLine={false} />
                                <ZAxis type="number" dataKey="soru" range={[100, 800]} name="Çözülen Soru" />
                                <Tooltip cursor={{strokeDasharray: '3 3'}} content={({ active, payload }) => {
                                    if (active && payload && payload.length) {
                                        const data = payload[0].payload;
                                        return (
                                            <div className="bg-white text-slate-800 p-4 rounded-xl text-xs shadow-xl border border-slate-100">
                                                <p className="font-black mb-2 text-sm border-b pb-1">{data.ders}</p>
                                                <p className="text-indigo-600 font-bold">Harcanan Efor: {data.efor.toFixed(1)} dk</p>
                                                <p className="text-emerald-600 font-bold">Alınan Verim: %{data.verim}</p>
                                                <p className="text-slate-500 font-medium mt-1">Soru Hacmi: {data.soru} soru</p>
                                            </div>
                                        );
                                    }
                                    return null;
                                }} />
                                <ReferenceLine x={ortalamaEfor} stroke="#cbd5e1" strokeDasharray="5 5" opacity={0.5} />
                                <ReferenceLine y={ortalamaVerim} stroke="#cbd5e1" strokeDasharray="5 5" opacity={0.5} />
                                <Scatter name="Dersler" data={eforVerimData} isAnimationActive={false} fill="#6366f1">
                                    {eforVerimData.map((entry, index) => {
                                        let dotColor = '#94a3b8';
                                        if (entry.verim >= ortalamaVerim && entry.efor >= ortalamaEfor) dotColor = '#10b981'; 
                                        else if (entry.verim < ortalamaVerim && entry.efor >= ortalamaEfor) dotColor = '#ef4444'; 
                                        else if (entry.verim >= ortalamaVerim && entry.efor < ortalamaEfor) dotColor = '#3b82f6'; 
                                        else if (entry.verim < ortalamaVerim && entry.efor < ortalamaEfor) dotColor = '#f59e0b'; 
                                        
                                        return <Cell key={`cell-${index}`} fill={dotColor} />
                                    })}
                                </Scatter>
                            </ScatterChart>
                        </ResponsiveContainer>
                    </div>

                    {/* 🚀 YENİ: PDF İÇİN EFOR MATRİSİ DETAY TABLOSU (Sadece Yazdırırken Görünür) */}
                    <div className="hidden print:block mt-4 relative z-10 w-full">
                        <table className="w-full text-left border-collapse">
                            <thead>
                                <tr className="bg-slate-100 border-b border-slate-300">
                                    <th className="p-2 w-8 text-center text-[7px] text-slate-500 uppercase tracking-widest">Renk</th>
                                    <th className="p-2 text-[7px] text-slate-500 uppercase tracking-widest">Ders</th>
                                    <th className="p-2 text-center text-[7px] text-slate-500 uppercase tracking-widest">Harcanan Efor</th>
                                    <th className="p-2 text-center text-[7px] text-slate-500 uppercase tracking-widest">Alınan Verim</th>
                                    <th className="p-2 text-center text-[7px] text-slate-500 uppercase tracking-widest">Durum Özeti</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                                {eforVerimData.map((data, idx) => {
                                    let dotColorClass = 'bg-slate-400';
                                    let durumMetni = '-';
                                    if (data.verim >= ortalamaVerim && data.efor >= ortalamaEfor) { dotColorClass = 'bg-emerald-500'; durumMetni = 'Yıldız Ders (Yüksek Verim)'; }
                                    else if (data.verim < ortalamaVerim && data.efor >= ortalamaEfor) { dotColorClass = 'bg-red-500'; durumMetni = 'Kanayan Yara (Düşük Verim)'; }
                                    else if (data.verim >= ortalamaVerim && data.efor < ortalamaEfor) { dotColorClass = 'bg-blue-500'; durumMetni = 'Potansiyel (Yüksek Verim)'; }
                                    else if (data.verim < ortalamaVerim && data.efor < ortalamaEfor) { dotColorClass = 'bg-amber-500'; durumMetni = 'Gelişime Açık (Düşük Verim)'; }
                                    
                                    return (
                                        <tr key={idx} className="border-b border-slate-100">
                                            <td className="p-2 flex justify-center items-center">
                                                <div className={`w-3 h-3 rounded-full ${dotColorClass}`}></div>
                                            </td>
                                            <td className="p-2 font-bold text-slate-800 text-[8px]">{data.ders}</td>
                                            <td className="p-2 text-center font-medium text-slate-600 text-[8px]">{data.efor.toFixed(1)} birim</td>
                                            <td className="p-2 text-center font-bold text-slate-800 text-[8px]">%{data.verim}</td>
                                            <td className="p-2 text-center font-bold text-[8px] text-slate-600">{durumMetni}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="mt-8 print:mt-12 break-inside-avoid">
                    <div className="flex justify-between items-end border-b border-slate-200 pb-3 mb-4">
                        <h3 className="font-bold text-slate-800 flex items-center text-sm uppercase tracking-widest">
                            <Target className="h-5 w-5 mr-2 text-indigo-500"/> Akademik Öncelik Haritası
                        </h3>
                        <div className="flex flex-wrap gap-3 text-[10px] font-bold uppercase tracking-wider">
    <span className="flex items-center text-red-600"><div className="w-2 h-2 rounded-full bg-red-500 mr-1.5"></div> Öncelikli Destek</span>
    <span className="flex items-center text-amber-500"><div className="w-2 h-2 rounded-full bg-amber-400 mr-1.5"></div> Geliştirilmeli</span>
    <span className="flex items-center text-emerald-600"><div className="w-2 h-2 rounded-full bg-emerald-500 mr-1.5"></div> Güçlü Alan</span>
    <span className="flex items-center text-slate-500"><div className="w-2 h-2 rounded-full bg-slate-400 mr-1.5"></div> Yetersiz Veri</span>
</div>
                    </div>
                   <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
                        <table className="w-full text-left text-sm">
                            <thead className="bg-slate-50 text-slate-500 font-bold uppercase text-[10px] tracking-wider border-b border-slate-100">
                                <tr className="print:text-[8px]">
                                    <th className="p-4 print:p-2 w-32">Ders</th>
                                    <th className="p-4 print:p-2">Çalışılan Konu</th>
                                    <th className="p-4 print:p-2 text-center">Soru</th>
                                    <th className="p-4 print:p-2 text-center">Doğru</th>
                                    <th className="p-4 print:p-2 text-center">Yanlış</th>
                                    <th className="p-4 print:p-2 text-center">Başarı %</th>
                                    <th className="p-4 print:p-2 text-center">Öncelik Durumu</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                                {konuDetaylari.map((k, idx) => {
                                    const basari = k.toplam > 0 ? Math.round(((k.dogru || (k.toplam - k.yanlis)) / k.toplam) * 100) : 0;
                                    return (
                                    <tr key={idx} className={`hover:bg-slate-50 transition-colors border-b border-slate-50 print:border-slate-200 ${k.triyaj === 'kirmizi' ? 'bg-red-50/40 print:bg-red-50' : ''}`}>
                                        <td className="p-4 print:p-2 font-black text-slate-700 text-xs print:text-[10px]">{k.ders}</td>
                                        <td className="p-4 print:p-2 font-medium text-slate-600 text-xs print:text-[9px]">{k.konu}</td>
                                        <td className="p-4 print:p-2 text-center font-bold text-slate-800">{k.toplam}</td>
                                        <td className="p-4 print:p-2 text-center font-bold text-emerald-600">{k.dogru || (k.toplam - k.yanlis)}</td>
                                        <td className="p-4 print:p-2 text-center font-bold text-red-500">{k.yanlis}</td>
                                        <td className="p-4 print:p-2 text-center">
                                            <span className={`font-black ${basari < 50 ? 'text-red-600' : basari < 75 ? 'text-amber-500' : 'text-emerald-500'}`}>
                                                %{basari}
                                            </span>
                                        </td>
                                        <td className="p-4 print:p-2 flex justify-center">
                                            {k.triyaj === 'kirmizi' && <span className="px-3 py-1 print:py-0.5 rounded-full font-black text-[10px] print:text-[8px] uppercase bg-red-100 text-red-700 border border-red-200 flex items-center shadow-sm"><Activity className="h-3 w-3 print:h-2 print:w-2 mr-1.5 print:mr-1 animate-pulse"/> Öncelikli Destek</span>}
                                            {k.triyaj === 'sari' && <span className="px-3 py-1 print:py-0.5 rounded-full font-black text-[10px] print:text-[8px] uppercase bg-amber-100 text-amber-700 border border-amber-200 flex items-center"><Target className="h-3 w-3 print:h-2 print:w-2 mr-1.5 print:mr-1"/> {k.triyajText}</span>}
                                            {k.triyaj === 'yesil' && <span className="px-3 py-1 print:py-0.5 rounded-full font-black text-[10px] print:text-[8px] uppercase bg-emerald-100 text-emerald-700 border border-emerald-200 flex items-center"><CheckCircle className="h-3 w-3 print:h-2 print:w-2 mr-1.5 print:mr-1"/> {k.triyajText}</span>}
                                            {k.triyaj === 'gri' && <span className="px-3 py-1 print:py-0.5 rounded-full font-black text-[10px] print:text-[8px] uppercase bg-slate-100 text-slate-500 border border-slate-200">{k.triyajText}</span>}
                                        </td>
                                    </tr>
                                )})}
                              {konuDetaylari.length === 0 && (
                                    <tr><td colSpan="7" className="p-8 text-center text-slate-400">Detaylı konu verisi yok.</td></tr>
                                )}
                                                        </tbody>
                        </table>
                    </div>
                </div>

               </div>


               <div
                 className={`${
                   soruEforTab === 'haftalik' ? 'block' : 'hidden'
                 } print:block`}
               >

                {/* 📚 DETAYLI HAFTALIK SORU ÇÖZÜM ARŞİVİ */}
{aktifHaftaVerisi && (
  <div className="mt-8 bg-white rounded-2xl border border-slate-200 shadow-sm animate-in slide-in-from-bottom-4 duration-500 print:mt-12 print:border-none print:shadow-none break-inside-avoid">
    
    {/* BAŞLIK + HAFTA SEÇİCİ */}
    <div className="bg-slate-50 p-4 border-b border-slate-200 print:bg-slate-100 print:border-b-2 print:border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
      
      <div>
        <h3 className="font-bold text-slate-700 uppercase tracking-widest text-xs flex items-center">
          <BookOpen className="h-4 w-4 mr-2 text-indigo-500"/>
          Detaylı Haftalık Soru Çözüm Arşivi
        </h3>

        <p className="text-[10px] text-slate-400 font-medium mt-1 ml-6 no-print">
          Öğrencinin haftalık çalışma performansını ve geçmiş gelişimini inceleyin.
        </p>
      </div>

      {/* HAFTA SEÇİCİ */}
      <div className="flex items-center gap-3 no-print">
        <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
          Seçili Hafta:
        </span>

        <div className="relative">
          <select
            value={gosterilecekHafta}
            onChange={(e) => setSeciliHafta(e.target.value)}
            className="appearance-none min-w-[180px] px-4 py-2.5 pr-10 bg-white border border-slate-200 rounded-xl text-xs font-black text-indigo-700 focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 cursor-pointer shadow-sm"
          >
            {mevcutHaftalar.map(hafta => (
              <option key={hafta} value={hafta}>
                {hafta} Haftası
              </option>
            ))}
          </select>

          <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-indigo-400 pointer-events-none"/>
        </div>
      </div>

      {/* PDF'DE SEÇİLİ HAFTA */}
      <div className="hidden print:block text-right">
        <p className="text-[9px] text-slate-400 uppercase font-bold tracking-widest">
          Rapor Haftası
        </p>
        <p className="text-xs font-black text-slate-700">
          {gosterilecekHafta}
        </p>
      </div>

    </div>

    {/* TABLO */}
    <div className="overflow-x-auto custom-scrollbar">
      <table className="w-full text-left text-sm whitespace-nowrap">

        <thead className="bg-white text-slate-400 font-bold uppercase text-[10px] tracking-wider border-b border-slate-100">

          {/* ÜST BAŞLIK */}
          <tr>
            <th
              rowSpan={2}
              className="p-4 bg-slate-50/50 align-middle"
            >
              Ders
            </th>

            <th
              colSpan={3}
              className="p-4 text-center border-l border-slate-200 bg-indigo-50/30 text-indigo-600"
            >
              Soru Performansı
            </th>

            <th
              rowSpan={2}
              className="p-4 text-center border-l border-slate-200 align-middle text-emerald-600"
            >
              Başarı
            </th>

            <th
              rowSpan={2}
              className="p-4 text-center border-l border-slate-200 align-middle"
            >
              Haftalık Durum
            </th>
          </tr>

          {/* ALT BAŞLIK */}
          <tr className="bg-slate-50 text-[9px] text-slate-500 border-b border-slate-200">
            <th className="p-2 text-center border-l border-slate-200">
              Soru
            </th>

            <th className="p-2 text-center text-emerald-600">
              Doğru
            </th>

            <th className="p-2 text-center text-red-500">
              Yanlış
            </th>
          </tr>

        </thead>

        <tbody className="divide-y divide-slate-100">

          {Object.entries(aktifHaftaVerisi.dersler)
            .sort((a, b) => b[1].toplam - a[1].toplam)
            .map(([dersAdi, veriler], idx) => {

              const basari =
                veriler.toplam > 0
                  ? Math.round((veriler.dogru / veriler.toplam) * 100)
                  : 0;

              let durumText = "Güçlü";
              let durumClass =
                "bg-emerald-100 text-emerald-700 border-emerald-200";

              if (basari < 50) {
                durumText = "Destek Gerekli";
                durumClass =
                  "bg-red-100 text-red-700 border-red-200";
              } else if (basari < 75) {
                durumText = "Gelişiyor";
                durumClass =
                  "bg-amber-100 text-amber-700 border-amber-200";
              }

              return (
                <tr
                  key={idx}
                  className="hover:bg-slate-50 transition-colors"
                >

                  {/* DERS */}
                  <td className="p-4 font-black text-slate-700 text-xs bg-slate-50/30">
                    {dersAdi}
                  </td>

                  {/* SORU */}
                  <td className="p-4 text-center border-l border-slate-200 font-black text-slate-700">
                    {veriler.toplam}
                  </td>

                  {/* DOĞRU */}
                  <td className="p-4 text-center font-bold text-emerald-600">
                    {veriler.dogru}
                  </td>

                  {/* YANLIŞ */}
                  <td className="p-4 text-center font-bold text-red-500">
                    {veriler.yanlis}
                  </td>

                  {/* BAŞARI */}
                  <td className="p-4 text-center border-l border-slate-200">
                    <span
                      className={`font-black text-base ${
                        basari < 50
                          ? "text-red-600"
                          : basari < 75
                          ? "text-amber-500"
                          : "text-emerald-600"
                      }`}
                    >
                      %{basari}
                    </span>
                  </td>

                  {/* DURUM */}
                  <td className="p-4 text-center border-l border-slate-200">
                    <span
                      className={`inline-flex px-3 py-1.5 rounded-full border text-[9px] font-black uppercase tracking-wide ${durumClass}`}
                    >
                      {durumText}
                    </span>
                  </td>

                </tr>
              );
            })}

          {/* HAFTALIK TOPLAM */}
          <tr className="bg-slate-800 text-white">

            <td className="p-4 font-black text-xs text-right uppercase tracking-widest">
              Haftalık Toplam
            </td>

            <td className="p-4 text-center border-l border-slate-700 font-black text-base">
              {aktifHaftaVerisi.toplam}
            </td>

            <td className="p-4 text-center font-black text-emerald-400 text-base">
              {aktifHaftaVerisi.dogru}
            </td>

            <td className="p-4 text-center font-black text-red-400 text-base">
              {aktifHaftaVerisi.yanlis}
            </td>

            <td className="p-4 text-center border-l border-slate-700 font-black text-blue-400 text-base">
              %
              {aktifHaftaVerisi.toplam > 0
                ? Math.round(
                    (aktifHaftaVerisi.dogru /
                      aktifHaftaVerisi.toplam) *
                      100
                  )
                : 0}
            </td>

            <td className="p-4 text-center border-l border-slate-700">
              <span className="text-[9px] font-black uppercase tracking-widest text-slate-300">
                Genel Hafta
              </span>
            </td>

          </tr>

        </tbody>
      </table>
    </div>
    </div>
)}

               </div>

                {/* 🚀 YENİ: PDF Çıktısı İçin Uzman Notu (Sadece Yazdırırken Görünür) */}
                {expertPrintNote && (
                    <div className="hidden print:block mt-8 border-t-4 border-slate-900 pt-6 break-inside-avoid">
                       <h3 className="text-lg font-black text-slate-900 mb-2">Psikolojik Danışman Değerlendirmesi</h3>
                       <p className="text-sm text-slate-700 leading-relaxed text-justify italic">"{expertPrintNote}"</p>
                       <div className="mt-12 flex justify-end">
                          <div className="text-center">
                             <p className="font-bold text-slate-800">{user?.fullName || "Psikolojik Danışman"}</p>
                             <p className="text-xs text-slate-500">PDR Servisi</p>
                          </div>
                       </div>
                    </div>
                )}
             </div>
           )}
        </div>
      ) : mainSection === 'tracking' && activeTab === 'deneme_analizi' ? (
  <div id="deneme-print-area" className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 min-h-[500px] print:p-0 print:border-none print:shadow-none">
           
           {/* 🚀 YENİ: PDF KURUMSAL BAŞLIK (Sadece Yazdırırken Görünür) */}
           <div className="hidden print:flex justify-between items-center border-b-4 border-slate-900 pb-4 mb-8">
              <div>
                  <h1 className="text-2xl font-black tracking-tight text-slate-900">{user?.schoolName || "REHBER360"}</h1>
                  <p className="text-[10px] uppercase font-bold tracking-widest text-slate-400">Psikolojik Danışmanlık ve Rehberlik Servisi</p>
              </div>
              <div className="text-right">
                  <h2 className="text-sm font-black text-slate-800">Deneme Trend ve Gelişim Raporu</h2>
                  <p className="text-[10px] text-slate-500 font-bold">Öğrenci: {benzersizOgrenciler.find(o => String(o.no) === String(selectedStudent))?.label || (demoModuAktif ? "Demo Öğrenci" : "")}</p>
              </div>
           </div>

           {/* 🚀 DÜZELTME: no-print kalkanını bu sarmalayıcıya da ekledik */}
           <div className="flex flex-col md:flex-row justify-between items-center mb-8 border-b pb-4 border-slate-100 no-print">
              <div>
                <h2 className="text-2xl font-black text-slate-800 flex items-center"><Target className="h-6 w-6 mr-2 text-emerald-500"/> Deneme Trend Analizi</h2>
                <p className="text-slate-500 text-sm">Öğrencinin zaman içindeki net artış/azalış grafiği.</p>
              </div>

            <div className="mt-4 md:mt-0 flex flex-col md:flex-row gap-3 w-full md:w-auto">
                <button 
                  onClick={() => setDemoModuAktif(!demoModuAktif)}
                  className={`px-4 py-3 rounded-xl font-bold text-xs transition border-2 flex items-center shadow-sm ${demoModuAktif ? 'bg-amber-100 border-amber-400 text-amber-700' : 'bg-slate-50 border-slate-200 text-slate-500 hover:bg-slate-100'}`}
                >
                  {demoModuAktif ? '🧪 Demo Aktif' : 'Test Verisi Yükle'}
                </button>
                <div className="w-full md:w-72 relative">
                  <select 
                    value={selectedStudent} 
                    onChange={(e) => setSelectedStudent(e.target.value)}
                    className="w-full appearance-none bg-slate-50 border-2 border-slate-200 text-slate-700 font-bold py-3 px-4 pr-10 rounded-xl focus:outline-none focus:border-emerald-500 cursor-pointer"
                  >
                    <option value="">Analiz İçin Öğrenci Seçin</option>
                    {koclukMerkeziVerileri.map(ogr => (
                      <option key={ogr.no} value={ogr.no}>{ogr.label}</option>
                    ))}
                  </select>
                  <ChevronDown className="absolute right-4 top-1/2 transform -translate-y-1/2 text-slate-400 pointer-events-none" />
                </div>
              </div>
           </div>

           {(!selectedStudent && !demoModuAktif) ? (
             <div className="flex flex-col items-center justify-center h-64 text-slate-400">
               <Target className="h-16 w-16 mb-4 opacity-20"/>
               <p className="font-bold text-lg">Öğrenci Bekleniyor</p>
               <p className="text-sm">Yukarıdaki menüden veri girişi yapmış bir öğrenci seçmeli veya Demo Modu'nu açmalısınız.</p>
             </div>
           ) : (seciliOgrenciDenemeleri.length === 0 && !demoModuAktif) ? (
             <div className="flex flex-col items-center justify-center h-64 text-slate-400">
               <BookOpen className="h-16 w-16 mb-4 opacity-20"/>
               <p className="font-bold text-lg">Deneme Verisi Bulunamadı</p>
               <p className="text-sm">Bu öğrenci henüz bir deneme sonucu yüklememiş.</p>
             </div>
          ) : (
             <div className="animate-in fade-in zoom-in-95 duration-300">
                
               {/* 🚀 YENİ: MOMENTUM VE PROJEKSİYON EKRANI (TYT + AYT ÇİFT KART) */}
                <div className="space-y-4 mb-8 print:space-y-6 break-inside-avoid">
                  {/* TYT KARTI */}
                  <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-6 print:gap-4 break-inside-avoid">
                      <div className="col-span-1 md:col-span-2 bg-gradient-to-br from-slate-900 to-slate-800 p-6 rounded-3xl shadow-lg border border-slate-700 text-white flex flex-col justify-center">
                          <div className="flex items-center gap-3 mb-3">
                              <div className={`p-2.5 rounded-full ${tytTrend === 'artis' ? 'bg-emerald-500/20 text-emerald-400' : tytTrend === 'dusus' ? 'bg-red-500/20 text-red-400' : 'bg-blue-500/20 text-blue-400'}`}>
                                  <Activity className="h-5 w-5" />
                              </div>
                              <div>
                                  <h3 className="font-black text-base uppercase tracking-widest text-emerald-400">TYT Gidişat Analizi</h3>
                                  <p className="text-slate-400 text-[10px] font-bold">Son TYT Denemeleri Baz Alınmıştır</p>
                              </div>
                          </div>
                          <p className="text-xs font-medium leading-relaxed text-slate-300">
                              {tytSonucMetni}
                          </p>
                      </div>

                      <div className="col-span-1 bg-white p-5 rounded-3xl shadow-sm border border-slate-200 flex flex-col items-center justify-center text-center relative overflow-hidden">
                          <h4 className="font-bold text-slate-400 uppercase text-[10px] tracking-widest mb-1 relative z-10">TYT Projeksiyon (5 Deneme Sonra)</h4>
                          <div className="relative z-10 flex items-baseline gap-1">
                              <span className="text-4xl font-black text-emerald-600">{tytProjeksiyon > 0 ? tytProjeksiyon.toFixed(1) : '?'}</span>
                              <span className="text-xs font-bold text-slate-500"> Net</span>
                          </div>
                          <p className="text-[10px] font-bold mt-2 px-3 py-0.5 bg-slate-100 text-slate-500 rounded-full relative z-10">
                              Mevcut TYT: <span className="text-slate-800">{sonTytNet > 0 ? sonTytNet.toFixed(1) : '?'}</span>
                          </p>
                      </div>
                  </div>

                  {/* AYT KARTI */}
                  {(sonAytNet > 0 || demoModuAktif || seciliOgrenciDenemeleri.some(d => d['AYT Net'] !== null)) && (
                    <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-6 print:gap-4 break-inside-avoid animate-in fade-in duration-300">
                        <div className="col-span-1 md:col-span-2 bg-gradient-to-br from-slate-900 to-indigo-950 p-6 rounded-3xl shadow-lg border border-indigo-900/50 text-white flex flex-col justify-center">
                            <div className="flex items-center gap-3 mb-3">
                                <div className={`p-2.5 rounded-full ${aytTrend === 'artis' ? 'bg-blue-500/20 text-blue-400' : aytTrend === 'dusus' ? 'bg-red-500/20 text-red-400' : 'bg-purple-500/20 text-purple-400'}`}>
                                    <Activity className="h-5 w-5" />
                                </div>
                                <div>
                                    <h3 className="font-black text-base uppercase tracking-widest text-blue-400">AYT Gidişat Analizi</h3>
                                    <p className="text-slate-400 text-[10px] font-bold">Son AYT Denemeleri Baz Alınmıştır</p>
                                </div>
                            </div>
                            <p className="text-xs font-medium leading-relaxed text-slate-300">
                                {aytSonucMetni}
                            </p>
                        </div>

                        <div className="col-span-1 bg-white p-5 rounded-3xl shadow-sm border border-slate-200 flex flex-col items-center justify-center text-center relative overflow-hidden">
                            <h4 className="font-bold text-slate-400 uppercase text-[10px] tracking-widest mb-1 relative z-10">AYT Projeksiyon (5 Deneme Sonra)</h4>
                            <div className="relative z-10 flex items-baseline gap-1">
                                <span className="text-4xl font-black text-blue-600">{aytProjeksiyon > 0 ? aytProjeksiyon.toFixed(1) : '?'}</span>
                                <span className="text-xs font-bold text-slate-500"> Net</span>
                            </div>
                            <p className="text-[10px] font-bold mt-2 px-3 py-0.5 bg-slate-100 text-slate-500 rounded-full relative z-10">
                                Mevcut AYT: <span className="text-slate-800">{sonAytNet > 0 ? sonAytNet.toFixed(1) : '?'}</span>
                            </p>
                        </div>
                    </div>
                  )}

                  {/* LGS KARTI */}
                  {(sonLgsNet > 0 || (demoModuAktif && seciliHedefProfil?.includes('LGS'))) && (
                    <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-6 print:gap-4 break-inside-avoid animate-in fade-in duration-300">
                        <div className="col-span-1 md:col-span-2 bg-gradient-to-br from-amber-900 to-orange-950 p-6 rounded-3xl shadow-lg border border-orange-900/50 text-white flex flex-col justify-center">
                            <div className="flex items-center gap-3 mb-3">
                                <div className={`p-2.5 rounded-full ${lgsTrend === 'artis' ? 'bg-amber-500/20 text-amber-400' : lgsTrend === 'dusus' ? 'bg-red-500/20 text-red-400' : 'bg-orange-500/20 text-orange-400'}`}>
                                    <Activity className="h-5 w-5" />
                                </div>
                                <div>
                                    <h3 className="font-black text-base uppercase tracking-widest text-amber-400">LGS Gidişat Analizi</h3>
                                    <p className="text-orange-200 text-[10px] font-bold">Son LGS Denemeleri Baz Alınmıştır</p>
                                </div>
                            </div>
                            <p className="text-xs font-medium leading-relaxed text-orange-100">
                                {lgsSonucMetni}
                            </p>
                        </div>

                        <div className="col-span-1 bg-white p-5 rounded-3xl shadow-sm border border-orange-200 flex flex-col items-center justify-center text-center relative overflow-hidden">
                            <h4 className="font-bold text-orange-400 uppercase text-[10px] tracking-widest mb-1 relative z-10">LGS Projeksiyon (5 Deneme Sonra)</h4>
                            <div className="relative z-10 flex items-baseline gap-1">
                                <span className="text-4xl font-black text-amber-600">{lgsProjeksiyon > 0 ? lgsProjeksiyon.toFixed(1) : '?'}</span>
                                <span className="text-xs font-bold text-slate-500"> Net</span>
                            </div>
                            <p className="text-[10px] font-bold mt-2 px-3 py-0.5 bg-orange-50 text-orange-700 rounded-full relative z-10 border border-orange-100">
                                Mevcut LGS: <span className="text-slate-800">{sonLgsNet > 0 ? sonLgsNet.toFixed(1) : '?'}</span>
                            </p>
                        </div>
                    </div>
                  )}
                </div>

                <div className="h-[400px] w-full bg-slate-50 p-6 rounded-2xl border border-slate-100 shadow-inner flex flex-col break-inside-avoid print:h-[280px] print:bg-white print:border-none print:shadow-none print:p-0 print:mt-8 overflow-hidden">
                    <h3 className="font-bold text-slate-600 mb-4 text-center text-sm uppercase tracking-wider shrink-0">Net Gelişim Grafiği</h3>
                    <div className="w-full flex-1 min-h-0 relative">
                        <ResponsiveContainer width="99%" height="100%">
                            <AreaChart data={seciliOgrenciDenemeleri} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
                                <defs>
                                  <linearGradient id="colorTYT" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor="#10b981" stopOpacity={0.4}/>
                                    <stop offset="95%" stopColor="#10b981" stopOpacity={0.0}/>
                                  </linearGradient>
                                  <linearGradient id="colorAYT" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.4}/>
                                    <stop offset="95%" stopColor="#3b82f6" stopOpacity={0.0}/>
                                  </linearGradient>
                                  <linearGradient id="colorYDT" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor="#8b5cf6" stopOpacity={0.4}/>
                                    <stop offset="95%" stopColor="#8b5cf6" stopOpacity={0.0}/>
                                  </linearGradient>
                                  <linearGradient id="colorLGS" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.4}/>
                                    <stop offset="95%" stopColor="#f59e0b" stopOpacity={0.0}/>
                                  </linearGradient>
                                </defs>
                                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0"/>
                                <XAxis dataKey="name" tick={{fontSize: 11, fontWeight: 'bold', fill: '#64748b'}} axisLine={false} tickLine={false}/>
                                <YAxis tick={{fontSize: 11, fill: '#94a3b8'}} axisLine={false} tickLine={false}/>
                                <Tooltip contentStyle={{ borderRadius: '12px', fontSize: '13px', fontWeight: 'bold', backgroundColor: 'rgba(255, 255, 255, 0.95)' }}/>
                                <Legend wrapperStyle={{fontSize: '12px', fontWeight: 'bold', paddingTop: '20px'}}/>
                                <Area type="monotone" isAnimationActive={false} connectNulls={true} dataKey="TYT Net" stroke="#10b981" strokeWidth={4} fillOpacity={1} fill="url(#colorTYT)" dot={{ r: 4, strokeWidth: 2, fill: '#fff' }} activeDot={{ r: 8 }} />
                                <Area type="monotone" isAnimationActive={false} connectNulls={true} dataKey="AYT Net" stroke="#3b82f6" strokeWidth={4} fillOpacity={1} fill="url(#colorAYT)" dot={{ r: 4, strokeWidth: 2, fill: '#fff' }} activeDot={{ r: 8 }} />
                                <Area type="monotone" isAnimationActive={false} connectNulls={true} dataKey="YDT Net" stroke="#8b5cf6" strokeWidth={4} fillOpacity={1} fill="url(#colorYDT)" dot={{ r: 4, strokeWidth: 2, fill: '#fff' }} activeDot={{ r: 8 }} />
                                <Area type="monotone" isAnimationActive={false} connectNulls={true} dataKey="LGS Net" stroke="#f59e0b" strokeWidth={4} fillOpacity={1} fill="url(#colorLGS)" dot={{ r: 4, strokeWidth: 2, fill: '#fff' }} activeDot={{ r: 8 }} />
                            </AreaChart>
                        </ResponsiveContainer>
                    </div>
                </div>

              {/* 🚀 YENİ: TAM DETAYLI YKS KARNE TABLOSU */}
                <div className="mt-8 bg-white rounded-2xl border border-slate-200 shadow-sm animate-in slide-in-from-bottom-4 duration-500 print:mt-12 print:border-none print:shadow-none break-inside-avoid">
                    <div className="bg-slate-50 p-4 border-b border-slate-200 print:bg-slate-100 print:border-b-2 print:border-slate-800">
                        <h3 className="font-bold text-slate-700 uppercase tracking-widest text-xs flex items-center">
                            <BookOpen className="h-4 w-4 mr-2 text-emerald-500"/> Detaylı Deneme Karne Arşivi
                        </h3>
                    </div>
                    <div className="overflow-x-auto custom-scrollbar">
                        <table className="w-full text-left text-sm whitespace-nowrap">
                            <thead className="bg-white text-slate-400 font-bold uppercase text-[10px] tracking-wider border-b border-slate-100">
                                <tr>
                                    <th className="p-4">Tarih</th>
                                    <th className="p-4">Yayın / Deneme Adı</th>
                                    <th className="p-4 text-center">Tür</th>
                                    <th className="p-4 text-center border-l border-slate-200 bg-slate-50/50" colSpan="4">TYT Netleri</th>
                                    <th className="p-4 text-center border-l border-slate-200 bg-blue-50/30 text-blue-700" colSpan="11">AYT Netleri (Branş Kırılımları)</th>
                                    <th className="p-4 text-center border-l border-slate-200 bg-purple-50/30 text-purple-700">YDT</th>
                                    <th className="p-4 text-center border-l border-slate-200 text-emerald-600">Toplam</th>
                                </tr>
                                <tr className="bg-slate-50 text-[9px] text-slate-500 border-b border-slate-200">
                                    <th className="p-2"></th>
                                    <th className="p-2"></th>
                                    <th className="p-2"></th>
                                    {/* TYT */}
                                    <th className="p-2 text-center border-l border-slate-200">Türkçe</th>
                                    <th className="p-2 text-center">Matematik</th>
                                    <th className="p-2 text-center">Sosyal</th>
                                    <th className="p-2 text-center">Fen</th>
                                    {/* AYT Mat & Fen */}
                                    <th className="p-2 text-center border-l border-slate-200 bg-blue-50/50 font-black text-blue-900">Mat</th>
                                    <th className="p-2 text-center bg-blue-50/50">Fizik</th>
                                    <th className="p-2 text-center bg-blue-50/50">Kimya</th>
                                    <th className="p-2 text-center bg-blue-50/50">Biyoloji</th>
                                    {/* AYT Sos-1 */}
                                    <th className="p-2 text-center border-l border-slate-200">Edebiyat</th>
                                    <th className="p-2 text-center">Tarih-1</th>
                                    <th className="p-2 text-center">Coğrafya-1</th>
                                    {/* AYT Sos-2 */}
                                    <th className="p-2 text-center border-l border-slate-200">Tarih-2</th>
                                    <th className="p-2 text-center">Coğrafya-2</th>
                                    <th className="p-2 text-center">Felsefe Grb.</th>
                                    <th className="p-2 text-center">Din K.</th>
                                    {/* YDT */}
                                    <th className="p-2 text-center border-l border-slate-200">Dil</th>
                                    <th className="p-2 border-l border-slate-200"></th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                                {seciliOgrenciDenemeleri.map((d, idx) => (
                                    <tr key={idx} className="hover:bg-slate-50 transition-colors">
                                        <td className="p-4 font-medium text-slate-500">{d.tarih}</td>
                                        <td className="p-4 font-bold text-slate-700">{d.yayin}</td>
                                        <td className="p-4 text-center">
                                            <span className={`px-2 py-1 rounded font-black text-[10px] ${d.turu === 'TYT' ? 'bg-emerald-100 text-emerald-700' : d.turu === 'AYT' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'}`}>
                                                {d.turu}
                                            </span>
                                        </td>
                                        {/* TYT Netleri */}
                                        <td className="p-4 text-center border-l border-slate-200 font-medium text-slate-600">{d.tytTurkce}</td>
                                        <td className="p-4 text-center font-medium text-slate-600">{d.tytMat}</td>
                                        <td className="p-4 text-center font-medium text-slate-600">{d.tytSos}</td>
                                        <td className="p-4 text-center font-medium text-slate-600">{d.tytFen}</td>
                                        {/* AYT Sayısal */}
                                        <td className="p-4 text-center border-l border-slate-200 font-bold text-slate-700 bg-slate-50/30">{d.aytMat}</td>
                                        <td className="p-4 text-center font-medium text-slate-600 bg-slate-50/30">{d.aytFizik}</td>
                                        <td className="p-4 text-center font-medium text-slate-600 bg-slate-50/30">{d.aytKimya}</td>
                                        <td className="p-4 text-center font-medium text-slate-600 bg-slate-50/30">{d.aytBiyo}</td>
                                        {/* AYT Sos-1 */}
                                        <td className="p-4 text-center border-l border-slate-200 font-medium text-slate-600">{d.aytEdb}</td>
                                        <td className="p-4 text-center font-medium text-slate-600">{d.aytTar1}</td>
                                        <td className="p-4 text-center font-medium text-slate-600">{d.aytCog1}</td>
                                        {/* AYT Sos-2 */}
                                        <td className="p-4 text-center border-l border-slate-200 font-medium text-slate-600">{d.aytTar2}</td>
                                        <td className="p-4 text-center font-medium text-slate-600">{d.aytCog2}</td>
                                        <td className="p-4 text-center font-medium text-slate-600">{d.aytFel}</td>
                                        <td className="p-4 text-center font-medium text-slate-600">{d.aytDin}</td>
                                        {/* YDT & Toplam */}
                                        <td className="p-4 text-center border-l border-slate-200 font-medium text-slate-600">{d.ydtDil}</td>
                                        <td className="p-4 text-center border-l border-slate-200 font-black text-emerald-600 text-base">{d.toplamNet}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* 🚀 YENİ: PDF Çıktısı İçin Uzman Notu (Sadece Yazdırırken Görünür) */}
                {expertPrintNote && (
                    <div className="hidden print:block mt-8 border-t-4 border-slate-900 pt-6 break-inside-avoid">
                       <h3 className="text-lg font-black text-slate-900 mb-2">Psikolojik Danışman Değerlendirmesi</h3>
                       <p className="text-sm text-slate-700 leading-relaxed text-justify italic">"{expertPrintNote}"</p>
                       <div className="mt-12 flex justify-end">
                          <div className="text-center">
                             <p className="font-bold text-slate-800">{user?.fullName || "Psikolojik Danışman"}</p>
                             <p className="text-xs text-slate-500">PDR Servisi</p>
                          </div>
                       </div>
                    </div>
                )}
             </div>
           )}
        </div>
      ) : null}

      {isAiModalOpen && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-3xl w-full max-w-4xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh] animate-in zoom-in-95">
            
            <div className="bg-slate-900 p-6 flex justify-between items-center shrink-0">
              <div>
                <h3 className="text-xl font-black text-white flex items-center">
                  <Brain className="h-6 w-6 mr-3 text-indigo-400"/> Yapay Zeka Program Oluşturucu
                </h3>
                <p className="text-slate-400 text-xs mt-1 font-medium">
  Öğrencinin özelliklerini belirleyin; çalışma programını Rehber360 oluştursun.
</p>
              </div>
              <button onClick={() => setIsAiModalOpen(false)} className="text-slate-400 hover:text-white transition"><X className="h-6 w-6"/></button>
            </div>

            <div className="p-8 overflow-y-auto custom-scrollbar space-y-8 flex-1 bg-slate-50 text-sm">
              
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 border-b border-slate-200 pb-8">
                <div>
                  <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Hedef Süre</label>
                  <select value={aiParams.hafta} onChange={e => setAiParams({...aiParams, hafta: Number(e.target.value)})} className="w-full p-3 bg-white border border-slate-200 rounded-xl font-black text-slate-800 outline-none focus:border-indigo-500">
                    {HAFTA_SECENEKLERI.map(h => <option key={h} value={h}>{h} Hafta</option>)}
                  </select>
                </div>
               <div>
                  <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Sınıf Düzeyi</label>
                  <select value={aiParams.sinif} onChange={e => setAiParams({...aiParams, sinif: e.target.value})} className="w-full p-3 bg-white border border-slate-200 rounded-xl font-black text-slate-800 outline-none focus:border-indigo-500">
                    {SINIF_SECENEKLERI.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                {/* 🚀 YENİ: Öğrenci Seviyesi (Başlangıç/Orta/İleri) */}
                <div>
                  <label className="block text-xs font-bold text-amber-500 uppercase mb-2">Öğrenci Seviyesi</label>
                  <select value={aiParams.seviye} onChange={e => setAiParams({...aiParams, seviye: e.target.value})} className="w-full p-3 bg-amber-50 border border-amber-200 rounded-xl font-black text-amber-800 outline-none focus:border-amber-500">
                    <option value="Başlangıç">Başlangıç (Temel)</option>
                    <option value="Orta">Orta Düzey</option>
                    <option value="İleri">İleri (Derece)</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-bold text-indigo-500 uppercase mb-2">Sınav Türü</label>
                  <select value={aiParams.sinav} onChange={e => setAiParams({...aiParams, sinav: e.target.value})} className="w-full p-3 bg-indigo-50 border border-indigo-200 rounded-xl font-black text-indigo-800 outline-none focus:border-indigo-500">
                    {SINAV_SECENEKLERI.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Öğrenci Alanı</label>
                  <select value={aiParams.alan} onChange={e => setAiParams({...aiParams, alan: e.target.value})} className="w-full p-3 bg-white border border-slate-200 rounded-xl font-black text-slate-800 outline-none focus:border-indigo-500">
                    {ALAN_SECENEKLERI.map(a => <option key={a} value={a}>{a}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Günlük Görev</label>
                  <select value={aiParams.gorevSayisi} onChange={e => setAiParams({...aiParams, gorevSayisi: Number(e.target.value)})} className="w-full p-3 bg-white border border-slate-200 rounded-xl font-black text-slate-800 outline-none focus:border-indigo-500">
                    {GOREV_SECENEKLERI.map(g => <option key={g} value={g}>Maks {g} Blok</option>)}
                  </select>
                </div>
                {/* 🚀 YENİ: AI Planı Soru Hedefi Girdisi */}
                <div>
                  <label className="block text-xs font-bold text-emerald-500 uppercase mb-2">Hedef Soru</label>
                  <input type="number" placeholder="Örn: 1200" value={aiParams.hedefSoru} onChange={e => setAiParams({...aiParams, hedefSoru: e.target.value})} className="w-full p-3 bg-emerald-50 border border-emerald-200 rounded-xl font-black text-emerald-800 outline-none focus:border-emerald-500" />
                </div>
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">Günlük Değişmez Rutin Görevi</label>
                <select value={aiParams.rutin} onChange={e => setAiParams({...aiParams, rutin: e.target.value})} className="w-full p-3 bg-white border border-slate-200 rounded-xl font-bold text-slate-700 outline-none focus:border-indigo-500">
                  {RUTIN_SECENEKLERI.map(r => <option key={r} value={r}>{r}</option>)}
                </select>
                {aiParams.rutin.includes("Manuel") && (
                  <input type="text" placeholder="Örn: 10 Prg + 5 Geo + 15 Problemler..." value={aiParams.manuelRutin} onChange={e => setAiParams({...aiParams, manuelRutin: e.target.value})} className="w-full p-3 bg-white border border-slate-200 rounded-xl font-medium text-slate-700 outline-none focus:border-indigo-500 mt-2" />
                )}
              </div>

              <div className="grid grid-cols-2 gap-4 bg-indigo-50 border border-indigo-100 p-4 rounded-2xl">
                <div>
                  <label className="block text-xs font-black text-indigo-800 uppercase mb-2">Mola Günü (Opsiyonel)</label>
                  <select value={aiParams.molaGunu} onChange={e => setAiParams({...aiParams, molaGunu: e.target.value})} className="w-full p-3 bg-white border border-indigo-200 rounded-xl font-bold text-slate-700 outline-none focus:border-indigo-500">
                    <option value="">Belirtilmedi (Önermiyorum)</option>
                    {GUNLER.map(g => (
                      <option key={`mola-${g}`} value={g} disabled={aiParams.zirveGunu === g}>{g} {aiParams.zirveGunu === g ? '(Zirve Seçildi)' : ''}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-black text-purple-800 uppercase mb-2">Zirve Günü (Opsiyonel)</label>
                  <select value={aiParams.zirveGunu} onChange={e => setAiParams({...aiParams, zirveGunu: e.target.value})} className="w-full p-3 bg-white border border-purple-200 rounded-xl font-bold text-slate-700 outline-none focus:border-purple-500">
                    <option value="">Belirtilmedi</option>
                    {GUNLER.map(g => (
                      <option key={`zirve-${g}`} value={g} disabled={aiParams.molaGunu === g}>{g} {aiParams.molaGunu === g ? '(Mola Seçildi)' : ''}</option>
                    ))}
                  </select>
                </div>
              </div>
              <p className="text-[10px] text-slate-400 italic text-justify">
                * Yapay zeka motoru, yukarıda seçtiğiniz parametrelere dayanarak ve PDR mesleki etiğine uygun olarak öğrencinin bilişsel kapasitesini aşmayacak dengeli bir plan üretecektir. Üretilen planı indirmeden önce gözden geçirebileceksiniz.
              </p>

            </div>

            <div className="p-6 bg-white border-t border-slate-100 flex justify-end gap-3 shrink-0">
               <button onClick={() => setIsAiModalOpen(false)} className="px-6 py-3 bg-slate-100 hover:bg-slate-200 text-slate-600 rounded-xl font-bold text-sm transition">
                 İptal Et
               </button>
               <button 
                 onClick={handleGenerateMacroPlan} 
                 disabled={isGenerating}
                 className={`px-8 py-3 rounded-xl font-black text-sm transition flex items-center shadow-lg ${isGenerating ? 'bg-indigo-400 text-white cursor-not-allowed shadow-none' : 'bg-indigo-600 hover:bg-indigo-700 text-white shadow-indigo-200'}`}
               >
                 {isGenerating ? (
  <><Activity className="h-4 w-4 mr-2 animate-spin"/> Program Hazırlanıyor...</>
) : (
  <><Brain className="h-4 w-4 mr-2"/> Programı Oluştur</>
)}
               </button>
            </div>
          </div>
        </div>
      )}

      {mainSection === 'program' && programMode === 'ai' && generatedPlanText && (
        <div className="bg-slate-950 p-8 rounded-3xl border border-slate-800 shadow-2xl mt-12 animate-in fade-in zoom-in-95 duration-500">
          
          <div className="flex flex-col md:flex-row justify-between items-center border-b border-slate-800 pb-6 mb-6 gap-4 no-print">
            <div>
              <h3 className="text-xl font-black text-white flex items-center">
                <Sparkles className="h-5 w-5 mr-2 text-indigo-400 animate-pulse"/> Yapay Zeka Programı Hazır
              </h3>
              <p className="text-slate-400 text-xs mt-1">Planı veritabanına kaydedebilir veya PDF çıktısı alabilirsiniz.</p>
            </div>
            
            <div className="flex flex-wrap items-center gap-3">
              <select 
                value={aiTargetNo} 
                onChange={(e) => setAiTargetNo(e.target.value)} 
                className="px-4 py-3 bg-slate-800 border-2 border-slate-700 text-white rounded-xl font-bold w-48 focus:border-indigo-500 focus:outline-none text-sm cursor-pointer"
              >
                <option value="" disabled>Öğrenci Seçin...</option>
                {benzersizOgrenciler.map(ogr => (
                  <option key={ogr.no} value={ogr.no}>{ogr.label}</option>
                ))}
              </select>
              <button 
                onClick={handleSaveAiPlan} 
                className="px-5 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-black text-xs transition shadow-lg shadow-indigo-900/50 flex items-center"
              >
                <Target className="h-4 w-4 mr-2"/> Öğrenciye Kaydet
              </button>
              
<div className="w-px h-8 bg-slate-700 mx-1 hidden md:block"></div>

              {/* ✏️ YENİ: Düzenleme Butonu */}
              <button 
                onClick={() => setIsEditingPlan(!isEditingPlan)} 
                className={`px-5 py-3 rounded-xl font-black text-xs transition flex items-center shadow-lg ${isEditingPlan ? 'bg-amber-500 hover:bg-amber-600 text-white shadow-amber-900/30' : 'bg-slate-700 hover:bg-slate-600 text-white shadow-slate-900/30'}`}
              >
                <Edit3 className="h-4 w-4 mr-2"/> {isEditingPlan ? "Düzenlemeyi Bitir" : "Planı Düzenle"}
              </button>

              <button 
                onClick={() => handlePrint('ai-macro-print-area')}
                className="px-5 py-3 bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white rounded-xl font-black text-xs transition shadow-lg shadow-emerald-900/30 flex items-center"
              >
                <CheckCircle className="h-4 w-4 mr-2"/> Kurumsal PDF
              </button>
            </div>
          </div>

          <div id="ai-macro-print-area" className="text-slate-100 print:bg-white print:text-black">
              <div className="hidden print:flex justify-between items-center border-b-4 border-slate-900 pb-4 mb-8">
                  <div>
                      <h1 className="text-2xl font-black tracking-tight text-slate-900">REHBER360</h1>
                      <p className="text-[10px] uppercase font-bold tracking-widest text-slate-400">Yapay Zeka Destekli PDR Servisi</p>
                  </div>
                  <div className="text-right">
                      <h2 className="text-sm font-black text-slate-800">Öğrenci Makro Gelişim Planı</h2>
                      <p className="text-[10px] text-slate-500 font-bold">{aiParams.sinif} - {aiParams.alan} / {aiParams.hafta} Haftalık Kamp</p>
                  </div>
              </div>

             <div className="mt-8">
               {/* ✏️ YENİ: Edit Modu Açıksa Metin Kutusunu Göster */}
               {isEditingPlan ? (
                 <div className="animate-in fade-in duration-300 no-print">
                   <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-xl mb-4">
                     <p className="text-amber-800 text-xs font-bold">⚠️ Düzenleme Modu Aktif</p>
                     <p className="text-amber-700 text-[11px] mt-1">Aşağıdaki metni değiştirerek programı güncelleyebilirsiniz. Değişiklikleriniz anında aşağıdaki tabloya yansıyacaktır. Lütfen '# ' (Hafta) ve '**' (Gün) gibi format işaretlerini silmemeye özen gösterin.</p>
                   </div>
                   <textarea
                     value={generatedPlanText}
                     onChange={(e) => setGeneratedPlanText(e.target.value)}
                     className="w-full h-[400px] p-4 bg-slate-800 text-emerald-400 font-mono text-xs rounded-xl border border-slate-700 focus:outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500 custom-scrollbar mb-8"
                   />
                 </div>
               ) : null}
               
             {/* Düzenleme modundayken tabloyu hafif şeffaf yapıp arkada canlı değişimi gösteriyoruz */}
               <div className={`transition-opacity duration-300 ${isEditingPlan ? "opacity-50 pointer-events-none" : ""}`}>
                 {formatPlanAsGrid(generatedPlanText)}
               </div>
             </div>

             <div className="hidden print:block border-t border-slate-200 mt-12 pt-4 text-center text-[10px] font-bold text-slate-400">
               * Bu plan Rehber360 AI motoru tarafından öğrencinin bilişsel kapasitesine uygun olarak üretilmiştir. PDR Servisi
             </div>
          </div>
        </div>
      )}

      {/* 🚀 YENİ: PDF KARNE İÇİN UZMAN DEĞERLENDİRME MODALI */}
      {pdfModal.isOpen && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-in fade-in duration-200 no-print">
           <div className="bg-white rounded-3xl p-6 md:p-8 w-full max-w-xl shadow-2xl animate-in zoom-in-95">
              <div className="flex justify-between items-center mb-6 border-b border-slate-100 pb-4">
                 <h3 className="text-xl font-black text-slate-800 flex items-center">
                   {pdfModal.type === 'efor' ? <Activity className="h-6 w-6 mr-3 text-emerald-500"/> : <Target className="h-6 w-6 mr-3 text-blue-500"/>}
                   Uzman Değerlendirmesi Ekle
                 </h3>
                 <button onClick={() => setPdfModal({ isOpen: false })} className="text-slate-400 hover:text-rose-500 transition-colors bg-slate-100 p-2 rounded-full"><X className="h-5 w-5"/></button>
              </div>
              
              <div className="bg-slate-50 border border-slate-200 p-4 rounded-xl mb-6 flex items-center">
                 <Users className="h-5 w-5 text-slate-400 mr-3"/>
                 <div>
                   <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-0.5">Karnesi Hazırlanacak Öğrenci</p>
                   <p className="text-sm font-black text-slate-700">{pdfModal.student?.label}</p>
                 </div>
              </div>

              <label className="block text-xs font-bold text-slate-500 mb-2 ml-1">Karnenin Altına Eklenecek PDR Uzman Notu (Opsiyonel):</label>
              <textarea 
                 value={pdfModal.expertNote}
                 onChange={e => setPdfModal({...pdfModal, expertNote: e.target.value})}
                 placeholder={pdfModal.type === 'efor' ? "Örn: Matematik soru eforu çok başarılı ancak Türkçe denemelerinde zaman yönetimi çalışılması gerekiyor..." : "Örn: Son 3 denemedeki net artış ivmesi harika. Bu istikrarla hedefe kolayca ulaşılabilir..."}
                 className="w-full h-32 p-4 bg-white border-2 border-slate-200 rounded-xl text-sm outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/20 resize-none mb-6 shadow-inner font-medium text-slate-700"
              />
              
              <div className="flex justify-end gap-3 pt-2">
                 <button onClick={() => setPdfModal({ isOpen: false })} className="px-6 py-3 bg-slate-100 text-slate-600 font-bold rounded-xl hover:bg-slate-200 transition">İptal</button>
                 <button onClick={() => {
                     setExpertPrintNote(pdfModal.expertNote);
                     setSelectedStudent(pdfModal.student.no);
                     setActiveTab(pdfModal.type === 'efor' ? 'ogrenci_rontgeni' : 'deneme_analizi');
                     setPdfModal({ isOpen: false });
                     // 🚀 GÜVENLİ YAZDIRMA: window.print() yerine sayfanın kendi motorunu çağırıyoruz
                     const printAreaId = pdfModal.type === 'efor' ? 'rontgen-print-area' : 'deneme-print-area';
                     setTimeout(() => handlePrint(printAreaId), 800);
                 }} className="px-6 py-3 bg-blue-600 text-white font-black rounded-xl hover:bg-blue-700 shadow-lg shadow-blue-600/30 flex items-center transition-transform hover:scale-105">
                     <Printer className="h-5 w-5 mr-2"/> PDF Oluştur & Yazdır
                 </button>
              </div>
           </div>
        </div>
      )}

    </div>
  ); 
};

export default CoachingPanel;